<template>
  <!-- animate__animated animate__fadeInLeft -->
  <div>
    <!-- RELATED INVITE (History Events) -->
    <b-modal
        modal-class="modal-primary news-hist-modal"
        :ref="`${instance}-modal-link-invite`"
        :title="$t('SEND_NEWS.Modal_Related_Invite_Title')"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        size="xl"
        centered
        no-close-on-backdrop
    >
      <div class="d-block">
        <list-flashes
            :ref="`${instance}-list-link-invite`"
            :isDisclosure="true"
            :disclosureType="form.disclosureType.value"
            :selectedData="form.eventScheduleRelatedNews.value"
            @select="onSelectLinkInvite"
        ></list-flashes>
      </div>
    </b-modal>

    <!-- LIST FLASHES -->
    <b-modal
        v-show="form.listFlashes.display"
        modal-class="modal-primary news-hist-modal"
        :ref="`${instance}-modal-hist-flashes`"
        :title="$t('SEND_NEWS.Modal_Flashes_Title')"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        size="xl"
        centered
        no-close-on-backdrop
    >
      <div class="d-block">
        <list-flashes
            :ref="`${instance}-list-flashes`"
            :origins="form.source.value"
            @select="onSelectFlashes"
        ></list-flashes>
      </div>
    </b-modal>

    <!-- HIGHLIGHT DATE EDITOR -->
    <b-modal
        v-show="form.highlight_date.display"
        modal-class="modal-primary modal-highlight-date"
        :ref="`${instance}-modal-highlight-date`"
        :title="$t('SEND_NEWS.Modal_Highlight_Date_Title')"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        centered
        no-close-on-backdrop
    >
      <div class="d-block">
        <send-news-select-duration
            :ref="`${instance}-send-news-select-duration`"
            @select-date="onSelectDuration"
        ></send-news-select-duration>
      </div>
    </b-modal>

    <!-- CONTENT EDITOR -->
    <b-modal
        modal-class="modal-primary modal-content-editor"
        :ref="`${instance}-modal-content-editor`"
        :title="$t('SEND_NEWS.Modal_Content_Editor_Title')"
        size="xl"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        centered
        no-close-on-backdrop
    >
      <div class="d-block">
        <send-news-editor
            v-if="form.body.display"
            :ref="`${instance}-send-news-editor-modal`"
            :displayContentEditor="displayContentEditorMaximized"
            :userHeaderDisplay="form.userHeader.display"
            :userHeaders="userHeaders"
            :currentBody="form.body.value"
            :isMaximize="true"
            :signatureDisplay="form.signatures.display"
            :contentFooter="contentFooter"
            :signatures="signatures"
            :isSendNews="true"
            @minimize="onMinimizeEditor"
            @getAcronyms="loadAcronymsByName"
            @openAcronymsModal="displayAcronymsModal"
        ></send-news-editor>
      </div>
    </b-modal>
    <!-- NEWS HIST MODAL (FLASHES) -->
    <!-- v-show="form.listFlashes.display" -->
    <!-- Schedule Modal -->
    <nw-schedule-modal
        :ref="`${instance}-modal-scheduled`"
        @submit="sendEventShedule"
    ></nw-schedule-modal>
    <!-- Acronyms Modal -->
    <b-modal
        modal-class="modal-primary"
        :ref="`${instance}-modal-acronyms`"
        :title="$t('SEND_NEWS.Modal_Acronyms_Title')"
        no-close-on-backdrop
    >
      <div class="d-block">
        <div v-if="acronyms.length === 0">
          {{ $t("SEND_NEWS.Modal_Acronyms_Notfound") }}
        </div>
        <b-list-group v-if="acronyms.length > 0">
          <b-list-group-item
              v-for="(item, index) in acronyms"
              :key="instance + index"
              class="cursor-pointer"
              @click="onSelectAcronyms(item)"
          >
            <small class="cursor-pointer">
              <div>
                <b-badge variant="primary">{{ item.name }}</b-badge>
              </div>
              <div>{{ item.text }}</div>
            </small>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-modal>
    <!-- Image Library Modal THUMB PODCAST -->
    <b-modal
        modal-class="modal-primary custom-image-library-modal"
        :ref="`${instance}-modal-image-library-thumb-podcast`"
        :title="$t('SEND_NEWS.Modal_Library_Thumb_Title')"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        size="xl"
        ok-only
        no-close-on-backdrop
        v-if="form.thumb.display"
    >
      <div class="d-block">
        <image-library-list
            :ref="`${instance}-image-library-list-thumb-podcast`"
            dataType="thumb"
            :sendNews="true"
            :tags="form.tags.value"
            :selectedItens="thumbPodcastLibraryData"
            :instance="instance"
            @submit-document="onSubmitThumbPodcastLibrary"
            @close="closeModalLibraryThumbPodcast"
        ></image-library-list>
      </div>
    </b-modal>
    <!-- Image Library Modal THUMB VIDEO -->
    <b-modal
        modal-class="modal-primary custom-image-library-modal"
        :ref="`${instance}-modal-image-library-thumb-video`"
        :title="$t('SEND_NEWS.Modal_Library_Thumb_Title')"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        size="xl"
        ok-only
        no-close-on-backdrop
        v-if="form.thumb.display"
    >
      <div class="d-block">
        <image-library-list
            :ref="`${instance}-image-library-list-thumb-video`"
            dataType="thumb"
            :sendNews="true"
            :tags="form.tags.value"
            :selectedItens="thumbVideoLibraryData"
            :instance="instance"
            @submit-document="onSubmitThumbVideoLibrary"
            @close="closeModalLibraryThumbVideo"
        ></image-library-list>
      </div>
    </b-modal>
    <!-- Image Library Modal THUMB -->
    <b-modal
        modal-class="modal-primary custom-image-library-modal"
        :ref="`${instance}-modal-image-library-thumb`"
        :title="$t('SEND_NEWS.Modal_Library_Thumb_Title')"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        size="xl"
        ok-only
        no-close-on-backdrop
        v-if="form.thumb.display"
    >
      <div class="d-block">
        <image-library-list
            :ref="`${instance}-image-library-list-thumb`"
            dataType="video"
            :sendNews="true"
            :tags="form.tags.value"
            :selectedItens="thumbLibraryData"
            :instance="instance"
            @submit-document="onSubmitThumbLibrary"
            @close="closeModalLibraryThumb"
        ></image-library-list>
      </div>
    </b-modal>
    <!-- Image Library Modal IMAGE -->
    <b-modal
        modal-class="modal-primary custom-image-library-modal"
        :ref="`${instance}-modal-image-library-image`"
        :title="$t('SEND_NEWS.Modal_Library_Image_Title')"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        size="xl"
        ok-only
        no-close-on-backdrop
        v-if="form.image.display"
    >
      <div class="d-block">
        <image-library-list
            :ref="`${instance}-image-library-list-image`"
            dataType="image"
            :sendNews="true"
            :tags="form.tags.value"
            :selectedItens="imageLibraryData"
            :instance="instance"
            @submit-document="onSubmitImageLibrary"
            @close="closeModalLibraryImage"
        ></image-library-list>
      </div>
    </b-modal>
    <!-- Image Library Modal DOCUMENT -->
    <b-modal
        modal-class="modal-primary custom-image-library-modal"
        :ref="`${instance}-modal-image-library-document`"
        :title="$t('SEND_NEWS.Modal_Library_Document_Title')"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        size="xl"
        ok-only
        no-close-on-backdrop
        v-if="form.document.display"
    >
      <div class="d-block">
        <image-library-list
            :ref="`${instance}-image-library-list-document`"
            dataType="document"
            :sendNews="true"
            :tags="form.tags.value"
            :selectedItens="documentLibraryData"
            :instance="instance"
            @submit-document="onSubmitDocumentsLibrary"
            @close="closeModalLibraryDocument"
        ></image-library-list>
      </div>
    </b-modal>
    <!-- Image Library Modal AUDIO -->
    <b-modal
        modal-class="modal-primary custom-image-library-modal"
        :ref="`${instance}-modal-image-library-audio`"
        :title="$t('SEND_NEWS.Modal_Library_Audio_Title')"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        size="xl"
        ok-only
        no-close-on-backdrop
        v-if="form.document.display"
    >
      <div class="d-block">
        <image-library-list
            :ref="`${instance}-image-library-list-audio`"
            dataType="audio"
            :sendNews="true"
            :tags="form.tags.value"
            :selectedItens="audioLibraryData"
            :instance="instance"
            @submit-document="onSubmitAudioLibrary"
            @close="closeModalAudioDocument"
        ></image-library-list>
      </div>
    </b-modal>
    <!-- Image Library Modal VIDEO -->
    <b-modal
        modal-class="modal-primary custom-image-library-modal"
        :ref="`${instance}-modal-image-library-video`"
        :title="$t('SEND_NEWS.Modal_Library_Video_Title')"
        :ok-title="$t('SEND_NEWS.Modal_Ok_Title')"
        size="xl"
        ok-only
        no-close-on-backdrop
        v-if="form.document.display"
    >
      <div class="d-block">
        <image-library-list
            :ref="`${instance}-image-library-list-video`"
            dataType="video"
            :sendNews="true"
            :tags="form.tags.value"
            :selectedItens="videoLibraryData"
            :instance="instance"
            @submit-document="onSubmitVideoLibrary"
            @close="closeModalVideoDocument"
        ></image-library-list>
      </div>
    </b-modal>
    <!-- Preview URL Modal -->
    <b-modal
        modal-class="modal-primary preview-url-modal"
        :ref="`${instance}-preview-url-modal`"
        :title="$t('SEND_NEWS.Modal_Preview_Url_Title')"
        no-close-on-backdrop
        v-if="form.youtube.display || form.soundcloud.display"
    >
      <div class="d-block">
        <iframe
            :src="previewURL"
            width="600"
            height="400"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
        ></iframe>
      </div>
    </b-modal>
    <!-- Google Maps Modal -->
    <!-- <b-modal
        modal-class="modal-primary google-maps-modal"
        :ref="`${instance}-google-maps-modal`"
        :title="$t('SEND_NEWS.Modal_Google_Maps_Title')"
        no-close-on-backdrop
        size="xl"
        centered
        v-if="form.eventScheduleLocation.display"
    >
      <div class="d-block">
        <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.4617105828866!2d-46.672817682556136!3d-23.587768799999992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce575876657c21%3A0xbd12fac23318984b!2sR.%20Prof.%20Filadelfo%20Azevedo%2C%20712%20-%20Moema%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2004508-011!5e0!3m2!1sen!2sbr!4v1671686163514!5m2!1sen!2sbr"
            width="100%"
            height="500px"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </b-modal> -->

    <news-action-button
        v-if="displayActionButtons"
        :instance="instance"
        :event_status="currentEventStatus"
        :isPublishedNews="statusBeforeEditing == eventStatusPublished"
        :isEditingNews="isEditingNews"
        :isSendNews="true"
        :disabled="displayOverlay"
        @action-publish="sendPublish"
        @action-store="sendStore"
        @action-schedule="openScheduleModal"
        @action-cancel-editing="confirmCancelEditing"
        @close="closeForm"
    ></news-action-button>

    <vue-perfect-scrollbar
        :ref="`${instance}-scrollbar`"
        :settings="perfectScrollbarSettings"
        class="scroll-send-news"
        :suppressScrollX="true"
    >
      <b-overlay class="custom-overlay" :show="displayOverlay" rounded="sm">
        <b-button
            variant="flat-primary"
            size="sm"
            class="btn-voltar"
            @click.prevent="closeForm"
        >
        </b-button>
        <!-- INICIO POSTTYPE -->
        <b-card no-body class="send-news-card-header">
          <b-card-body class="flex">
            <div class="buttons-post">
              <b-button
                  variant="outline-primary"
                  class="btn-template"
                  :class="{ 'template-selected': isNews }"
                  @click="onSelectTemplate('newsFields')"
                  v-if="canDisplayNewsTemplate"
              >
                <feather-icon icon="FileTextIcon" class="mr-50" />
                <span class="align-middle">{{ $t("TEMPLATE.News") }}</span>
              </b-button>

              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-template"
                  :class="{ 'template-selected': isFlashes }"
                  @click="onSelectTemplate('flashesFields')"
                  v-if="canDisplayFlashesTemplate"
              >
                <feather-icon icon="ZapIcon" class="mr-50" />
                <span class="align-middle">{{ $t("TEMPLATE.Flashes") }}</span>
              </b-button>

              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-template"
                  :class="{ 'template-selected': isPodcast }"
                  @click="onSelectTemplate('podcastFields')"
                  v-if="canDisplayPodcastTemplate"
              >
                <feather-icon icon="MicIcon" class="mr-50" />
                <span class="align-middle">{{ $t("TEMPLATE.Podcast") }}</span>
              </b-button>

              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-template"
                  :class="{ 'template-selected': isTVCast }"
                  @click="onSelectTemplate('tvFields')"
                  v-if="canDisplayTvCastTemplate"
              >
                <feather-icon icon="TvIcon" class="mr-50" />
                <span class="align-middle">{{ $t("TEMPLATE.TvCast") }}</span>
              </b-button>

              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-template"
                  :class="{ 'template-selected': isReport }"
                  @click="onSelectTemplate('reportFields')"
                  v-if="canDisplayReportTemplate"
              >
                <feather-icon icon="PieChartIcon" class="mr-50" />
                <span class="align-middle">{{ $t("TEMPLATE.Report") }}</span>
              </b-button>
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-template"
                  :class="{ 'template-selected': isDisclosure }"
                  @click="onSelectTemplate('eventFields')"
              >
                <feather-icon icon="CalendarIcon" class="mr-50" />
                <span class="align-middle">{{
                    $t("TEMPLATE.Disclosure")
                  }}</span>
              </b-button>
            </div>
            <div class="user-template-content" v-if="!isEdit">
              <span class="">
                {{$t('SEND_NEWS.Template')}}
                <span class="required" v-if="userTemplate.isUpdated">
                  ...
                  <feather-icon class="" icon="Edit2Icon"/>
                </span>
              </span>
              <div class="flex">
                <feather-icon v-if="userTemplate.name" class="cursor-pointer user-template-btn-edit" icon="EditIcon" @click="onEditSelectedUserTemplateName"/>
                <v-select
                    id="user-template"
                    v-model="userTemplate"
                    label="name"
                    :options="currentUserTemplates"
                >
                  <span slot="no-options">{{
                      $t("GENERAL.NoOptions")
                    }}</span>
                </v-select>
                <b-button
                    v-if="userTemplate.name"
                    variant="flat-primary"
                    class="btn-icon "
                    v-b-tooltip.hover.top="$t('SEND_NEWS.Template_New')"
                    @click="newUserTemplate"
                >
                  <feather-icon icon="PlusIcon" class="mr-50" />
                </b-button>
                <b-button
                    v-if="userTemplate.name"
                    variant="flat-primary"
                    class="btn-icon user-template-btn"
                    v-b-tooltip.hover.top="$t('SEND_NEWS.Template_Delete')"
                    @click="onDeleteUserTemplate"
                >
                  <feather-icon icon="TrashIcon" class="mr-50" />
                </b-button>
                <b-button
                    variant="flat-primary"
                    class="btn-icon user-template-btn"
                    v-b-tooltip.hover.top="$t('SEND_NEWS.Template_Save')"
                    @click="saveUserTemplate"
                >
                  <feather-icon icon="SaveIcon" class="mr-50" />
                </b-button>
              </div>
            </div>
          </b-card-body>
        </b-card>
        <!-- FIM POSTTYPE -->

        <!-- INICIO SUBJECTS -->
        <b-card no-body class="send-news-card-header">
          <b-card-body class="position-relative">
            <b-button
              v-if="form.subjects.value.length > 0"
              variant="flat-secondary"
              size="sm"
              class="btn-icon"
              style="position: absolute; top: 15px; right: 20px; z-index: 9"
              v-b-tooltip.hover.v-secondary
              :title="$t('SEND_NEWS.Clear_Subjects')"
              @click="clearSubjects"
            >
              <feather-icon icon="TrashIcon" size="18" class="mr-25" />
              <span>{{ $t('SEND_NEWS.Clear') }}</span>
            </b-button>
            <b-row>
            <b-col
              md="12"
              v-if="
              form.subjects.display &&
              !displaySubjectViewTypeCheckbox
            "
          >
            <span
                class="lbl-form-send-news"
                :class="{ required: form.subjects.required }"
            >{{ getSubjectLabel }}
              <feather-icon
                  v-if="hasFieldError('subjects')"
                  icon="AlertCircleIcon"
                  class="text-danger icon-validate"
                  v-b-tooltip.hover.v-secondary
                  :title="getMessageFieldError('subjects')"
              >
                </feather-icon>
              </span>
            <v-select
                id="subjects-list"
                v-model="form.subjects.value"
                :options="userCore.subjects"
                :label="getTranslateLabelName"
                multiple
                class="subject-select-field"
                :placeholder="$t('SEND_NEWS.Subject_Placeholder')"
                :tabindex="4"
                :closeOnSelect="false"
            >
              <template v-slot:option="item">
                <p>
                  <b>{{ getTranslateFieldName(item) }} ({{item.acronym ? item.acronym : item.mnemonic}})</b>
                </p>
              </template>
              <span slot="no-options">{{
                  $t("GENERAL.NoOptions")
                }}</span>
            </v-select>
            </b-col>
            </b-row>

            <b-row>
              <b-col
                md="12"
                v-if="
                form.subjects.display &&
                displaySubjectViewTypeCheckbox
              "
            >
              <span
                  class="lbl-form-send-news"
                  :class="{ required: form.subjects.required }"
              >{{ getSubjectLabel }}
                <feather-icon
                    v-if="hasFieldError('subjects')"
                    icon="AlertCircleIcon"
                    class="text-danger icon-validate"
                    v-b-tooltip.hover.v-secondary
                    :title="getMessageFieldError('subjects')"
                >
                </feather-icon>
              </span>
              <div style="margin-left: -6px">
                <b-badge
                    variant="light-secondary"
                    class="send-news-subject-badge"
                    v-for="(item, index) in userCore.subjects"
                    :key="index"
                    :class="{
                    'send-news-subject-badge-selected': subjectSelected(item),
                  }"
                    @click="onSelectSubjectCheckbox(item)"
                >{{ getTranslateFieldName(item) }} ({{item.acronym ? item.acronym : item.mnemonic}})</b-badge>
              </div>

              <!--<b-form-group label="Assuntos" style="margin-top: 5px">
        <b-form-checkbox-group
          id="checkbox-subejcts"
          v-model="subjectModelCheckbox"
          :options="subjects"
          value-field="id"
          text-field="name"
          name="flavour-1"
          class="demo-inline-spacing"
        />
      </b-form-group> -->
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <!-- FIM SUBJECTS -->



        <!-- INICIO SENDNEWS -->
        <div class="flex">
          <div>
            <!-- <b-card class="card-header-top">
              <b-card-body>
                <b-row md="6">
                  <b-col>
                    teste
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card> -->
            <b-card no-body class="send-news-card w-full">            
            <b-card-body>
              <!-- EVENTOS -->
              <b-row>
                <b-card no-body class="">
                  <b-card-body v-if="displayForm">
                    <b-form
                        ref="news-form"
                        class=""
                        @submit.prevent
                        autocomplete="off"
                    >
                      <b-row>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="6" vs- v-if="form.eventScheduleType.display">
                          <span
                              class="lbl-form-send-news"
                              :class="{
                              required: form.eventScheduleType.required,
                            }"
                          >{{ $t("SEND_NEWS.EventSchedule_Type") }}
                            <feather-icon
                                v-if="hasFieldError('eventScheduleType')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('eventScheduleType')"
                            >
                            </feather-icon>
                          </span>
                          <v-select
                              id="eventScheduleType"
                              v-model="form.eventScheduleType.value"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              label="name"
                              :options="eventScheduleTypes"
                              :reduce="(option) => option.id"
                          >
                            <span slot="no-options">{{
                                $t("GENERAL.NoOptions")
                              }}</span>
                          </v-select>
                        </b-col>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="6" v-if="form.disclosureType.display">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.disclosureType.required }"
                          >{{ $t("SEND_NEWS.Type") }}
                            <feather-icon
                                v-if="hasFieldError('disclosureType')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('disclosureType')"
                            >
                            </feather-icon>
                          </span>
                          <v-select
                              id="disclosureType"
                              v-model="form.disclosureType.value"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              label="name"
                              :options="disclosureTypes"
                              :reduce="(option) => option.id"
                          >
                            <span slot="no-options">{{
                                $t("GENERAL.NoOptions")
                              }}</span>
                          </v-select>
                        </b-col>

                        <b-col
                            md="12"
                            v-if="form.eventScheduleRelatedNews.display"
                        >
                          <div class="">
                            <span
                                class="lbl-form-send-news"
                                :class="{
                                required:
                                  form.eventScheduleRelatedNews.required,
                              }"
                            >{{ isAnnouncement ? $t("SEND_NEWS.EventSchedule_Related_News") : $t("SEND_NEWS.EventSchedule_Related_News_Announcement") }}
                              <feather-icon
                                  v-if="hasFieldError('eventScheduleRelatedNews')"
                                  icon="AlertCircleIcon"
                                  class="text-danger icon-validate"
                                  v-b-tooltip.hover.v-secondary
                                  :title="
                                  getMessageFieldError(
                                    'eventScheduleRelatedNews'
                                  )
                                "
                              >
                              </feather-icon>
                              <feather-icon
                                  icon="LinkIcon"
                                  class="icon-validate cursor-pointer"
                                  v-b-tooltip.hover.v-secondary
                                  :title="$t('SEND_NEWS.Link_News')"
                                  @click="openLinkInviteModal"
                              >
                              </feather-icon>
                            </span>
                            <v-select
                                id="eventScheduleRelatedNews"
                                v-model="form.eventScheduleRelatedNews.value"
                                :dir="
                                $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              "
                                label="name"
                                :options="[]"
                            >
                              <span slot="no-options">{{
                                  $t("GENERAL.NoOptions")
                                }}</span>
                            </v-select>
                            <!-- <b-form-input
                        id="eventScheduleLocation"
                        :placeholder="$t('SEND_NEWS.EventSchedule_Related_News')"
                        :value="form.eventScheduleRelatedNews.value ? form.eventScheduleRelatedNews.value.content.title.data : ''"
                        disabled
                      /> -->
                            <!-- <label for="eventScheduleRelatedNews">{{$t('SEND_NEWS.EventSchedule_Related_News')}}</label> -->
                          </div>
                        </b-col>
                        <!-- <b-col
                            md="12"
                            v-if="form.eventScheduleLocation.display"
                        >
                          <div class="">
                            <span
                                class="lbl-form-send-news"
                                :class="{
                                required: form.eventScheduleLocation.required,
                              }"
                            >{{ $t("SEND_NEWS.EventSchedule_Location") }}
                              <feather-icon
                                  v-if="hasFieldError('eventScheduleLocation')"
                                  icon="AlertCircleIcon"
                                  class="text-danger icon-validate"
                                  v-b-tooltip.hover.v-secondary
                                  :title="
                                  getMessageFieldError('eventScheduleLocation')
                                "
                              >
                              </feather-icon>
                              <feather-icon
                                  icon="MapIcon"
                                  class="icon-validate cursor-pointer"
                                  v-b-tooltip.hover.v-secondary
                                  :title="$t('SEND_NEWS.Open_Map')"
                                  @click="openGoogleMapsModal"
                              >
                              </feather-icon>
                            </span>
                            <b-form-input
                                id="eventScheduleLocation"
                                :placeholder="
                                $t('SEND_NEWS.EventSchedule_Location')
                              "
                                v-model="form.eventScheduleLocation.value"
                            />
                          </div>
                        </b-col> -->
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12" v-if="form.eventScheduleLink.display">
                          <div class="">
                            <span
                                class="lbl-form-send-news"
                                :class="{
                                required: form.eventScheduleLink.required,
                              }"
                            >{{ $t("SEND_NEWS.EventSchedule_Link") }}
                              <feather-icon
                                  v-if="hasFieldError('eventScheduleLink')"
                                  icon="AlertCircleIcon"
                                  class="text-danger icon-validate"
                                  v-b-tooltip.hover.v-secondary
                                  :title="
                                  getMessageFieldError('eventScheduleLink')
                                "
                              >
                              </feather-icon>
                            </span>
                            <b-form-input
                                id="eventScheduleLink"
                                :placeholder="$t('SEND_NEWS.EventSchedule_Link')"
                                v-model="form.eventScheduleLink.value"
                            />
                            <!-- <label for="eventScheduleLink">{{$t('SEND_NEWS.EventSchedule_Link')}}</label> -->
                          </div>
                        </b-col>
                        <!-- <b-col xs="12" sm="12" md="12" lg="12" xl="12" v-if="form.eventSchedulePrice.display">
                          <div class="">
                            <span
                                class="lbl-form-send-news"
                                :class="{
                                required: form.eventSchedulePrice.required,
                              }"
                            >{{ $t("SEND_NEWS.EventSchedule_Price") }}
                              <feather-icon
                                  v-if="hasFieldError('eventSchedulePrice')"
                                  icon="AlertCircleIcon"
                                  class="text-danger icon-validate"
                                  v-b-tooltip.hover.v-secondary
                                  :title="
                                  getMessageFieldError('eventSchedulePrice')
                                "
                              >
                              </feather-icon>
                            </span>
                            <b-form-input
                                id="eventSchedulePrice"
                                :placeholder="$t('SEND_NEWS.EventSchedule_Price')"
                                v-model="form.eventSchedulePrice.value"
                                v-mask="currencyMask"
                            />
                          </div>
                        </b-col> -->
                        <b-col xs="12" sm="12" md="12" lg="6" xl="6" v-if="form.eventScheduleDuration_dateTo.display && isAnnouncement">
                          <div>
                            <span
                                class="lbl-form-send-news"
                                :class="{
                                required:
                                  form.eventScheduleDuration_dateTo.required,
                              }"
                            >{{ $t("SEND_NEWS.EventSchedule_DateTo") }}</span
                            >
                            <flat-pickr
                                v-model="form.eventScheduleDuration_dateTo.value"
                                class="form-control input-dt-schedule"
                                :config="{
                                enableTime: false,
                                dateFormat: 'Y-m-d',
                                altInput: true,
                                altFormat: 'd/m/Y',
                                allowInput: true,
                                inline: false,
                              }"
                            />
                                <!-- disable: [
                                  { from: '2022-01-01', to: getYesterdayDate },
                                ], -->
                          </div>
                        </b-col>
                        <b-col xs="12" sm="12" md="12" lg="6" xl="6" v-if="form.eventScheduleDuration_hourTo.display && isAnnouncement">
                          <div class="">
                            <span
                                class="lbl-form-send-news"
                                :class="{
                                required:
                                  form.eventScheduleDuration_hourTo.required,
                              }"
                            >{{ $t("SEND_NEWS.EventSchedule_HourTo") }}</span
                            >
                            <cleave
                                id="hour_schedule"
                                v-model="form.eventScheduleDuration_hourTo.value"
                                class="form-control"
                                :raw="false"
                                :options="maskOptions.time"
                                placeholder="hh:mm"
                            />
                          </div>
                        </b-col>
                        <!-- <b-col xs="12" sm="12" md="12" lg="12" xl="4" v-if="form.eventScheduleAllDay.display" class="flex" style="padding-top: 25px">
                          <b-form-checkbox
                            checked="false"
                            name="check-button"
                            class="custom-control-danger custom-switch-send-news"
                            switch
                            inline
                            v-model="form.eventScheduleAllDay.value"
                          >
                            {{ $t("SEND_NEWS.EventSchedule_AllDay") }}
                          </b-form-checkbox>
                        </b-col> -->
                        <b-col xs="12" sm="12" md="12" lg="6" xl="6"
                               v-if="
                            form.eventScheduleDuration_dateFrom.display && isAnnouncement
                          "
                        >
                          <div>
                            <span
                                class="lbl-form-send-news"
                                :class="{
                                required:
                                  form.eventScheduleDuration_dateFrom.required,
                              }"
                            >{{
                                $t("SEND_NEWS.EventSchedule_DateFrom")
                              }}</span
                            >
                            <flat-pickr
                                v-model="
                                form.eventScheduleDuration_dateFrom.value
                              "
                                class="form-control input-dt-schedule"
                                :config="{
                                enableTime: false,
                                dateFormat: 'Y-m-d',
                                altInput: true,
                                altFormat: 'd/m/Y',
                                allowInput: true,
                                inline: false,
                              }"
                            />
                            <!-- disable: [
                              {
                                from: '2022-01-01',
                                to: getYesterdayDateFrom(form.eventScheduleDuration_dateTo.value),
                              },
                            ], -->
                            <!-- disable: [{from: form.eventScheduleDuration_dateTo.value}] -->
                          </div>
                        </b-col>
                        <b-col xs="12" sm="12" md="12" lg="6" xl="6"
                               v-if="
                            form.eventScheduleDuration_hourFrom.display && isAnnouncement
                          "
                        >
                          <div class="">
                            <span
                                class="lbl-form-send-news"
                                :class="{
                                required:
                                  form.eventScheduleDuration_hourFrom.required,
                              }"
                            >{{
                                $t("SEND_NEWS.EventSchedule_HourFrom")
                              }}</span
                            >
                            <cleave
                                id="hour_schedule"
                                v-model="
                                form.eventScheduleDuration_hourFrom.value
                              "
                                class="form-control"
                                :raw="false"
                                :options="maskOptions.time"
                                placeholder="hh:mm"
                            />
                          </div>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col md="12" v-if="form.topic.display && this.topic.length > 0">
                          <!-- {{ $t("SEND_NEWS.Subject") }} -->
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.topic.required }"
                          >Tópico
                            <feather-icon
                                v-if="hasFieldError('topic')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('topic')"
                            >
                            </feather-icon>
                          </span>
                          <v-select
                              id="subjects-list"
                              v-model="form.topic.value"
                              :options="topic"
                              :label="getTranslateLabelName"
                              multiple
                              class="subject-select-field"
                              :placeholder="$t('SEND_NEWS.Subject_Placeholder')"
                              :tabindex="5"
                              :closeOnSelect="false"
                          >
                            <!-- <template v-slot:option="item">
                              <p>
                                <b>{{ item }}</b>
                              </p>
                            </template> -->
                            <span slot="no-options">{{
                                $t("GENERAL.NoOptions")
                              }}</span>
                          </v-select>
                        </b-col>

                        <b-col md="12" v-if="form.newsContent.display">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.newsContent.required }"
                          >{{ $t("SEND_NEWS.NewsContent") }}
                            <feather-icon
                                v-if="hasFieldError('newsContent')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('newsContent')"
                            >
                            </feather-icon>
                          </span>
                          <v-select
                              id="content-report"
                              :placeholder="
                              $t('SEND_NEWS.NewsContent_Placeholder')
                            "
                              v-model="form.newsContent.value"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              :label="getTranslateLabelName"
                              multiple
                              :options="newsContent"
                              :tabindex="6"
                              class="subject-select-field"
                          >
                            <template v-slot:option="item">
                              <p>
                                <b>{{ getTranslateFieldName(item) }}</b>
                              </p>
                              <!-- <p>
                                <small
                                >{{ $t("SEND_NEWS.Origins") }}:
                                  {{ item.originsName.join(", ") }}</small
                                >
                              </p> -->
                            </template>
                            <span slot="no-options">{{
                                $t("GENERAL.NoOptions")
                              }}</span>
                          </v-select>
                        </b-col>
                      </b-row>

                      <b-row v-if="form.tags.display">
                        <b-col md="12" :class="{ 'ai-highlight': highlightedFields.tags }">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.tags.required }"
                          >{{ $t("SEND_NEWS.Tags") }}
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              variant="flat-primary"
                              class="btn-icon btn-sm ml-50 align-self-center ai-icon-btn"
                              :disabled="tagsAiLoading"
                              @click.prevent="generateTagsSuggestion()"
                              v-b-tooltip.hover.v-secondary
                              :title="$t('AI_MESSAGES.GenerateTags')"
                              v-if="!isFlashes"
                            >
                              <template v-if="tagsAiLoading">
                                <b-spinner small class="mx-1" />
                              </template>
                              <template v-else>
                                <AiIcon :size="16" :aria-label="$t('AI_MESSAGES.Title')" />
                              </template>
                            </b-button>
                          </span>
                          <!-- :closeOnSelect="false" -->
                          <v-select
                              id="tags-list"
                              :placeholder="$t('SEND_NEWS.Tags_Placeholder')"
                              :ref="`${instance}-tags`"
                              v-model="form.tags.value"
                              :options="tags"
                              label="name"
                              class="tags-class"
                              multiple
                              pill
                              :taggable="canCreateTag"
                              :push-tags="canCreateTag"
                              :create-option="(name) => ({ id: null, name })"
                              :get-option-key="(option) => (typeof option === 'object' ? option.id || option.name : option)"
                              :tabindex="5"
                              :clearable="true"
                              @search="
                                (search, loading) => {
                                  loading(true);
                                  loadTagData(search).then((resp) => {
                                    tags = resp;
                                    loading(false);
                                  });
                                }
                              "
                          >
                            <template v-slot:option="item">
                              <p>
                                <b>{{ item.name }}</b>
                              </p>
                            </template>
                            <span slot="no-options">{{
                                $t("GENERAL.NoOptions")
                              }}</span>
                            <template #selected-option-container="{ option, deselect, disabled, multiple }">
                              <span class="vs__selected" :class="{'new': !option.id}" @click.stop="removeTag(option)">
                                <!-- Custom display for the option -->
                                {{ option.name }}
                                <AiIcon :size="8" v-if="option.aiGenerated" class="" style="margin-left: 0.3rem;"/>
                                <!-- Custom deselect button with mousedown.stop to prevent toggling the dropdown -->
                                <!-- <button v-if="multiple && !disabled" @click.stop="removeTag(option)" class="vs__deselect"> -->
                                <button v-if="multiple && !disabled" @click.stop="removeTag(option)" class="vs__deselect">
                                  &times;
                                </button>
                              </span>
                            </template>
                          </v-select>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12" v-if="form.reportType.display">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.reportType.required }"
                          >{{ $t("SEND_NEWS.Report") }}
                            <feather-icon
                                v-if="hasFieldError('reportType')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('reportType')"
                            >
                            </feather-icon>
                          </span>
                          <v-select
                              id="report-type"
                              :placeholder="$t('SEND_NEWS.Report_Placeholder')"
                              v-model="form.reportType.value"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              :label="getTranslateLabelName"
                              multiple
                              :options="reportType"
                              :filter-by="filterReportTypeOption"
                              :tabindex="7"
                              class="subject-select-field"
                          >
                            <template v-slot:option="item">
                              <p>
                                <b>{{ getTranslateFieldName(item) }}</b>
                              </p>
                            </template>
                            <span slot="no-options">{{
                                $t("GENERAL.NoOptions")
                              }}</span>
                          </v-select>
                        </b-col>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12" v-if="form.dt_report.display">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.dt_report.required }"
                          >{{ $t("SEND_NEWS.Report_Date") }}
                            <feather-icon
                                v-if="hasFieldError('dt_report')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('dt_report')"
                            >
                            </feather-icon>
                          </span>
                          <div class="form-label-group">
                            <flat-pickr
                                v-model="form.dt_report.value"
                                class="form-control input-dt-schedule"
                                :config="{
                                enableTime: false,
                                dateFormat: 'Y-m-d',
                                altInput: true,
                                altFormat: 'd/m/Y',
                                allowInput: true,
                                inline: false,
                              }"
                            />
                          </div>
                        </b-col>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12" v-if="form.dt_publish.display">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.dt_publish.required }"
                          >{{ $t("SEND_NEWS.Publish_Date") }}
                            <feather-icon
                                v-if="hasFieldError('dt_publish')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('dt_publish')"
                            >
                            </feather-icon>
                          </span>
                          <div class="form-label-group">
                            <flat-pickr
                                v-model="form.dt_publish.value"
                                class="form-control input-dt-schedule"
                                :config="{
                                enableTime: false,
                                dateFormat: 'Y-m-d',
                                altInput: true,
                                altFormat: 'd/m/Y',
                                allowInput: true,
                                inline: false,
                              }"
                            />
                          </div>
                        </b-col>
                        <!-- <b-col md="6"></b-col> -->

                        <b-col xs="12" sm="12" md="12" lg="12" xl="4" v-if="form.package.display">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.package.required }"
                          >{{ $t("SEND_NEWS.Package") }}
                            <feather-icon
                                v-if="hasFieldError('package')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('package')"
                            >
                            </feather-icon>
                          </span>
                          <div class="">
                            <b-form-input
                                id="package"
                                :placeholder="$t('SEND_NEWS.Package_Placeholder')"
                                v-model="form.package.value.name"
                                disabled
                            />
                            <!-- <label for="package">Pacote</label> -->
                          </div>
                        </b-col>

                        <b-col xs="12" sm="12" md="12" lg="12" xl="4" v-if="form.characteristic.display">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.characteristic.required }"
                          >{{ $t("SEND_NEWS.Characteristic") }}
                            <feather-icon
                                v-if="hasFieldError('characteristic')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('characteristic')"
                            >
                            </feather-icon>
                          </span>
                          <div class="">
                            <b-form-input
                                id="characteristic"
                                :placeholder="
                                $t('SEND_NEWS.Characteristic_Placeholder')
                              "
                                :value="
                                getTranslateFieldName(form.characteristic.value)
                              "
                                disabled
                            />
                          </div>
                        </b-col>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="4" v-if="form.periodicity.display">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.periodicity.required }"
                          >{{ $t("SEND_NEWS.Periodicity") }}
                            <feather-icon
                                v-if="hasFieldError('periodicity')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('periodicity')"
                            >
                            </feather-icon>
                          </span>
                          <div class="">
                            <b-form-input
                                id="periodicity"
                                :placeholder="
                                $t('SEND_NEWS.Periodicity_Placeholder')
                              "
                                :value="
                                getTranslateFieldName(form.periodicity.value)
                              "
                                disabled
                            />
                          </div>
                        </b-col>

                        <div class="col-md-12" v-if="form.hat.display" :class="{ 'ai-highlight': highlightedFields.hat }">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.hat.required }"
                          >{{ $t("SEND_NEWS.Hat") }}
                            <feather-icon
                                v-if="hasFieldError('hat')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('hat')"
                            >
                            </feather-icon>

                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              variant="flat-primary"
                              class="btn-icon btn-sm ml-50 align-self-center ai-icon-btn"
                              :disabled="hatAiLoading"
                              @click.prevent="generateHatSuggestion()"
                              v-b-tooltip.hover.v-secondary
                              :title="$t('AI_MESSAGES.GenerateHat')"
                              v-if="!isFlashes"
                            >
                              <template v-if="hatAiLoading">
                                <b-spinner small class="mx-1" />
                              </template>
                              <template v-else>
                                <AiIcon :size="16" :aria-label="$t('AI_MESSAGES.Title')" />
                              </template>
                            </b-button>
                          </span>
                          <v-select
                              id="hat"
                              :placeholder="$t('SEND_NEWS.Hat_Placeholder')"
                              :ref="`${instance}-hat`"
                              v-model="form.hat.value"
                              :options="hats"
                              label="name"
                              class="tags-class"
                              multiple
                              pill
                              :taggable="canCreateHat"
                              :push-tags="canCreateHat"
                              :tabindex="8"
                              @search="
                              (search, loading) => {
                                loading(true);
                                loadHatData(search).then((resp) => {
                                  hats = resp;
                                  loading(false);
                                });
                              }
                            "
                          >
                            <template v-slot:option="item">
                              <p>
                                <b>{{ item.name }}</b>
                              </p>
                            </template>
                            <span slot="no-options">{{
                                $t("GENERAL.NoOptions")
                              }}</span>
                            <template #selected-option-container="{ option, deselect, disabled, multiple }">
                              <span class="vs__selected" :class="{'new': !option.id}">
                                <!-- Custom display for the option -->
                                {{ option.name }}
                                <!-- Custom deselect button with mousedown.stop to prevent toggling the dropdown -->
                                <button v-if="multiple && !disabled" @mousedown.stop @click="deselect(option)" class="vs__deselect">
                                  &times;
                                </button>
                              </span>
                            </template>
                          </v-select>
                        </div>
                        <!-- Manchete -->
                        <b-col md="12" v-if="form.title.display" :class="{ 'ai-highlight': highlightedFields.title }">
                          <span
                              class="lbl-form-send-news d-inline-flex align-items-center"
                              :class="{ required: form.title.required }"
                          >{{ $t("SEND_NEWS.Title") }}
                            <feather-icon
                                v-if="hasFieldError('title')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('title')"
                            >
                            </feather-icon>
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              variant="flat-primary"
                              class="btn-icon btn-sm ml-50 align-self-center ai-icon-btn"
                              :disabled="titleAiLoading"
                              @click.prevent="generateTitleSuggestion()"
                              v-b-tooltip.hover.v-secondary
                              :title="$t('AI_MESSAGES.GenerateTitle')"
                              v-if="!isFlashes"
                            >
                              <template v-if="titleAiLoading">
                                <b-spinner small class="mx-1" />
                              </template>
                              <template v-else>
                                <AiIcon :size="16" :aria-label="$t('AI_MESSAGES.Title')" />
                              </template>
                            </b-button>
                          </span>
                          <b-form-textarea
                              id="title"
                              :ref="`${instance}-title`"
                              :placeholder="$t('SEND_NEWS.Title_Placeholder')"
                              rows="4"
                              max-rows="4"
                              v-model="form.title.value"
                              maxlength="246"
                              autocomplete="off"
                              debounce="250"
                              :tabindex="9"
                              :class="
                              form.title.value.length > 245 ? 'text-danger' : ''
                            "
                          />
                          <small
                              class="textarea-counter-value float-right"
                              :class="
                              form.title.value.length > 245 ? 'bg-danger' : ''
                            "
                              style="margin-top: 0px"
                          >
                            <span class="char-count">{{
                                form.title.value.length
                              }}</span>
                            /
                            {{ 245 }}
                          </small>
                        </b-col>

                        <!-- Translate Button moved to send-options -->

                        <b-col md="12" v-show="form.summary.display" :class="{ 'ai-highlight': highlightedFields.summary }">
                          <span
                              class="lbl-form-send-news d-inline-flex align-items-center"
                              :class="{ required: form.summary.required }"
                          >{{ $t("SEND_NEWS.Summary") }}
                            <feather-icon
                                v-if="hasFieldError('summary')"
                                icon="AlertCircleIcon"
                                class="text-danger icon-validate"
                                v-b-tooltip.hover.v-secondary
                                :title="getMessageFieldError('summary')"
                            >
                            </feather-icon>
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              variant="flat-primary"
                              class="btn-icon btn-sm ml-50 align-self-center ai-icon-btn"
                              :disabled="summaryAiLoading"
                              @click.prevent="generateSummarySuggestion()"
                              v-b-tooltip.hover.v-secondary
                              :title="$t('AI_MESSAGES.GenerateSummary')"
                            >
                              <template v-if="summaryAiLoading">
                                <b-spinner small class="mx-1" />
                              </template>
                              <template v-else>
                                <AiIcon :size="16" :aria-label="$t('AI_MESSAGES.Title')" />
                              </template>
                            </b-button>
                          </span>
                          <b-form-textarea
                              id="summary"
                              :placeholder="$t('SEND_NEWS.Summary_Placeholder')"
                              :ref="`${instance}-summary`"
                              rows="6"
                              v-model="form.summary.value"
                              maxlength="1001"
                              :class="
                              form.summary.value.length > 1000
                                ? 'text-danger'
                                : ''
                            "
                              debounce="250"
                              :tabindex="10"
                          />

                          <small
                              class="textarea-counter-value float-right"
                              :class="
                              form.summary.value.length > 1000 ? 'bg-danger' : ''
                            "
                          >
                            <span class="char-count">{{
                                form.summary.value.length
                              }}</span>
                            /
                            {{ 1000 }}
                          </small>
                        </b-col>

                        <b-col md="12" class="mt-2">
                          <b-button
                            variant="success"
                            size="sm"
                            :disabled="suggestingAll"
                            @click="suggestAllFields()"
                            class="d-flex align-items-center"
                            v-b-tooltip.hover.v-secondary
                            :title="$t('AI_MESSAGES.SuggestAllHint')"
                          >
                            <template v-if="suggestingAll">
                              <b-spinner small class="mr-50" />
                              <span>{{ $t('AI_MESSAGES.Suggesting') }}</span>
                            </template>
                            <template v-else>
                              <AiIcon :size="16" class="mr-50" :aria-label="$t('AI_MESSAGES.Title')" />
                              <span>{{ $t('AI_MESSAGES.SuggestAll') }}</span>
                            </template>
                          </b-button>
                        </b-col>

                        <b-col md="12" v-if="form.body.display">
                          <span
                              class="lbl-form-send-news d-inline-flex align-items-center"
                              :class="{ required: form.body.required }"
                          >
                            {{ $t("SEND_NEWS.Body") }}
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              variant="flat-primary"
                              class="btn-icon btn-sm ml-50 align-self-center ai-icon-btn"
                              :disabled="contentAiLoading"
                              @click.prevent="openAiAssistDrawerFor('body')"
                              v-b-tooltip.hover.v-secondary
                              :title="$t('AI_MESSAGES.ImproveBody')"
                            >
                              <template v-if="contentAiLoading">
                                <b-spinner small class="mx-1" />
                              </template>
                              <template v-else>
                                <AiIcon :size="16" :aria-label="$t('AI_MESSAGES.Title')" />
                              </template>
                            </b-button>
                          </span
                          >
                          <send-news-editor
                              :ref="`${instance}-send-news-editor-form`"
                              :instance="instance"
                              :displayContentEditor="displayContentEditor"
                              :userHeaderDisplay="form.userHeader.display"
                              :userHeaders="userHeaders"
                              :currentBody="form.body.value"
                              :isMaximize="false"
                              :signatureDisplay="form.signatures.display"
                              :contentFooter="contentFooter"
                              :signatures="signatures"
                              @maximize="onMaximizeEditor"
                              @getAcronyms="loadAcronymsByName"
                              @openAcronymsModal="displayAcronymsModal"
                          ></send-news-editor>
                        </b-col>

                        <b-card-body class="col-md-12 key-points rel related-news" v-if="!isFlashes && !isDisclosure">
                          <div class="related-news-title">
                            <h5>{{ $t("SEND_NEWS.Related_News_Title") }}</h5>
                          </div>
                          <div class="related-news-container">
                            <b-col md="3 related-news-free-fields">
                              <b-form-input type="text" :placeholder="$t('SEND_NEWS.Related_Title_Placeholder')" v-model="form.related_news.free_title"/>
                            </b-col>
                            <b-col md="3 related-news-free-fields">
                              <b-form-input type="text" :placeholder="$t('SEND_NEWS.Related_Description_Placeholder')" v-model="form.related_news.free_text"/>
                            </b-col>

                            <b-col md="12">
                              <span class="lbl-form-send-news">
                                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="flat-info" class="btn-icon btn-sm search-related-news" @click.prevent="searchRelatedNews()">
                                  {{ $t("SEND_NEWS.Search_Publish") }}
                                </b-button>
                              </span>
                              <!-- <b-form-input type="text" v-model="relatedNews.title" @click.prevent="searchRelatedNews()"/> -->
                            </b-col>

                            <!-- <b-col md="6 related-news-actions">
                              <b-button  v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="flat-success" class="btn-icon btn-sm" @click="addNewRelatedNews()">
                                {{ $t("SEND_NEWS.Add") }}
                              </b-button>
                              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="flat-danger" class="btn-icon btn-sm" @click="removeNewRelatedNews()">
                                {{ $t("SEND_NEWS.Remove") }}
                              </b-button>
                            </b-col> -->

                            <b-list-group flush class="related-news-list">
                              <b-list-group-item v-for="(item, index) in this.form.related_news.news" :key="index" class="related-news-list-item">
                                <b-col>
                                  <span> {{ item.title }}</span>
                                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="flat-danger" class="btn-icon btn-sm" @click="deleteRelatedNews(item)">
                                    {{ $t("SEND_NEWS.Remove") }}
                                  </b-button>
                                </b-col>
                              </b-list-group-item>
                            </b-list-group>

                            <b-modal modal-class="modal-primary related-news-modal" :ref="`${instance}-modal-related-news`" :title="$t('SEND_NEWS.Modal_Related_News_Title')" size="xl" :ok-title="$t('SEND_NEWS.Modal_Ok_Title')" no-close-on-backdrop>
                              <div class="d-block">
                                <list-flashes :ref="`${instance}-list-related-news`" :relatedNews="true" @select="onSelectRelatedNews"></list-flashes>
                              </div>
                            </b-modal>
                          </div>
                        </b-card-body>





                        <!-- <b-col md="12">
                  <span class="lbl-form-send-news">{{$t('SEND_NEWS.Signatures')}}</span>
                  <div class="form-label-group">
                    <b-form-input
                      id="signatures"
                      v-model="form.signatures.value"
                      disabled
                    />
                  </div>
                </b-col>
                <b-col md="12">
                  <span class="lbl-form-send-news">{{$t('SEND_NEWS.ContentFooter')}}</span>
                  <div class="form-label-group">
                    <b-form-input
                      id="contentFooter"
                      v-model="form.contentFooter.value"
                      disabled
                    />
                  </div>
                </b-col> -->

                        <!-- <b-col md="12" v-if="form.sharedSources.display">
                          <span
                              class="lbl-form-send-news"
                              :class="{ required: form.sharedSources.required }"
                          >{{ $t("SEND_NEWS.SharedOrigin") }}</span
                          >
                          <v-select
                              id="typeOrigem"
                              :placeholder="
                              $t('SEND_NEWS.SharedOrigin_Placeholder')
                            "
                              v-model="form.sharedSources.value"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              label="name"
                              multiple
                              :options="sharedSources"
                              :tabindex="0"
                          >
                            <span slot="no-options">{{
                                $t("GENERAL.NoOptions")
                              }}</span>
                          </v-select>
                        </b-col> -->

                        <b-col
                            md="12"
                            v-if="hasTwitterChannel && form.weblink.display"
                        >
                          <span class="lbl-form-send-news">{{
                              $t("SEND_NEWS.Weblink")
                            }}</span>
                          <div class="form-label-group">
                            <b-form-input
                                id="weblink"
                                :placeholder="$t('SEND_NEWS.Weblink_Placeholder')"
                                v-model="form.weblink.value"
                            />
                          </div>
                        </b-col>

                        <!-- <template v-if="form.library.display"> </template> -->
                      </b-row>
                    </b-form>
                  </b-card-body>
                </b-card>
              </b-row>
            </b-card-body>
          </b-card>
          </div>
          
          <!-- INICIO OPCOES DE ENVIO -->
          <div class="send-options">
            
            <b-card no-body>
              <b-card-body>
                <b-row>
                  <!-- [2024-05-26] Pedido do Mario Hugo para remover e não mostrar os campos de origem e canal -->
                  <b-col md="12" v-if="form.source.display">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.source.required }"
                    >{{ $t("SEND_NEWS.Origin") }}
                      <feather-icon
                          v-if="hasFieldError('source')"
                          icon="AlertCircleIcon"
                          class="text-danger icon-validate"
                          v-b-tooltip.hover.v-secondary
                          :title="getMessageFieldError('source')"
                      >
                      </feather-icon>
                    </span>
                    <v-select
                        id="typeOrigem"
                        :placeholder="$t('SEND_NEWS.Origin_Placeholder')"
                        v-model="form.source.value"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        multiple
                        :options="userCore.origins"
                        :tabindex="0"
                    >
                      <span slot="no-options">{{
                          $t("GENERAL.NoOptions")
                        }}</span>
                    </v-select>
                  </b-col>
                  <b-col md="12" v-if="canDisplayChannelField">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.channel.required }"
                    >{{ $t("SEND_NEWS.Channel") }}
                      <feather-icon
                          v-if="hasFieldError('channel')"
                          icon="AlertCircleIcon"
                          class="text-danger icon-validate"
                          v-b-tooltip.hover.v-secondary
                          :title="getMessageFieldError('channel')"
                      >
                      </feather-icon>
                    </span>
                    <v-select
                        id="subjects-list"
                        v-model="form.channel.value"
                        :options="userCore.channels"
                        label="name"
                        multiple
                        class="subject-class"
                        :placeholder="$t('SEND_NEWS.Channel_Placeholder')"
                        :tabindex="1"
                    >
                      <span slot="no-options">{{
                          $t("GENERAL.NoOptions")
                        }}</span>
                    </v-select>
                  </b-col>
                  <!-- <b-col
                      md="12"
                      v-if="
                      form.type_message_channel.display &&
                      (hasTwitterChannel || hasTelegramChannel)
                    "
                  >
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.type_message_channel.required }"
                    >
                      {{ $t("SEND_NEWS.Type_Message") }}
                      <feather-icon
                          style="padding-left: 5px"
                          icon="HelpCircleIcon"
                          v-b-tooltip.hover.v-secondary
                          :title="$t('SEND_NEWS.Twitter_Telegram_Field_Help')"
                      >
                      </feather-icon>
                    </span>
                    <div class="form-label-group">
                      <v-select
                          id="type_message_channel"
                          :placeholder="$t('SEND_NEWS.Type_Message')"
                          v-model="form.type_message_channel.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="name"
                          item-value="value"
                          :options="type_message_channel"
                      >
                        <span slot="no-options">{{
                            $t("GENERAL.NoOptions")
                          }}</span>
                      </v-select>
                    </div>
                  </b-col> -->
                  <b-col md="12" v-if="form.country.display">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.country.required }"
                    >{{ $t("SEND_NEWS.Country") }}
                      <feather-icon
                          v-if="hasFieldError('country')"
                          icon="AlertCircleIcon"
                          class="text-danger icon-validate"
                          v-b-tooltip.hover.v-secondary
                          :title="getMessageFieldError('country')"
                      >
                      </feather-icon>
                    </span>
                    <v-select
                        id="country"
                        :placeholder="$t('SEND_NEWS.Country_Placeholder')"
                        v-model="form.country.value"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        multiple
                        :options="countries"
                        :tabindex="2"
                    >
                      <span slot="no-options">{{
                          $t("GENERAL.NoOptions")
                        }}</span>
                    </v-select>
                  </b-col>
                  <b-col md="12" v-if="form.clientGroup.display && !isDisclosure">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.clientGroup.required }"
                    >{{ $t("SEND_NEWS.ClientGroup") }}</span
                    >
                    <v-select
                        :disabled="form.public_area.value"
                        id="clientGroup-list"
                        v-model="form.clientGroup.value"
                        :options="clientGroup"
                        multiple
                        class="subject-select-field"
                        :placeholder="$t('SEND_NEWS.ClientGroup_Placeholder')"
                        :tabindex="4"
                        @search="
                        (search, loading) => {
                          loading(true);
                          loadClientGroupData(search).then((resp) => {
                            clientGroup = resp;
                            loading(false);
                          });
                        }
                      "
                    >
                      <span slot="no-options">{{
                          $t("GENERAL.NoOptions")
                        }}</span>
                    </v-select>
                  </b-col>
                  <b-col md="12" v-if="canDisplayAssetReference">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.asset_reference.required }"
                    >{{ $t("SEND_NEWS.AssetReference") }}</span
                    >
                    <v-select
                        id="clientGroup-list"
                        v-model="form.asset_reference.value"
                        :options="assetReference"
                        multiple
                        class="subject-select-field"
                        :placeholder="$t('SEND_NEWS.AssetReference_Placeholder')"
                        :tabindex="4"
                        label="name"
                    >
                      <template v-slot:option="item">
                        <p><b>{{item.name}}</b></p>
                        <p><small><b>{{ $t('SEND_NEWS.Option_Symbols') }}</b> {{item.symbolList.join(', ')}}</small></p>
                        <p><small><b>{{ $t('SEND_NEWS.Option_Description') }}</b> {{item.symbolDesc}}</small></p>
                        <p><small><b>{{ $t('SEND_NEWS.Option_Market') }}</b> {{item.market}}</small></p>
                        <p><small><b>{{ $t('SEND_NEWS.Option_SourceId') }}</b> {{item.sourceId}}</small></p>
                      </template>
                      <span slot="no-options">{{
                          $t("GENERAL.NoOptions")
                        }}</span>
                    </v-select>
                  </b-col>
                  <!-- <b-col md="4" v-if="form.language.display">
                  <span class="lbl-form-send-news" :class="{required: form.language.required}">{{$t('SEND_NEWS.Language')}}</span>
                  <v-select
                    id="language"
                    :placeholder="$t('SEND_NEWS.Language_Placeholder')"
                    v-model="form.language.value"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    multiple
                    disabled
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-col> -->

                  <b-col
                      md="12"
                      v-if="form.category.display && hasWordpressChannel"
                  >
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: hasWordpressChannel }"
                    >{{ $t("SEND_NEWS.Category") }}
                      <feather-icon
                          v-if="hasFieldError('category')"
                          icon="AlertCircleIcon"
                          class="text-danger icon-validate"
                          v-b-tooltip.hover.v-secondary
                          :title="getMessageFieldError('category')"
                      >
                      </feather-icon>
                    </span>
                    <v-select
                        id="category-list"
                        v-model="form.category.value"
                        :options="categories"
                        class="subject-select-field"
                        label="name"
                        :placeholder="$t('SEND_NEWS.Category_Placeholder')"
                        :tabindex="1"
                    >
                      <template v-slot:option="item">
                        <p>
                          <b>{{ item.name }}</b>
                        </p>
                        <p>
                          <small
                          >{{ $t("SEND_NEWS.Category") }}:
                            {{ item.channelName }}</small
                          >
                        </p>
                      </template>
                      <span slot="no-options">{{
                          $t("GENERAL.NoOptions")
                        }}</span>
                    </v-select>
                  </b-col>

                  <!-- Translation Trigger (moved from Title/Summary section) -->
                  <b-col md="12" v-if="isNews || isFlashes">
                    <hr>
                    <div>
                      <span class="lbl-form-send-news">{{$t('SEND_NEWS.Language')}}</span>
                      <div class="translation-controls">
                        <div class="translation-language-select-wrapper">
                          <v-select
                              id="translation-language"
                              v-model="translationTargetLanguage"
                              :options="translationLanguages"
                              label="label"
                              class="translation-language-select"
                              :reduce="(lang) => lang.code"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              :placeholder="$t('SEND_NEWS.Select_Language')"
                              :tabindex="0"
                          >
                            <span slot="no-options">{{
                                $t("GENERAL.NoOptions")
                              }}</span>
                          </v-select>
                        </div>
                      </div>
                      <div class="mt-1">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          class="translation-button w-full"
                          variant="outline-primary"
                          size="sm"
                          :disabled="!translationTargetLanguage || translationLanguagesLoading"
                          @click="handleTranslation"
                        >
                          <span class="align-middle">{{$t('SEND_NEWS.Translate')}}</span>
                        </b-button>
                      </div>
                    </div>
                    <hr>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <b-card no-body>
              <b-card-body>
                <div class="switches-session p-1">
                  <!-- <feather-icon
                        icon="PlusIcon"
                        :badge="getSwitchesSessionBadge"
                        :badge-classes="{
                          'badge-danger': true,
                          'badge-glow': true,
                          'badge-filter': true,
                        }"
                      /> -->
                  <b-row>
                    <!-- <label>Configurações da Publicação</label> -->
                    <b-col
                        md="12"
                        v-if="canDisplayEnableChartField"
                        class="config-options-send flex"
                    >
                      <span
                          class="lbl-form-send-news lbl-config-post"
                          :class="{ required: form.enable_chart.required }"
                          style="margin-right: 10px"
                      >{{ $t("SEND_NEWS.Enable_Chart") }}
                      </span>
                      <b-form-checkbox
                          :disabled="form.public_area.value"
                          checked="false"
                          name="check-button"
                          class="config-post-swiches"
                          switch
                          inline
                          v-model="form.enable_chart.value"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                        md="12"
                        v-if="canDisplayPublicAreaField"
                        class="config-options-send flex"
                    >
                      <span
                          class="lbl-form-send-news lbl-config-post"
                          :class="{ required: form.public_area.required, 'public-area-field': form.public_area.value }"
                          style="margin-right: 10px"
                      >{{ $t("SEND_NEWS.Public_Area") }}
                      </span>
                      <b-form-checkbox
                        checked="false"
                        name="check-button"
                        class="config-post-swiches"
                        switch
                        inline
                        v-model="form.public_area.value"
                        :disabled="canEnablePublicAreaField"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                        md="12"
                        v-if="canDisplayPriorityField"
                        class="config-options-send flex"
                    >
                      <span
                          class="lbl-form-send-news lbl-config-post"
                          :class="{ required: form.importance.required }"
                          style="margin-right: 10px"
                      >{{ $t("SEND_NEWS.Priority") }}
                        <feather-icon
                            v-if="hasFieldError('importance')"
                            icon="AlertCircleIcon"
                            class="text-danger icon-validate"
                            v-b-tooltip.hover.v-secondary
                            :title="getMessageFieldError('importance')"
                        >
                        </feather-icon>
                      </span>
                      <b-form-checkbox
                          checked="false"
                          name="check-button"
                          class="config-post-swiches"
                          switch
                          inline
                          v-model="form.importance.value"
                      >
                        <!-- {{form.importance.value ? $t('SEND_NEWS.Priority_Importance') : $t('SEND_NEWS.Priority_Default')}} -->
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                        md="12"
                        v-if="form.ignored_by_ai.display"
                        class="config-options-send flex"
                    >
                      <span
                          class="lbl-form-send-news"
                          style="min-width: 85px"
                      >{{ $t("SEND_NEWS.Ignored_By_AI") }}</span
                      >
                      <b-form-checkbox
                          checked="true"
                          name="check-button"
                          class="config-post-swiches"
                          switch
                          inline
                          v-model="form.ignored_by_ai.value"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                        md="12"
                        v-if="canDisplayPushField"
                        class="config-options-send flex"
                    >
                      <span
                          class="lbl-form-send-news"
                          style="min-width: 85px"
                      >{{ $t("SEND_NEWS.Send_Push") }}</span
                      >
                      <b-form-checkbox
                          checked="true"
                          name="check-button"
                          class="config-post-swiches"
                          switch
                          inline
                          v-model="form.push.value"
                      >
                        <!-- {{form.push.value ? $t('BOOLEAN.Yes') : $t('BOOLEAN.No')}} -->
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                        md="12"
                        v-if="canDisplayHighlightField"
                        class="config-options-send flex"
                    >
                      <span
                          class="lbl-form-send-news"
                          :class="{ required: form.highlight.required }"
                          style="margin-right: 10px"
                      >{{ $t("SEND_NEWS.Highlight") }}</span
                      >
                      <b-form-checkbox
                          checked="true"
                          name="check-button"
                          class="config-post-swiches"
                          switch
                          inline
                          v-model="form.highlight.value"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                        md="12"
                        v-if="form.highlight_date.display && form.highlight.value"
                        class="config-options-send flex opt"
                    >
                      <span
                          class="lbl-form-send-news"
                          :class="{ required: form.highlight.value }"
                      >{{ $t("SEND_NEWS.Period") }}
                        <feather-icon
                            v-if="hasFieldError('highlight_date')"
                            icon="AlertCircleIcon"
                            class="text-danger icon-validate"
                            v-b-tooltip.hover.v-secondary
                            :title="getMessageFieldError('highlight_date')"
                        >
                        </feather-icon>
                      </span>
                      <div
                          v-if="form.highlight_date.value"
                          class="highlight-date-field-input"
                      >
                        <b-form-input
                            id="highlight_date"
                            v-model="form.highlight_date.value"
                        ></b-form-input>
                        <feather-icon
                            class="cursor-pointer highlight-date-field-icon"
                            icon="EditIcon"
                            @click="
                            openSelectDurationModal('highlight_date', true)
                          "
                        >
                        </feather-icon>
                      </div>
                      <b-button
                          size="sm"
                          v-if="!form.highlight_date.value"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          class="config-post-swiches"
                          variant="flat-primary"
                          id="modal-select-duration"
                          @click="openSelectDurationModal('highlight_date', true)"
                      >
                        <feather-icon icon="CalendarIcon" class="mr-50" />
                        <span>{{ $t("SEND_NEWS.Add") }}</span>
                      </b-button>
                    </b-col>
                    <b-col
                        md="12"
                        v-if="form.inLive.display"
                        class="config-options-send flex"
                    >
                      <span
                          class="lbl-form-send-news"
                          :class="{ required: form.inLive.required }"
                          style="margin-right: 10px"
                      >{{ $t("SEND_NEWS.InLive") }}</span
                      >
                      <b-form-checkbox
                          checked="true"
                          name="check-button"
                          class="config-post-swiches"
                          switch
                          inline
                          v-model="form.inLive.value"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                        md="12"
                        v-if="canDisplayLiveField"
                        class="config-options-send flex opt"
                    >
                      <span
                          class="lbl-form-send-news"
                          :class="{ required: form.inLive.required }"
                      >{{ $t("SEND_NEWS.InLive_Period") }}
                        <feather-icon
                            v-if="hasFieldError('inLive_validate')"
                            icon="AlertCircleIcon"
                            class="text-danger icon-validate"
                            v-b-tooltip.hover.v-secondary
                            :title="getMessageFieldError('inLive_validate')"
                        >
                        </feather-icon>
                      </span>
                      <div
                          v-if="form.inLive_validate.value"
                          class="highlight-date-field-input"
                      >
                        <b-form-input
                            id="inLive_validate"
                            v-model="form.inLive_validate.value"
                        ></b-form-input>
                        <feather-icon
                            class="cursor-pointer highlight-date-field-icon"
                            icon="EditIcon"
                            @click="
                            openSelectDurationModal(
                              'inLive_validate',
                              false,
                              true
                            )
                          "
                        >
                        </feather-icon>
                      </div>
                      <b-button
                          size="sm"
                          v-if="!form.inLive_validate.value"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          class="config-post-swiches"
                          variant="flat-primary"
                          id="modal-select-duration"
                          @click="
                          openSelectDurationModal(
                            'inLive_validate',
                            false,
                            true
                          )
                        "
                      >
                        <feather-icon icon="CalendarIcon" class="mr-50" />
                        <span>{{ $t("SEND_NEWS.Add") }}</span>
                      </b-button>
                    </b-col>
                    <b-col
                        md="12"
                        v-if="isAnnouncement && isDisclosure"
                        class="config-options-send flex opt config-options-send-announcement"
                    >
                      <span
                          class="lbl-form-send-news"
                          :class="{'required': isRequiredAnnouncementDate}"
                      >{{ $t("SEND_NEWS.Period_Announcement") }}
                        <feather-icon
                            v-if="hasFieldError('announcement_date')"
                            icon="AlertCircleIcon"
                            class="text-danger icon-validate"
                            v-b-tooltip.hover.v-secondary
                            :title="getMessageFieldError('announcement_date')"
                        >
                        </feather-icon>
                      </span>
                      <div
                          v-if="form.announcement_date.value"
                          class="highlight-date-field-input"
                      >
                        <b-form-input
                            id="announcement_date"
                            v-model="form.announcement_date.value"
                        ></b-form-input>
                        <feather-icon
                            class="cursor-pointer highlight-date-field-icon"
                            icon="EditIcon"
                            @click="
                            openSelectDurationModal('announcement_date', true)
                          "
                        >
                        </feather-icon>
                      </div>
                      <b-button
                          size="sm"
                          v-if="!form.announcement_date.value"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          class="config-post-swiches"
                          variant="flat-primary"
                          id="modal-select-duration"
                          @click="openSelectDurationModal('announcement_date', true)"
                      >
                        <feather-icon icon="CalendarIcon" class="mr-50" />
                        <span>{{ $t("SEND_NEWS.Add") }}</span>
                      </b-button>
                    </b-col>
                    <!-- <b-col
                        md="12"
                        v-if="form.eventScheduleAllDay.display"
                        class="config-options-send flex"
                    >
                      <span
                          class="lbl-form-send-news"
                          :class="{ required: form.eventScheduleAllDay.required }"
                          style="margin-right: 10px"
                      >{{ $t("SEND_NEWS.EventSchedule_AllDay") }}</span
                      >
                      <b-form-checkbox
                          checked="true"
                          name="check-button"
                          class="config-post-swiches"
                          switch
                          inline
                          v-model="form.eventScheduleAllDay.value"
                      >
                      </b-form-checkbox>
                    </b-col> -->
                  </b-row>
                  <b-row>
                    <b-col md="12" v-if="form.listFlashes.display">
                      <span class="lbl-form-send-news">{{
                          $t("SEND_NEWS.Hist")
                        }}</span>
                      <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="flat-primary"
                          id="modal-history"
                          class="btn-sm btn-nav-link btn-nav-link-white"
                          @click.stop="openHistNewsFlashesModal()"
                      >
                        <feather-icon icon="ClockIcon" class="mr-50" />
                        <span>{{ $t("SEND_NEWS.Display") }}</span>
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
            </b-card>

            <b-card no-body v-if="form.thumb.display || form.image.display || form.image_description.display">
              <b-card-body>
                <b-row>
                  <b-col md="12" class="tbnail" v-if="form.thumb.display">
                    <div class="news-thumbnail">
                      <span
                          class="lbl-form-send-news"
                          :class="{ required: form.thumb.required }"
                      >{{ $t("SEND_NEWS.Thumb") }}</span
                      >
                      <div class="thumb-buttons">
                        <b-button
                            size="sm"
                            class="btn-icon rounded-circle btn-image-edit"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="flat-primary btn-remove-image-add"
                            @click="openImageLibraryThumb"
                        >
                          <feather-icon icon="EditIcon" />
                        </b-button>
                        <b-button
                            v-if="hasThumb"
                            size="sm"
                            class="btn-icon rounded-circle btn-image-delete"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="flat-primary btn-remove-image-add"
                            @click="onRemoveThumbSelected()"
                        >
                          <feather-icon icon="TrashIcon" />
                        </b-button>
                      </div>
                    </div>

                    <div class="drag-files send">
                      <!-- <div class="img-bg-post"
                        @click="openImageLibraryThumb"
                        :style="getThumbPathStyle(thumbSelectedPath)"
                        v-if="hasThumb"
                      ></div> -->
                      <div class="img-bg-post"
                           @click="openImage()"
                           :style="getThumbPathStyle(thumbSelectedPath)"
                           v-if="hasThumb"
                      ></div>

                      <b-button
                          v-if="!hasThumb"
                          @click="openImageLibraryThumb"
                          aria-controls="sidebar-add-new-event"
                          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                          variant="flat-primary btn-upload btn-addpublish"
                          class="btn-icon"
                          block
                      >
                        <feather-icon icon="ImageIcon" />
                      </b-button>
                      <!-- <span class="text-btn">Abrir Biblioteca de Mídias</span> -->
                    </div>

                  </b-col>
                  <b-col md="12" v-if="form.image.display">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.image.required }"
                    >{{ $t("SEND_NEWS.Image") }}</span
                    >

                    <div class="drag-files send">
                      <b-img
                          class="thumbnail-add cursor-pointer"
                          :src="imageSelectedPath"
                          v-if="hasImage"
                          @click="openImageLibraryImage"
                      />
                      <b-button
                          v-if="!hasImage"
                          @click="openImageLibraryImage"
                          aria-controls="sidebar-add-new-event"
                          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                          variant="flat-primary btn-upload btn-addpublish"
                          class="btn-icon"
                          block
                      >
                        <feather-icon icon="ImageIcon" />
                      </b-button>
                    </div>
                    <b-button
                        size="sm"
                        class="btn-icon rounded-circle btn-image-delete"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="flat-primary btn-remove-image-add"
                        @click="onRemoveImageSelected()"
                        v-if="hasImage"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </b-col>
                  <b-col md="12" v-if="form.image_description.display">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.image_description.required }"
                    >{{ $t("SEND_NEWS.Image_Description") }}</span
                    >
                    <b-form-textarea
                        id="description-img"
                        :ref="`${instance}-description`"
                        :placeholder="$t('SEND_NEWS.Image_Description_Placeholder')"
                        rows="5"
                        maxlength="250"
                        v-model="form.image_description.value"
                    />
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <b-card no-body v-if="form.document.display || form.generate_thumb.display">
              <b-card-body>
                <b-row>
                  <b-col md="12" v-if="form.document.display">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.document.required }"
                    >{{ $t("SEND_NEWS.Document") }}
                      <feather-icon
                          v-if="hasFieldError('document')"
                          icon="AlertCircleIcon"
                          class="text-danger icon-validate"
                          v-b-tooltip.hover.v-secondary
                          :title="getMessageFieldError('document')"
                      >
                      </feather-icon>
                    </span>

                    <div class="drag-files drag-doc send">
                      <b-img
                          class="thumbnail-add cursor-pointer"
                          :src="documentSelectedPath"
                          v-if="hasDocument"
                          @click="openImageLibraryDocument"
                      />
                      <b-button
                          v-if="!hasDocument"
                          @click="openImageLibraryDocument"
                          aria-controls="sidebar-add-new-event"
                          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                          variant="flat-primary btn-upload btn-addpublish"
                          class="btn-icon"
                          block
                      >
                        <feather-icon icon="FileTextIcon" />
                      </b-button>
                    </div>

                    <span
                        class="lbl-form-send-news"
                        v-if="form.download_document.display"
                        :class="{ required: form.download_document.required }"
                    >{{ $t("SEND_NEWS.Download_Document") }}</span
                    >
                    <v-select
                        id="download_document"
                        :placeholder="$t('SEND_NEWS.Download_Document_Placeholder')"
                        v-if="form.download_document.display"
                        v-model="form.download_document.value"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :options="dropdownYesNo"
                        :reduce="(option) => option.value"
                    >
                      <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                    </v-select>
                    <b-button
                        v-if="hasDocument"
                        size="sm"
                        class="btn-icon rounded-circle btn-image-delete"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="flat-primary btn-remove-image-add"
                        @click="onRemoveDocumentSelected()"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </b-col>
                  <b-col md="12" class="down" v-if="form.generate_thumb.display">
                    <div class="form-label-group">
                      <span class="lbl-form-send-news"
                      >{{ $t("SEND_NEWS.Generate_Thumb") }}
                        <feather-icon
                            icon="HelpCircleIcon"
                            class="icon-validate cursor-pointer"
                            v-b-tooltip.hover.v-secondary
                            :title="$t('SEND_NEWS.Generate_Thumb_Tooltip')"
                        >
                        </feather-icon>
                      </span>

                      <v-select
                          :placeholder="$t('SEND_NEWS.Generate_Thumb_Placeholder')"
                          v-model="form.generate_thumb.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="name"
                          item-value="value"
                          :options="dropdownYesNo"
                          :reduce="(option) => option.value"
                      >
                        <span slot="no-options">{{
                            $t("GENERAL.NoOptions")
                          }}</span>
                      </v-select>
                    </div>
                  </b-col>

                </b-row>
              </b-card-body>
            </b-card>
            <b-card no-body v-if="form.audio.display || form.audioPodcast.display || form.audiofilename.display || form.thumbPodcast.display">
              <b-card-body>
                <b-row>
                  <b-col md="12" class="tbnail" v-if="form.thumbPodcast.display">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.thumbPodcast.required }"
                    >{{ $t("SEND_NEWS.Thumb_Podcast") }}</span
                    >

                    <div class="drag-files send">
                      <b-img
                          class="thumbnail-add cursor-pointer"
                          :src="thumbPodcastSelectedPath"
                          v-if="hasThumbPodcast"
                          @click="openImageLibraryThumbPodcast"
                      />
                      <b-button
                          v-if="!hasThumbPodcast"
                          @click="openImageLibraryThumbPodcast"
                          aria-controls="sidebar-add-new-event"
                          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                          variant="flat-primary btn-upload btn-addpublish"
                          class="btn-icon"
                          block
                      >
                        <feather-icon icon="ImageIcon" />
                      </b-button>
                      <!-- <span class="text-btn">Abrir Biblioteca de Mídias</span> -->
                    </div>
                    <b-button
                        v-if="hasThumb"
                        size="sm"
                        class="btn-icon rounded-circle btn-image-delete"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="flat-primary btn-remove-image-add"
                        @click="onRemoveThumbSelected()"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </b-col>
                  <b-col md="12" v-if="form.audio.display">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.audio.required }"
                    >{{ $t("SEND_NEWS.Audio") }}
                      <feather-icon
                          v-if="hasFieldError('audio')"
                          icon="AlertCircleIcon"
                          class="text-danger icon-validate"
                          v-b-tooltip.hover.v-secondary
                          :title="getMessageFieldError('audio')"
                      >
                      </feather-icon>
                    </span>

                    <div class="drag-files drag-doc send">
                      <b-img
                          class="thumbnail-add cursor-pointer"
                          :src="audioSelectedPath"
                          v-if="hasAudio"
                          @click="openAudioLibraryDocument"
                      />
                      <b-button
                          v-if="!hasAudio"
                          @click="openAudioLibraryDocument"
                          aria-controls="sidebar-add-new-event"
                          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                          variant="flat-primary btn-upload btn-addpublish"
                          class="btn-icon"
                          block
                      >
                        <feather-icon icon="FileTextIcon" />
                      </b-button>
                    </div>
                    <b-button
                        v-if="hasAudio"
                        size="sm"
                        class="btn-icon rounded-circle btn-image-delete"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="flat-primary btn-remove-image-add"
                        @click="onRemoveAudioSelected()"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </b-col>
                  <b-col md="12" v-if="form.audio.display">
                    <b-button
                        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                        variant="flat-primary"
                        class="btn-icon mt-2 btn-display-audio"
                        block
                        @click.stop="displayAudioRec = !displayAudioRec"
                    >
                      <feather-icon icon="MicIcon" size="4" />
                      {{$t('SEND_NEWS.Record_Audio')}}
                    </b-button>
                  </b-col>
                  <b-col md="12" v-if="form.audiofilename.display && displayAudioRec">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.audiofilename.required }"
                    >{{ $t("SEND_NEWS.Audio") }}
                      <feather-icon
                          v-if="hasFieldError('audio')"
                          icon="AlertCircleIcon"
                          class="text-danger icon-validate"
                          v-b-tooltip.hover.v-secondary
                          :title="getMessageFieldError('audio')"
                      >
                      </feather-icon>
                    </span>
                    <audio-recorder
                        filename="gravacao"
                        format="mp3"
                        :time="10"
                        :select-record="selectRecord"
                        :bit-rate="192"
                        :mediaRecord="audioLibraryData"
                    />
                    <!-- <audio-player v-if="audioLibraryData._id" :src="audioLibraryData.image_path"/> -->
                  </b-col>
                  <b-col md="12" v-if="form.audiofilename.display && displayAudioRec">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.audiofilename.required }"
                    >{{ $t("SEND_NEWS.Audio_Filename") }}
                      <feather-icon
                          v-if="hasFieldError('audio')"
                          icon="AlertCircleIcon"
                          class="text-danger icon-validate"
                          v-b-tooltip.hover.v-secondary
                          :title="getMessageFieldError('audio')"
                      >
                      </feather-icon>
                    </span>
                    <b-form-input
                        id="audiofilename"
                        :ref="`${instance}-audiofilename`"
                        :placeholder="$t('SEND_NEWS.Audio_Filename_Placeholder')"
                        v-model="form.audiofilename.value"
                        maxlength="250"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>

            <!-- Video -->
            <b-card no-body>
              <b-card-body>
                <b-row>
                  <b-col md="12" class="tbnail" v-if="form.thumbVideo.display">
                    <div class="news-thumbnail">
                      <span
                          class="lbl-form-send-news"
                          :class="{ required: form.thumbVideo.required }"
                      >{{ $t("SEND_NEWS.Thumb_Video") }}</span
                      >
                      <div class="thumb-buttons">
                        <b-button
                            v-if="hasThumbVideo"
                            size="sm"
                            class="btn-icon rounded-circle btn-image-delete"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="flat-primary btn-remove-image-add"
                            @click="onRemoveThumbVideoSelected()"
                        >
                          <feather-icon icon="TrashIcon" />
                        </b-button>
                      </div>
                    </div>

                    <div class="drag-files send">
                      <b-img
                          class="thumbnail-add cursor-pointer"
                          :src="thumbVideoSelectedPath"
                          v-if="hasThumbVideo"
                          @click="openImageLibraryThumbVideo"
                      />
                      <b-button
                          v-if="!hasThumbVideo"
                          @click="openImageLibraryThumbVideo"
                          aria-controls="sidebar-add-new-event"
                          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                          variant="flat-primary btn-upload btn-addpublish"
                          class="btn-icon"
                          block
                      >
                        <feather-icon icon="ImageIcon" />
                      </b-button>
                      <!-- <span class="text-btn">Abrir Biblioteca de Mídias</span> -->
                    </div>
                  </b-col>
                  <b-col md="12">
                    <div class="news-thumbnail">
                      <span
                          class="lbl-form-send-news"
                          :class="{ required: form.youtube.required }"
                      >{{ $t("SEND_NEWS.Video") }}</span>
                      <div class="thumb-buttons">
                           <b-button
                               v-if="hasVideo"
                               size="sm"
                               class="btn-icon rounded-circle btn-image-delete"
                               v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                               variant="flat-primary btn-remove-image-add"
                               @click="onRemoveVideoSelected()"
                           >
                            <feather-icon icon="TrashIcon"/>
                          </b-button>
                      </div>
                    </div>

                    <div class="drag-files drag-doc send">
                      <b-img
                          class="thumbnail-add cursor-pointer thumbnail-contain"
                          :src="videoSelectedPath"
                          v-if="hasVideo"
                          @click="openVideoLibraryDocument"
                      />
                      <b-button
                          v-if="!hasVideo"
                          @click="openVideoLibraryDocument"
                          aria-controls="sidebar-add-new-event"
                          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                          variant="flat-primary btn-upload btn-addpublish"
                          class="btn-icon"
                          block
                      >
                        <feather-icon icon="FileTextIcon" />
                      </b-button>
                    </div>
                  </b-col>
                  <!-- Youtube video title -->
                  <b-col md="12" v-if="false">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.youtube.required }"
                    >{{ $t("SEND_NEWS.Send_To_Youtube_Title") }}</span
                    >
                    <b-form-input
                        id="youtube_title"
                        :placeholder="$t('SEND_NEWS.Send_To_Youtube_Title_Placeholder')"
                        v-model="form.youtube_title.value"
                    />
                  </b-col>
                  <b-col md="12" v-if="false">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.youtube.required }"
                    >{{ $t("SEND_NEWS.Send_To_Youtube_Description") }}</span
                    >
                    <b-form-textarea
                        id="youtube-description"
                        :placeholder="$t('SEND_NEWS.Send_To_Youtube_Description_Placeholder')"
                        rows="3"
                        maxlength="250"
                        v-model="form.youtube_description.value"
                    />
                  </b-col>
                  <b-col md="12" v-if="false">
                    <b-button
                        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                        variant="flat-primary"
                        class="btn-icon mt-2 btn-display-audio"
                        block
                        @click="sendVideoToYoutube()"
                    >
                      <feather-icon icon="YoutubeIcon" size="4" v-if="isYoutubeSentSuccess" />
                      <feather-icon icon="VideoIcon" size="4" v-if="!isSendingYoutube && !isYoutubeSentSuccess" />
                      <feather-icon icon="LoaderIcon" size="4" v-if="isSendingYoutube && !isYoutubeSentSuccess" class="loading-youtube" />
                      <span class="button-text" v-if="!isYoutubeSentSuccess">{{ isSendingYoutube ? $t("SEND_NEWS.Wait_Youtube") + ` (${formattedTime})` : $t("SEND_NEWS.Send_To_Youtube") }}</span>
                      <span class="button-text" v-if="isYoutubeSentSuccess">{{ $t("SEND_NEWS.OpenYoutube") }}</span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <!-- End Video -->

            <b-card no-body v-if="form.youtube.display || form.soundcloud.display || form.spotify.display || form.external_url.display || form.external_label_btn.display || form.related_news.display">
              <b-card-body>
                <b-row>
                  <b-col md="12" v-if="form.youtube.display">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.youtube.required }"
                    >{{ $t("SEND_NEWS.Youtube") }}
                      <feather-icon
                          v-if="hasFieldError('youtube')"
                          icon="AlertCircleIcon"
                          class="text-danger icon-validate"
                          v-b-tooltip.hover.v-secondary
                          :title="getMessageFieldError('youtube')"
                      >
                      </feather-icon>
                    </span>
                    <div class="form-label-group">
                      <b-form-input
                          id="youtube"
                          :placeholder="$t('SEND_NEWS.Youtube_Placeholder')"
                          v-model="form.youtube.value"
                      />
                      <div v-if="youtubeVideoDetail.id">
                        <div>{{ youtubeVideoDetail.snippet.title }}</div>
                        <div>
                          {{
                            youtubeVideoDetail.snippet.description.substring(
                                0,
                                30
                            ) + "..."
                          }}
                        </div>
                        <b-img
                            class=""
                            :src="youtubeVideoDetail.snippet.thumbnails.medium.url"
                            :width="
                            youtubeVideoDetail.snippet.thumbnails.medium.width
                          "
                            :height="
                            youtubeVideoDetail.snippet.thumbnails.medium.height
                          "
                        />
                      </div>
                      <!-- <label for="youtube">URL Youtube</label> -->
                      <!-- <feather-icon icon="EyeIcon" class="cursor-pointer preview-url" v-if="form.youtube.value" @click="onPreviewUrl(form.youtube.value)"/> -->
                    </div>
                  </b-col>
                  <!-- <b-col md="12" v-if="form.soundcloud.display && (canSendSoundcloudLink || isAdmin)"> -->
                  <b-col md="12" v-if="form.soundcloud.display && isAdmin && canSendSoundcloudLink">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.soundcloud.required }"
                    >{{ $t("SEND_NEWS.Soundcloud") }}</span
                    >
                    <div class="form-label-group">
                      <b-form-input
                          id="soundcloud"
                          :placeholder="$t('SEND_NEWS.Soundcloud_Placeholder')"
                          v-model="form.soundcloud.value"
                      />
                      <!-- <label for="soundcloud">Soundcloud</label> -->
                      <feather-icon
                          icon="EyeIcon"
                          class="cursor-pointer preview-url"
                          v-if="form.soundcloud.value"
                          @click="onPreviewUrl(form.soundcloud.value)"
                      />
                    </div>
                  </b-col>
                  <b-col md="12" v-if="form.spotify.display">
                    <span
                        class="lbl-form-send-news"
                        :class="{ required: form.spotify.required }"
                    >{{ $t("SEND_NEWS.Spotify") }}</span
                    >
                    <div class="form-label-group">
                      <b-form-input
                          id="spotify"
                          :placeholder="$t('SEND_NEWS.Spotify_Placeholder')"
                          v-model="form.spotify.value"
                      />
                      <div v-if="form.spotify.value" style="margin-top: 10px">
                        <iframe
                            :src="spotifyUrlEmbed"
                            width="100%"
                            height="200"
                            frameborder="0"
                            allowtransparency="true"
                            allow="encrypted-media"
                        ></iframe>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="12" v-if="form.external_url.display">
                    <div class="form-label-group">
                      <label for="external_url">{{
                          $t("SEND_NEWS.Url_Complement")
                        }}</label>
                      <b-form-input
                          id="external_url"
                          :placeholder="$t('SEND_NEWS.Url_Complement_Placeholder')"
                          v-model="form.external_url.value"
                      />
                    </div>
                  </b-col>
                  <b-col md="12" v-if="form.external_label_btn.display">
                    <div class="form-label-group">
                      <label for="external_label_btn">{{
                          $t("SEND_NEWS.Button_Name")
                        }}</label>
                      <b-form-input
                          id="external_label_btn"
                          :placeholder="$t('SEND_NEWS.Button_Name_Placeholder')"
                          v-model="form.external_label_btn.value"
                      />
                    </div>
                  </b-col>
                  <b-col md="12" v-if="form.related_news.display">
                    <span class="lbl-form-send-news">{{
                        $t("SEND_NEWS.Related_News")
                      }}</span>
                    <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        class="btn-sm btn-nav-link btn-nav-link-white"
                        variant="flat-primary"
                        id="modal-history"
                        @click.prevent="openRelatedNewsCard"
                    >
                      <feather-icon icon="CalendarIcon" class="mr-50" />
                      <span>{{ $t("SEND_NEWS.Add") }}</span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </div>
          <!-- FIM OPCOES DE ENVIO -->
        </div>
        <!-- FIM SENDNEWS -->

      </b-overlay>
    </vue-perfect-scrollbar>
    <b-modal class="popup-image-maximized pop-image-full w-full h-full"
             modal-class="modal-primary news-hist-modal"
             ref="imageMaximized"
             size="xl"
             centered
    >
      <img :src="thumbSelectedPath" style="width: 100%"/>
    </b-modal>

    <ai-assist-drawer
      v-model="aiAssistDrawerVisible"
      :title="aiAssistDrawerTitle"
      :html="aiAssistInitialHtml"
      :request="aiEditBodyRequest"
      :analyze-request="aiSuggestionsRequest"
      :tags-suggestions-request="aiTagsSuggestionsRequest"
      :newsTitle="form.title.value"
      :subjectsName="selectedSubjectsName"
      :target="aiAssistTarget"
      @error="onAiAssistError"
      @apply="applyAiAssist"
      @apply-tags="applyAiAssistTags"
    />
  </div>
</template>

<script>
import {
  VBModal,
  VBTooltip,
  BOverlay,
  BImg,
  BForm,
  BFormInput,
  BFormGroup,
  BFormCheckbox,
  BCol,
  BRow,
  BCard,
  BCardBody,
  BFormTextarea,
  BBadge,
  BFormFile,
  BButtonGroup,
  BButton,
  BModal,
  BListGroup,
  BListGroupItem,
  BPopover,
  BFormCheckboxGroup,
  BSpinner
  // BCalendar,
} from "bootstrap-vue";
import Cleave from "vue-cleave-component";
import Ripple from "vue-ripple-directive";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import dropdownService from "@/providers/dropdownService";
import acronymsService from "@/providers/acronymsService";
import newsService from "@/providers/newsService";
import youtubeService from "@/providers/youtubeService";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import AppConstants from "@/appConstants";
import { onBeforeUnmount } from "@vue/composition-api";
import NewsActionButton from "./NewsActionButton.vue";
import ListFlashes from "./ListFlashes.vue";
import flatPickr from "vue-flatpickr-component";
import ImageLibraryList from "@/views/admin/image-library/ImageLibraryList.vue";
/* eslint-disable */
import formatFieldHelper from "@/helpers/format-field-helper";
import formTemplates from "./form-templates";
import SendNewsEditor from "./SendNewsEditor.vue";
import NwScheduleModal from "./components/NwScheduleModal.vue";
import SendNewsSelectDuration from "./SendNewsSelectDuration.vue";
import AiAssistDrawer from "./manage/AiAssistDrawer.vue";
import AiIcon from "@core/components/icons/AiIcon.vue";
import messageDialogHelper from "@/helpers/message-dialog-helper";
import userService from "@/providers/userService";
import translationConfigService from "@/providers/translationConfigService";
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import { formatDate } from "@core/utils/filter";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { getCodeLang, ENUM_LOCALE_LIST } from '@/helpers/locale-helper';

const currencyMask = createNumberMask({
  prefix: "R$ ",
  allowDecimal: true,
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ".",
  decimalSymbol: ",",
  decimalLimit: 2,
  allowNegative: false,
});

let self;

export default {
  data() {
    return {
      imageMaximized: false,
      displayAudioRec: false,
      displaySwitchesSession: false,
      audioBlob: null,
      messageErrors: [],
      previewURL: "",
      displayContentEditorMaximized: false,
      displayContentEditor: false,
      displayForm: false,
      form: {},
      relatedNews: {
        id: '',
        title: ''
      },
      type_message_channel: AppConstants.TYPE_MESSAGE_CHANNEL,
      displayActionButtons: false,
      displayOverlay: false,
      submitData: false,
      canCreateTag: true,
      canCreateHat: true,
      isSendingYoutube: false,
      youtubeVideoId: '',
      isYoutubeSentSuccess: false,
      formattedTime: '00:00',
      totalSeconds: 0,
      intervalId: null,
      canSendSoundcloudLink: false,
      canSendChartOnSendNews: false,
      eventScheduleTypes: AppConstants.EVENT_SCHEDULE_TYPE,
      disclosureTypes: AppConstants.EVENT_SCHEDULE_DISCLOSURE_TYPE,
      channels: [],
      // Edicao/duplicacao: os assuntos carregados da noticia nao devem somar origens e canais
      keepLoadedSourceChannel: false,
      sourceModel: [],
      typeMessageModel: [],
      typeMessages: [],
      typeMessageSaved: null,
      eventStatus: [],
      origins: [],
      sharedSources: [],
      subjects: [],
      topic: [],
      subjectModelCheckbox: [],
      tags: [],
      categories: [],
      contentFooter: "",
      signatures: [],
      userHeaders: [],
      hats: [],
      acronyms: [],
      commodities: [],
      commodityModel: [],
      newsContent: [],
      newsContentModel: [],
      reportType: [],
      countries: [],
      clientGroup: [],
      languageModel: null,
      imagePreviewSrc: "",
      displayImagePreview: false,
      thumbPreviewSrc: "",
      displayThumbPreview: false,
      displayAppFields: false,
      sendNewsWithAction: false,
      contextSchedule: {},
      // Data do agendamento ja gravado na noticia em edicao (preenche o modal de agendamento)
      currentScheduledDate: null,
      eventStatusPublished: AppConstants.EVENT_STATUS.PUBLISHED,
      // Status da noticia antes de abrir a edicao (ao editar o backend muda para "Em edicao")
      statusBeforeEditing: null,
      maskOptions: {
        time: {
          time: true,
          timePattern: ["h", "m"],
        },
        date: {
          date: true,
          delimiter: "/",
          // datePattern: ['d', 'm', 'Y'],
          datePattern: ["Y", "m", "d"],
        },
      },
      thumbPodcastLibraryData: {},
      thumbVideoLibraryData: {},
      thumbLibraryData: {},
      imageLibraryData: {},
      documentLibraryData: {},
      audioLibraryData: {},
      videoLibraryData: {},
      formPisca: {
        dtInterval: null,
      },
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true,
      },
      imageList: [],
      listTemplate: AppConstants.LIST_TEMPLATE,
      templateSelected: {},
      displayRelatedNewsCard: true,
      youtubeVideoDetail: {},
      displaySubjectViewTypeCheckbox: false,
      dataUpdate: null,
      currencyMask,
      changeTemplateForm: null,
      userTemplate: { name: '', data: {}, isUpdated: false},
      currentUserTemplates: [],
      assetReference: [],
      bodyBeforeFlashes: null,
      translationTargetLanguage: null,
      translationTargetLanguageLabel: '',
      translationLanguages: [],
      translationLanguagesLoading: false,

      aiAssistDrawerVisible: false,
      aiAssistInitialHtml: '',
      aiAssistTarget: 'body',
      tagsAiLoading: false,
      hatAiLoading: false,
      titleAiLoading: false,
      summaryAiLoading: false,
      contentAiLoading: false,
      suggestingAll: false,
      highlightedFields: {
        summary: false,
        title: false,
        hat: false,
        tags: false,
      },
    };
  },
  props: {
    instance: {
      type: String,
    },
    isEdit: {
      type: Boolean,
    },
    isCopy: {
      type: Boolean,
    },
    isErrata: {
      type: Boolean,
    },
    editData: {
      type: Object,
    },
    currentTab: {
      type: Object,
    },
    startTemplate: {
      type: Number,
    },
  },
  beforeDestroy() {
    if (this.currentTab) {
      this.currentTab.form = Object.create(this.form);
      this.$store.dispatch("report/updateFormTab", this.currentTab);
    }
    if (
        this.isEdit &&
        this.isDraft(this.form.event_status.value) &&
        !this.sendNewsWithAction &&
        !this.isFlashes
    ) {
      this.onSubmit(AppConstants.EVENT_STATUS.DRAFT);
    } else if (!this.isEdit && !this.sendNewsWithAction) {
      if (
          this.form.source.value.length > 0 &&
          (this.form.subjects.value.length > 0 ||
              this.subjectModelCheckbox.length > 0) &&
          this.form.title.value
      ) {
        this.form.source.value = this.form.source.value;
        if (this.form.originData) {
          this.form.originData.value = this.form.source.value;
        }
        this.form.event_status.value = AppConstants.EVENT_STATUS.DRAFT;
        this.onSubmit(AppConstants.EVENT_STATUS.DRAFT);
      }
    }
  },
  created() {
    this.initComponent();
  },
  watch: {
    translationTargetLanguage (val) {
      if (val) {
        this.setCountryByLanguageToTranslate(val);
      }
    },
    "form.eventScheduleDuration_dateTo.value" (val) {
      if (val && !this.isEdit && !this.sendNewsWithAction) {
        this.form.eventScheduleDuration_dateFrom.value = this.form.eventScheduleDuration_dateTo.value;
      }
    },
    "form.public_area.value"(val) {
      if (!val) {
        this.form.channel.value = this.form.channel.value.filter((item) => item.code != AppConstants.CHANNELS.PUBLIC_AREA.id);
      } else {
        this.form.enable_chart.value = false;
        this.form.clientGroup.value = [];
      }
    },
    userTemplate(newVal, oldVal) {
      console.log('onSelect userTemplate', newVal);
      if (!newVal) {
        this.clearUserTemplate(true);
        return;
      }
      if (newVal.data._id) {
        this.loadNewsData();
      }
      // this.checkTemplateUpdated(oldVal, (a) => {
      //   if (a) {
      //   } else {
      //     newVal.preventDefault();
      //   }
      // });
    },
    "form.disclosureType.value"(val) {
      if (this.isDisclosure) {
        if (val == AppConstants.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT) {
          this.form.highlight.value = false;
          this.form.eventScheduleType.display = true;
          this.form.eventScheduleDuration_dateTo.display = true;
          this.form.eventScheduleDuration_hourTo.display = true;
          this.form.eventScheduleDuration_dateFrom.display = true;
          this.form.eventScheduleDuration_hourFrom.display = true;
          // this.form.eventScheduleAllDay.display = true;
          // this.form.eventScheduleLocation.display = true;
          this.form.eventScheduleLink.display = true;
          // this.form.eventSchedulePrice.display = true;
          this.form.eventScheduleRelatedNews.display = true;
        } else if (val == AppConstants.DISCLOSURE_TYPE_ENUM.INVITE) {
          this.form.highlight.value = true;
          this.form.eventScheduleType.display = true;
          this.form.eventScheduleDuration_dateTo.display = true;
          this.form.eventScheduleDuration_hourTo.display = true;
          this.form.eventScheduleDuration_dateFrom.display = true;
          this.form.eventScheduleDuration_hourFrom.display = true;
          // this.form.eventScheduleAllDay.display = true;
          this.form.eventScheduleRelatedNews.display = true;
          // this.form.eventScheduleLocation.display = false;
          this.form.eventScheduleLink.display = false;
          // this.form.eventSchedulePrice.display = false;

          if (this.hasPlatformPublicChannel) {
            this.form.channel.value = this.form.channel.value.filter((item) => item.code != AppConstants.CHANNELS.PUBLIC_AREA.id);
            // this.channels = this.form.channel.value.filter((item) => item.code != AppConstants.CHANNELS.PUBLIC_AREA.id);
          }
        }
      }
    },
    "form.highlight.value" (val) {
      if (val && this.canDisplayEnableChartField) {
        this.form.enable_chart.value = true;
      }
    },
    "form.enable_chart.value" (val) {
      // console.log('form.enable_chart.value: ',val)
      // console.log('form.enable_chart.value: ',this.assetReference)
      if (val) {
        this.form.public_area.value = false;
        if (this.assetReference.length <= 0) {
          this.loadAssetReference();
        }
      }
    },
    // "form.eventScheduleType.value"(val) {
    //   if (val) {
    //     if (val == AppConstants.DISCLOSURE_TYPE_ENUM.INVITE) {
    //       this.form.eventScheduleLocation.required = true;
    //       this.form.eventScheduleLocation.display = true;
    //     } else {
    //       this.form.eventScheduleLocation.required = false;
    //       this.form.eventScheduleLocation.display = false;
    //     }
    //   }
    // },
    "form.sharedSources.value"(val) {
      if (val) {
        if (val.length > 0) {
          if (
              val.findIndex(
                  (item) => item.id == AppConstants.DROPDOWN_ALL_OPTION.id
              ) >= 0
          ) {
            const origin = JSON.parse(JSON.stringify(this.sharedSources));
            origin.shift();
            this.form.sharedSources.value = origin;
          }
        }
      }
    },
    "form.tags.value"(val) {
      if (val.length > 0) {
        if (!val[val.length - 1].id) {
          console.log("[tag] ", val[val.length - 1]);
          let data = "";
          if (val[val.length - 1].name) {
            data = val[val.length - 1].name;
          } else {
            data = val[val.length - 1];
          }
          if (data.substring(0, 1) == "#") {
            data = `#${formatFieldHelper.removeSpecialCharacteres(data)}`;
          } else {
            data = formatFieldHelper.removeSpecialCharacteres(data);
          }
          if (!data) {
            this.form.tags.value.splice(this.form.tags.value.length - 1, 1);
          } else {
            if (data == "#") {
              this.form.tags.value.splice(this.form.tags.value.length - 1, 1);
            } else {
              if (this.form.tags.value[this.form.tags.value.length - 1].hasOwnProperty('name')) {
                this.form.tags.value[this.form.tags.value.length - 1].name = data;
              } else {
                this.form.tags.value[this.form.tags.value.length - 1] = data;
              }
            }
          }
        }
        // if (val.length > 1) {}
      }
    },
    "form.clientGroup.value"(val) {
      if (val && val.length > 0) {
        this.form.public_area.value = false;
        if (this.form.channel.value.findIndex(item => item.code == AppConstants.CHANNELS.PUBLIC_AREA.id) >= 0) {
          this.form.channel.value = this.form.channel.value.filter(item => item.code != AppConstants.CHANNELS.PUBLIC_AREA.id);
        }
      }
    },
    // "form.channel.value"(val) {
    //   if (this.form.clientGroup.value.length > 0) {
    //     if (val && val.findIndex(item => item.code == AppConstants.CHANNELS.PUBLIC_AREA.id) >= 0) {
    //       this.form.channel.value = val.filter(item => item.code != AppConstants.CHANNELS.PUBLIC_AREA.id);
    //       messagesNotifyHelper.warningNotify('Canal', 'Canal Área Pública não pode ser selecionado como conteúdo exclusivo');
    //       return;
    //     }
    //   }
    //   if (val.length > 0) {
    //     this.loadDataByChannels();
    //   }
    // },
    templateSelected(val) {
      if (!this.form.title.value) {
        this.updateTabName(val.name);
      }
    },
    "form.youtube.value"(val) {
      if (formatFieldHelper.validateLinkYoutubeVideo(val)) {
        this.youtubeVideoDetail = {};
        youtubeService
            .getVideoDetail(formatFieldHelper.getYoutubeId(val))
            .then((response) => {
              console.log("youtube video detail: ", response);
              if (response.items.length > 0) {
                this.youtubeVideoDetail = response.items[0];
              } else {
                messagesNotifyHelper.warningNotify(
                    "Youtube",
                    this.$t('SEND_NEWS.Youtube_Details_Not_Found')
                );
              }
            })
            .catch((err) => {
              console.log(err);
              this.youtubeVideoDetail = {};
              messagesNotifyHelper.warningNotify(
                  "Youtube",
                  this.$t('SEND_NEWS.Youtube_Details_Not_Found')
              );
            });
      }
    },
    "form.title.value"(val) {
      this.updateTabName(val);
    },
    "form.importance.value"(val) {
      if (this.isFlashes && !val) {
        this.form.importance.value = true;
      }
      if (val && this.canDisplayEnableChartField) {
        this.form.enable_chart.value = true;
      }
    },
    "form.subjects.value"(val) {
      this.onChangeSubjectValue(val);
    },
    subjectModelCheckbox(val) {
      // this.onChangeSubjectValue(val);
      // if (val.length > 0) {
      //   this.loadDataSubject();
      //   // this.loadContentBySubject();
      // } else {
      //   this.newsContent = [];
      //   this.form.newsContent.value = [];
      // }
    },
    "form.hat.value"(val) {
      if (val.length > 0) {
        if (val.length > 1) {
          this.form.hat.value = [val[val.length - 1]];
          // setTimeout(() => {
          //   this.loadHatData(val[val.length-1]);
          // }, 200);
        }
      }
    },
    "form.country.value"(val) {
      console.log('form.country.value');
      if (val) {
        if (val.length > 0) {
          if (
              val.findIndex(
                  (item) => item.id == AppConstants.DROPDOWN_ALL_OPTION.id
              ) >= 0
          ) {
            const country = JSON.parse(JSON.stringify(this.countries));
            country.shift();
            this.form.country.value = country;
          } 
          // this.checkCountryBrazil();
          // if (this.hasWordpressChannel) {
          //   this.loadCategoriesByCountry();
          // }
          this.setLanguageToTranslateByCountry(val);
          // Pisca: traduz o texto padrao do corpo para o idioma do pais (sem tocar em corpo escrito pelo usuario)
          if (this.isFlashes && this.isFlashesBody(this.form.body.value)) {
            this.form.body.value = this.getFlashesBody();
          }
        } else {
          this.categories = [];
        }
      }
    },
    "form.newsContent.value"(value) {
      if (value && value.length > 0) {
        if (!this.isEdit) {
          if (value.findIndex((item) => item.code == 1) >= 0) {
            this.form.dt_report.value = convertDatetimeHelper.getD1();
          } else {
            this.form.dt_report.value = new Date();
          }
          // this.checkCountryBrazil();
        }
        if (this.form.reportType.display) {
          this.loadReportType();
        }
      } else {
        this.form.reportType.value = [];
      }

      if (value.findIndex((item) => item.code == 1 || item.code == 2 || item.code == 3) >= 0) {
        // report contents
        this.form.dt_report.required = true;
        this.form.reportType.required = true;
        this.form.package.required = true;
        this.form.characteristic.required = true;
        this.form.periodicity.required = true;
      } else {
        this.form.dt_report.required = false;
        this.form.reportType.required = false;
        this.form.package.required = false;
        this.form.characteristic.required = false;
        this.form.periodicity.required = false;
      }
    },
    "form.reportType.value"(val) {
      if (this.form.reportType.display) {
        if (val.length > 0) {
          if (val.length > 1) {
            this.form.reportType.value = val.filter(
                (item) => item.id == val[val.length - 1].id
            );
          } else {
            this.selectReportType(val[0]);
          }
        } else {
          this.selectReportType(null);
        }
      }
    },
    "form.source.value"(val) {
      // console.log("sourceModel: ", val);
      if (val.length > 0) {
        // this.loadDataByOrigin();
        if (
          val[0] &&
          val[0].country &&
          !this.form._id.value && 
          !this.userTemplate.data._id
        ) {
          const c = this.countries.filter((item) =>
            val[0].country.includes(item.id)
          );
          if (c && c.length > 0) {
            this.form.country.value = c;
          }
        }
        // this.checkAppOrigin(this.sourceModel);
      } else {
        // this.subjects = [];
        // this.topic = []
        // this.tags = [];
        // this.commodities = [];
        // this.channels = [];
        // this.form.subjects.value = [];
        // this.subjectModelCheckbox = [];
        // this.form.channel.value = [];
        // this.form.newsContent.value = [];
        // this.form.country.value = [];
      }
    },
    typeMessageModel(val) {
      if (val) {
        if (val.length > 1) {
          this.typeMessageModel = val.filter(
              (item) => item.id == val[val.length - 1].id
          );
        }
      }
    },
    subjectViewType(val) {
      if (val == AppConstants.SUBJECT_VIEWTYPE_CHECKBOX) {
        this.displaySubjectViewTypeCheckbox = true;
      } else {
        this.displaySubjectViewTypeCheckbox = false;
      }
    },
  },
  computed: {
    selectedSubjectsName() {
      return this.form.subjects.value.map(item => item.name);
    },
    selectedLanguageCode() {
      return this.form.country.value && this.form.country.value.length > 0
        ? this.form.country.value[0].lang
        : 'pt-BR';
    },
    isRequiredAnnouncementDate() {
      return this.form.newsContent.value.findIndex(item => item.code == 10) < 0;
    },
    dropdownYesNo() {
      return [
        { name: this.$t('BOOLEAN.Yes'), value: true },
        { name: this.$t('BOOLEAN.No'), value: false },
      ];
    },
    aiAssistDrawerTitle() {
      const map = {
        title: 'AI_MESSAGES.Field_Title',
        summary: 'AI_MESSAGES.Field_Summary',
        body: 'AI_MESSAGES.Field_Body',
        hat: 'AI_MESSAGES.Field_Hat',
      };

      const label = this.$t(map[this.aiAssistTarget] || 'AI_MESSAGES.Field_Content');
      return this.$t('AI_MESSAGES.DrawerTitle', { label });
    },
    canDisplayChannelField() {
      return this.form.channel.display && (this.isAdmin || this.isEditor);
    },
    isEditor() {
      return this.currentUser.profile == AppConstants.USER_PROFILE.EDITOR;
    },
    userCore() {
      return this.$store.state.auth.userCore || {};
    },
    isAnnouncement() {
      return this.form.disclosureType.value == AppConstants.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT;
    },
    isInvite() {
      return this.form.disclosureType.value == AppConstants.DISCLOSURE_TYPE_ENUM.INVITE;
    },
    canDisplayPublicAreaField() {
      return this.form.public_area.display && this.hasUserCoreCategorie(AppConstants.USER_CATEGORIES_FIELD.PUBLIC_AREA);
    },
    canDisplayPriorityField() {
      return this.form.importance.display && this.hasUserCoreCategorie(AppConstants.USER_CATEGORIES_FIELD.PRIORITY);
    },
    canDisplayHighlightField() {
      return this.form.highlight.display && this.hasUserCoreCategorie(AppConstants.USER_CATEGORIES_FIELD.HIGHLIGHT);
    },
    canDisplayLiveField() {
      return this.form.inLive_validate.display && this.form.inLive.value && this.hasUserCoreCategorie(AppConstants.USER_CATEGORIES_FIELD.LIVE);
    },
    canDisplayPushField() {
      if (!this.form.channel.value) {
        return false;
      }
      return this.form.push.display 
        && this.hasUserCoreCategorie(AppConstants.USER_CATEGORIES_FIELD.PUSH) 
        && (this.form.channel.value.findIndex(item => item.code == AppConstants.CHANNELS.APP.id || item.code == AppConstants.CHANNELS.PLATFORM.id) >= 0);
    },
    canEnablePublicAreaField() {
      return this.form.enable_chart.value || !(this.form.clientGroup.value && this.form.clientGroup.value.length == 0);
    },
    canDisplayEnableChartField() {
      return this.form.enable_chart.display &&
          (this.canSendChartOnSendNews || this.isAdmin) &&
          this.hasSelectedSubjectEnabledChart &&
          !this.isFlashes;
    },
    canDisplayAssetReference() {
      return this.form.enable_chart.value && this.form.asset_reference.display;
      // return this.form.highlight.value && this.hasSelectedSubjectEnabledChart && !this.isFlashes && this.form.asset_reference.display;
    },
    hasSelectedSubjectEnabledChart() {
      return this.form.subjects.value.findIndex(item => item.enable_chart) >= 0;
    },
    isAdmin() {
      return this.currentUser.profile == AppConstants.USER_PROFILE.ADMIN;
    },
    disableFieldByProfile() {
      return (this.currentUser.profile != AppConstants.USER_PROFILE.ADMIN &&
          this.currentUser.profile != AppConstants.USER_PROFILE.JOURNALISM)
    },
    getSubjectLabel() {
      if (this.form.source.value) {
        if (this.form.source.value.findIndex((item) => item.code == AppConstants.ORIGINS.SAFRAS_FINANCIAL) >= 0) {
          return this.$t("SEND_NEWS.Dashboard");
        } else if (this.form.source.value.findIndex((item) => item.code == AppConstants.ORIGINS.SAFRAS) >= 0 && this.form.channel.value.findIndex((item) => item.code == AppConstants.CHANNELS.PLATFORM.id) >= 0) {
          return this.$t("SEND_NEWS.Commodities");
        }
      }
      return this.$t("SEND_NEWS.Subject");
    },
    windowWidth() {
      return this.$store.state.app.windowWidth;
    },
    mediumScreen() {
      return this.windowWidth > 1200 && this.windowWidth < 1300;
    },
    getSwitchesSessionBadge() {
      if (
          (this.canDisplayPushField && this.form.push.value) ||
          this.form.importance.value ||
          this.form.highlight.value
      ) {
        return 1;
      }
      return 0;
    },
    canDisplayNewsTemplate() {
      return (
          this.currentUser.profile != AppConstants.USER_PROFILE.ATTENDANCE &&
          this.currentUser.profile != AppConstants.USER_PROFILE.CONTRACT &&
          this.currentUser.profile != AppConstants.USER_PROFILE.MARKETING
      );
    },
    canDisplayFlashesTemplate() {
      console.log('[canDisplayFlashesTemplate]')
      if (!this.userCore || !this.userCore.channels) return false;
      return (
          this.currentUser.profile != AppConstants.USER_PROFILE.ATTENDANCE &&
          this.currentUser.profile != AppConstants.USER_PROFILE.CONTRACT &&
          this.currentUser.profile != AppConstants.USER_PROFILE.MARKETING &&
          this.userCore.channels.findIndex(
              (item) => item.code == AppConstants.CHANNELS.LEGACY.id
          ) >= 0
      );
    },
    canDisplayPodcastTemplate() {
      return (
          this.currentUser.profile != AppConstants.USER_PROFILE.ATTENDANCE &&
          this.currentUser.profile != AppConstants.USER_PROFILE.CONTRACT &&
          this.currentUser.profile != AppConstants.USER_PROFILE.MARKETING
      );
    },
    canDisplayTvCastTemplate() {
      return (
          this.currentUser.profile != AppConstants.USER_PROFILE.ATTENDANCE &&
          this.currentUser.profile != AppConstants.USER_PROFILE.CONTRACT &&
          this.currentUser.profile != AppConstants.USER_PROFILE.MARKETING
      );
    },
    canDisplayReportTemplate() {
      return (
          this.currentUser.profile != AppConstants.USER_PROFILE.ATTENDANCE &&
          this.currentUser.profile != AppConstants.USER_PROFILE.CONTRACT
      );
    },
    canDisplayEventTemplate() {
      return (
          this.currentUser.profile == AppConstants.USER_PROFILE.ADMIN ||
          this.currentUser.profile == AppConstants.USER_PROFILE.MARKETING
      );
    },
    getYesterdayDate() {
      const dt = new Date();
      dt.setDate(dt.getDate() - 1);
      return dt;
    },
    getTranslateLabelName() {
      let currLocale = getCodeLang(this.currentUser.locale);
      return `name${currLocale}`;
      // if (this.form.country.value[0]) {
      //   return `name${this.form.country.value[0].locale}`;
      // }
      // return "name";
    },
    hasWordpressChannel() {
      if (!this.form.channel.value) {
        return false;
      }
      return (
          this.form.channel.value.findIndex(
              (item) => item.code == AppConstants.CHANNELS.WORDPRESS.id
          ) >= 0
      );
    },
    hasPlatformChannel() {
      if (!this.form.channel.value) {
        return false;
      }
      return (
          this.form.channel.value.findIndex(
              (item) => item.code == AppConstants.CHANNELS.PLATFORM.id
          ) >= 0
      );
    },
    hasPlatformPublicChannel() {
      if (!this.form.channel.value) {
        return false;
      }
      return (
          this.form.channel.value.findIndex(
              (item) => item.code == AppConstants.CHANNELS.PUBLIC_AREA.id
          ) >= 0
      );
    },
    hasTwitterChannel() {
      if (!this.form.channel.value) {
        return false;
      }
      return (
          this.form.channel.value.findIndex(
              (item) => item.code == AppConstants.CHANNELS.TWITTER.id
          ) >= 0
      );
    },
    hasTelegramChannel() {
      if (!this.form.channel.value) {
        return false;
      }
      return (
          this.form.channel.value.findIndex(
              (item) => item.code == AppConstants.CHANNELS.TELEGRAM.id
          ) >= 0
      );
    },
    keymap() {
      return {
        "ctrl+enter": this.hotKeySendPublish,
        "ctrl+s": this.hotKeySavePublish,
        esc: this.hotKeyDiscartPublish,
      };
    },
    isNews() {
      return this.form.layout == AppConstants.NEWS_LAYOUT.NEWS;
    },
    isFlashes() {
      return this.form.layout == AppConstants.NEWS_LAYOUT.FLASHES;
    },
    isPodcast() {
      return this.form.layout == AppConstants.NEWS_LAYOUT.PODCAST;
    },
    isTVCast() {
      return this.form.layout == AppConstants.NEWS_LAYOUT.TVCAST;
    },
    isReport() {
      return this.form.layout == AppConstants.NEWS_LAYOUT.REPORT;
    },
    isDisclosure() {
      return this.form.layout == AppConstants.NEWS_LAYOUT.EVENT;
    },
    getFormTitle() {
      let title = "Novo ";
      if (this.isUpdate) {
        title = "Alterar ";
      }
      if (this.isNews) {
        title += "Notícia";
      }
      if (this.isFlashes) {
        title += "Pisca";
      }
      if (this.isPodcast) {
        title += "Podcast";
      }
      if (this.isTVCast) {
        title += "TVCast";
      }
      if (this.isReport) {
        title += "Relatório";
      }
      if (this.isReport) {
        title += "Convite";
      }
      return title;
    },
    currentUser() {
      return this.$store.state.auth.currentUser || {};
    },
    userConfig() {
      return this.currentUser.sendNewsConfig;
    },
    subjectViewType() {
      return (
          this.currentUser.subjectViewType || AppConstants.SUBJECT_VIEWTYPE_LIST
      );
    },
    isImportant() {
      if (Array.isArray(this.typeMessageModel)) {
        if (this.typeMessageModel.length == 0) {
          return false;
        }
        return this.typeMessageModel[0].id == 1;
      }

      if (this.typeMessageModel.id) {
        return this.typeMessageModel.id == 1;
      }
      return false;
    },
    thumbPodcastSelectedPath() {
      if (this.thumbPodcastLibraryData._id || this.thumbPodcastLibraryData.file) {
        return this.thumbPodcastLibraryData.image_path;
      }
      return "";
    },
    thumbVideoSelectedPath() {
      if (this.thumbVideoLibraryData._id || this.thumbVideoLibraryData.file) {
        return this.thumbVideoLibraryData.image_path;
      }
      return "";
    },
    thumbSelectedPath() {
      if (this.thumbLibraryData._id || this.thumbLibraryData.file) {
        return this.thumbLibraryData.image_path;
      }
      return "";
    },
    imageSelectedPath() {
      if (this.imageLibraryData._id || this.imageLibraryData.file) {
        return this.imageLibraryData.image_path;
      }
      return "";
    },
    hasThumbPodcast() {
      if (this.thumbPodcastLibraryData._id || this.thumbPodcastLibraryData.file) {
        return true;
      }
      return false;
    },
    hasThumbVideo() {
      if (this.thumbVideoLibraryData._id || this.thumbVideoLibraryData.file) {
        return true;
      }
      return false;
    },
    hasThumb() {
      if (this.thumbLibraryData._id || this.thumbLibraryData.file) {
        return true;
      }
      return false;
    },
    hasImage() {
      if (this.imageLibraryData._id || this.imageLibraryData.file) {
        return true;
      }
      return false;
    },
    hasDocument() {
      if (this.documentLibraryData._id || this.documentLibraryData.file) {
        return true;
      }
      return false;
    },
    hasAudio() {
      if (this.audioLibraryData._id || this.audioLibraryData.file) {
        return true;
      }
      return false;
    },
    hasVideo() {
      if (this.videoLibraryData._id || this.videoLibraryData.file) {
        return true;
      }
      return false;
    },
    documentSelectedPath() {
      if (this.documentLibraryData._id || this.documentLibraryData.file) {
        if (
            AppConstants.MEDIA_DOCUMENT_EXTENSIONS.indexOf(
                this.documentLibraryData.extension
            ) >= 0
        ) {
          const doc = AppConstants.MEDIA_DOCUMENT_TYPE.find(
              (item) =>
                  item.values.indexOf(this.documentLibraryData.extension) >= 0
          );
          if (doc) {
            return require(`@/assets/images/icons/${doc.img_name}`);
          }
        }
      }
      return "";
    },
    audioSelectedPath() {
      if (this.audioLibraryData._id || this.audioLibraryData.file) {
        return require(`@/assets/images/icons/audio.png`);
      }
      return "";
    },
    videoSelectedPath() {
      if (this.videoLibraryData._id || this.videoLibraryData.file) {
        return require(`@/assets/images/icons/video.png`);
      }
      return "";
    },
    currentEventStatus() {
      if (this.isEdit) {
        return this.form.event_status.value;
      }
      return 0;
    },
    // Mesma regra do updateStatusEditing: so a edicao de noticia nao rascunho muda o status para editando
    isEditingNews() {
      return this.isUpdate &&
          !this.userTemplate.data._id &&
          this.statusBeforeEditing != null &&
          !this.isDraft(this.statusBeforeEditing);
    },
    isUpdate() {
      if (this.isEdit && !this.isCopy) {
        // console.log("isUpdate");
        return true;
      }
      return false;
    },
    newsID() {
      return this.editData._id;
    },
    spotifyUrlEmbed() {
      if (this.form.spotify.value) {
        return `${AppConstants.URL_SPOTIFY_EMBED}${this.getSpotifyIdFromUrl(
            this.form.spotify.value
        )}`;
      }
      return "";
    },
  },
  methods: {
    highlightField(fieldName) {
      this.highlightedFields[fieldName] = true;
      setTimeout(() => {
        this.highlightedFields[fieldName] = false;
      }, 3000);
    },
    removeTag(option) {
      console.log('[removeTag]', option);
      // Try reference match first
      let index = this.form.tags.value.findIndex(t => t === option);
      // Fallback: match by name (for new tags with id: null). The vue-select slot wraps
      // string values as { name }, so a new tag stored as a plain string must match too.
      if (index === -1 && option.name) {
        index = this.form.tags.value.findIndex(t => !t.id && (typeof t === 'string' ? t : t.name) === option.name);
      }
      if (index !== -1) {
        this.form.tags.value.splice(index, 1);
      }
    },
    setCountryByLanguageToTranslate(val) {
      console.log('[setCountryByLanguageToTranslate] ', val);
      if (val) {
        try {
          const language = this.translationLanguages.find(lang => lang.code === val);
          if (language && language.code) {
            const country = this.countries.find(c => c.lang?.toLowerCase() === language.code.toLowerCase());
            if (country) {
              this.form.country.value = [country];
            }
          }
        } catch(err) {console.log(err)}
      }
    },
    setLanguageToTranslateByCountry(val) {
      if (val && val.length > 0) {
        const country = val[0];
        const language = this.translationLanguages.find(lang => lang.code.toLowerCase() === country.lang?.toLowerCase());
        if (language) {
          this.translationTargetLanguage = language.code;
          this.translationTargetLanguageLabel = language.name;
        } else {
          this.translationTargetLanguage = null;
          this.translationTargetLanguageLabel = '';
        }
      } else {
        this.translationTargetLanguage = null;
        this.translationTargetLanguageLabel = '';
      }
    },
    checkCountryBrazil() {
      if (this.isNews || this.form.newsContent.value.findIndex(item => item.code == 10 || item.code == 5 || item.code == 6) >= 0) {
        if (this.form.country.value.findIndex((item) => item.code == AppConstants.COUNTRY_ENUM.BRAZIL) >= 0 && 
          this.form.country.value.findIndex((item) => item.code == AppConstants.COUNTRY_ENUM.PORTUGAL) < 0) {
          // case brazil insert country portugal
          const cPort = this.countries.find((item) => item.code == AppConstants.COUNTRY_ENUM.PORTUGAL);
          if (cPort) {
            this.form.country.value.push(cPort);
          }
        }
      }
    },
    async handleTranslation() {
      const translationTitle = this.$t('SEND_NEWS.Translate');

      if (!this.translationTargetLanguage) {
        messagesNotifyHelper.warningNotify(
            translationTitle,
            this.$t('SEND_NEWS.Translation_Select_Language_Warning')
        );
        return;
      }

      const editorFormRef = this.$refs[`${this.instance}-send-news-editor-form`];
      const editorModalRef = this.$refs[`${this.instance}-send-news-editor-modal`];
      const currentBody =
        (editorModalRef && typeof editorModalRef.body === 'string' ? editorModalRef.body : null) ||
        (editorFormRef && typeof editorFormRef.body === 'string' ? editorFormRef.body : null) ||
        this.form.body.value || '';

      const fields = {};

      const filledTags = (this.form.tags.value || [])
        .map(item => (item && item.name ? item.name : item))
        .filter(item => typeof item === 'string' && item.trim());
      if (filledTags.length > 0) {
        fields.tags = filledTags;
      }

      const filledHat = (this.form.hat.value || [])
        .map(item => (item && item.name ? item.name : item))
        .find(item => typeof item === 'string' && item.trim());
      if (filledHat) {
        fields.hat = filledHat;
      }

      if (this.form.title.value && this.form.title.value.trim()) {
        fields.title = this.form.title.value;
      }

      if (this.form.summary.value && this.form.summary.value.trim()) {
        fields.summary = this.form.summary.value;
      }

      if (this.htmlToPlainText(currentBody)) {
        fields.body = currentBody;
      }

      if (Object.keys(fields).length === 0) {
        messagesNotifyHelper.warningNotify(
          translationTitle,
          this.$t('SEND_NEWS.Translation_Empty_Fields_Warning')
        );
        return;
      }
      
      // Show loading overlay
      this.displayOverlay = true;

      try {
        const payload = {
          language: this.translationTargetLanguage,
          fields,
        };

        // Call backend translation service
        const response = await newsService.translateNews(payload, new URLSearchParams());
        
        // Update form values with translated content
        if (response.tags && Array.isArray(response.tags) && response.tags.length > 0) {
          // Filter out empty strings and map to tag objects
          this.form.tags.value = response.tags
            .filter(tag => typeof tag === 'string' && tag.trim().length > 0)
            .map(tag => ({id: null, name: tag.trim()}));
        }
        if (response.hat && typeof response.hat === 'string' && response.hat.trim().length > 0) {
          this.form.hat.value = [{ id: null, name: response.hat.trim() }];
        }

        if (response.title && fields.title) {
          this.form.title.value = response.title;
        }
        if (response.summary && fields.summary) {
          this.form.summary.value = response.summary;
        }
        if (response.body && fields.body) {
          this.form.body.value = response.body;
          // Update editor if it exists
          if (this.$refs[`${this.instance}-send-news-editor-form`]) {
            this.$refs[`${this.instance}-send-news-editor-form`].body = response.body;
          }
          if (this.$refs[`${this.instance}-send-news-editor-modal`]) {
            this.$refs[`${this.instance}-send-news-editor-modal`].body = response.body;
          }
        }

        // When translating to a language other than Portuguese or Spanish,
        // legacy channels (code 1) are not supported and must be removed
        const translatedLang = (this.translationTargetLanguage || '').toLowerCase();
        const isPortugueseOrSpanish = translatedLang.startsWith('pt') || translatedLang.startsWith('es');
        if (!isPortugueseOrSpanish && this.form.channel.value && this.form.channel.value.length > 0) {
          this.form.channel.value = this.form.channel.value.filter(
            (item) => item.code != AppConstants.CHANNELS.LEGACY.id
          );
        }

        messagesNotifyHelper.successNotify(
          translationTitle,
          this.$t('SEND_NEWS.Translation_Success')
        );
      } catch (error) {
        console.error('Translation error:', error);
        messagesNotifyHelper.errorNotifyUnlessHandled(
          this.$t('SEND_NEWS.Translation_Error_Title'),
          error,
          this.$t('SEND_NEWS.Translation_Error_Default')
        );
      } finally {
        this.displayOverlay = false;
      }
    },

    hideActiveTooltip() {
      this.$nextTick(() => {
        this.$root.$emit('bv::hide::tooltip');
      });
    },

    openAiAssistDrawerFor(target) {
      this.hideActiveTooltip();
      const allowed = ['tags', 'title', 'summary', 'body'];
      if (!allowed.includes(target)) return;

      if (target === 'tags' && !this.form?.tags?.display) return;
      if (target === 'title' && !this.form?.title?.display) return;
      if (target === 'summary' && !this.form?.summary?.display) return;
      if (target === 'body' && !this.form?.body?.display) return;

      this.aiAssistTarget = target;
      this.aiAssistInitialHtml = this.getAiAssistSourceHtml(target);
      this.aiAssistDrawerVisible = true;
    },

    plainTextToHtml(text) {
      const value = String(text || '');
      const escaped = value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

      const withBreaks = escaped.replace(/\r?\n/g, '<br>');
      return `<p>${withBreaks}</p>`;
    },

    htmlToPlainText(html) {
      const input = String(html || '');
      const normalized = input
        .replace(/<\s*br\s*\/?\s*>/gi, '\n')
        .replace(/<\s*\/\s*p\s*>/gi, '\n')
        .replace(/<\s*\/\s*div\s*>/gi, '\n');

      const el = document.createElement('div');
      el.innerHTML = normalized;
      return String(el.textContent || el.innerText || '')
        .replace(/\u00A0/g, ' ')
        .replace(/\s+\n/g, '\n')
        .replace(/\n\s+/g, '\n')
        .trim();
    },

    // Texto da integra sem o que o editor insere sozinho (cabecalho com cidade/data, assinatura e rodape).
    // Esse texto padrao nao e conteudo da noticia e nao serve de contexto para a IA.
    getBodyNewsText() {
      const collapse = (value) => String(value || '').replace(/\s+/g, ' ').trim();
      let text = collapse(this.htmlToPlainText(this.getCurrentBodyHtml()));
      if (!text) return '';

      (this.userHeaders || []).forEach((header) => {
        const pattern = this.userHeaderToRegexSource(header?.name);
        if (pattern) text = text.replace(new RegExp(`^\\s*${pattern}\\s*-?`, 'i'), ' ');
      });

      [...(this.signatures || []), this.contentFooter]
        .map(item => collapse(this.htmlToPlainText(item)))
        .filter(Boolean)
        .forEach((item) => {
          text = text.split(item).join(' ');
        });

      return collapse(text).replace(/^[\s-]+|[\s-]+$/g, '');
    },

    // Modelo do cabecalho (ex.: "Porto Alegre, dd de mm de aaaa") como regex que aceita qualquer data
    userHeaderToRegexSource(template) {
      if (!template || typeof template !== 'string') return '';
      return template
        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        .replace('Mes', '__MONTH__')
        .replace('dd', '\\d{1,2}')
        .replace('DD', '\\d{1,2}')
        .replace('mm', '__MONTH__')
        .replace('MM', '__MONTH__')
        .replace('aaaa', '\\d{4}')
        .replace('AAAA', '\\d{4}')
        .replace(/__MONTH__/g, '[^\\s,]+');
    },

    getAiAssistSourceHtml(target) {
      if (target === 'body') return this.getCurrentBodyHtml();
      if (target === 'title') return this.plainTextToHtml(this.form?.title?.value || '');
      if (target === 'summary') return this.plainTextToHtml(this.form?.summary?.value || '');
      if (target === 'hat') return this.plainTextToHtml((this.form?.hat?.value || []).map(h => h.name).join(', '));
      if (target === 'tags') return this.$refs[`${this.instance}-send-news-editor-form`].text || this.getCurrentBodyHtml();
      return '';
    },

    getCurrentBodyHtml() {
      const editorFormRef = this.$refs[`${this.instance}-send-news-editor-form`];
      const editorModalRef = this.$refs[`${this.instance}-send-news-editor-modal`];

      return (
        (editorModalRef && typeof editorModalRef.body === 'string' ? editorModalRef.body : null) ||
        (editorFormRef && typeof editorFormRef.body === 'string' ? editorFormRef.body : null) ||
        this.form.body.value ||
        ''
      );
    },

    async aiEditBodyRequest({ html, prompt }) {
      // Sem texto na integra nao ha o que editar: a instrucao passa a criar a integra do zero
      if (!this.htmlToPlainText(html).trim()) {
        return this.aiBodyCreateRequest({ prompt });
      }
      // For backward compatibility, this now acts as an improve function
      // Send all available context for better improvement suggestions
      const requestData = { html, prompt };
      
      // Add title if available
      if (this.form.title.value && this.form.title.value.trim()) {
        requestData.title = this.form.title.value.trim();
      }
      
      // Add summary if available
      if (this.form.summary.value && this.form.summary.value.trim()) {
        requestData.summary = this.form.summary.value.trim();
      }
      
      // Add hat (chapeu) if available
      if (this.form.hat.value && this.form.hat.value.length > 0) {
        requestData.hat = this.form.hat.value.map(item => item.name);
      }
      
      // Add tags if available
      if (this.form.tags.value && this.form.tags.value.length > 0) {
        requestData.tags = this.form.tags.value.map(item => item.name);
      }
      
      // Add subjects if available
      if (this.form.subjects.value && this.form.subjects.value.length > 0) {
        requestData.subjectsName = this.form.subjects.value.map(item => item.name);
      }

      // Add language code from selected country
      requestData.languageCode = this.selectedLanguageCode;

      const response = await newsService.aiEditBody(requestData, new URLSearchParams());
      return response?.html || '';
    },

    async aiSuggestionsRequest({ html }) {
      // For backward compatibility, this now acts as a general suggestion function
      // Send all available context for better suggestions
      const requestData = { html };
      
      // Add title if available
      if (this.form.title.value && this.form.title.value.trim()) {
        requestData.title = this.form.title.value.trim();
      }
      
      // Add summary if available
      if (this.form.summary.value && this.form.summary.value.trim()) {
        requestData.summary = this.form.summary.value.trim();
      }
      
      // Add hat (chapeu) if available
      if (this.form.hat.value && this.form.hat.value.length > 0) {
        requestData.hat = this.form.hat.value.map(item => item.name);
      }
      
      // Add tags if available
      if (this.form.tags.value && this.form.tags.value.length > 0) {
        requestData.tags = this.form.tags.value.map(item => item.name);
      }
      
      // Add subjects if available
      if (this.form.subjects.value && this.form.subjects.value.length > 0) {
        requestData.subjectsName = this.form.subjects.value.map(item => item.name);
      }
      
      // Add content type if available
      
      // Add language code from selected country
      requestData.languageCode = this.selectedLanguageCode;

      const response = await newsService.aiSuggestions(requestData, new URLSearchParams());
      return response?.suggestions || [];
    },

    // NEW METHODS FOR SPECIFIC FUNCTIONS

    async aiTitleSuggestionsRequest() {
      // Generate title suggestions based on full context
      const requestData = {};
      
      // Add title if available (current title for refinement)
      if (this.form.title.value && this.form.title.value.trim()) {
        requestData.title = this.form.title.value.trim();
      }
      
      // Add summary if available
      if (this.form.summary.value && this.form.summary.value.trim()) {
        requestData.summary = this.form.summary.value.trim();
      }
      
      // Add body if available
      const bodyHtml = this.getCurrentBodyHtml();
      if (bodyHtml && this.getBodyNewsText()) { // so cabecalho/assinatura nao e conteudo
        requestData.body = bodyHtml;
      }
      
      // Add hat (chapeu) if available
      if (this.form.hat.value && this.form.hat.value.length > 0) {
        requestData.hat = this.form.hat.value.map(item => item.name);
      }
      
      // Add tags if available
      if (this.form.tags.value && this.form.tags.value.length > 0) {
        requestData.tags = this.form.tags.value.map(item => item.name);
      }
      
      // Add subjects if available
      if (this.form.subjects.value && this.form.subjects.value.length > 0) {
        requestData.subjectsName = this.form.subjects.value.map(item => item.name);
      }
      
      // Add content type if available
      // TODO: Determine content type from form - for now we'll omit
      
      // Add language code from selected country
      requestData.languageCode = this.selectedLanguageCode;

      const response = await newsService.aiTitleSuggestions(requestData, new URLSearchParams());
      const suggestions = response?.suggestions || [];
       
       // Return the first valid suggestion, or empty string if none
       if (suggestions.length > 0) {
         return suggestions[0];
       }
       return '';
     },

    async aiSummarySuggestionsRequest() {
      // Generate summary suggestions based on full context
      const requestData = {};
      
      // Add title if available
      if (this.form.title.value && this.form.title.value.trim()) {
        requestData.title = this.form.title.value.trim();
      }
      
      // Add body if available
      const bodyHtml = this.getCurrentBodyHtml();
      if (bodyHtml && this.getBodyNewsText()) { // so cabecalho/assinatura nao e conteudo
        requestData.body = bodyHtml;
      }
      
      // Add hat (chapeu) if available
      if (this.form.hat.value && this.form.hat.value.length > 0) {
        requestData.hat = this.form.hat.value.map(item => item.name);
      }
      
      // Add tags if available
      if (this.form.tags.value && this.form.tags.value.length > 0) {
        requestData.tags = this.form.tags.value.map(item => item.name);
      }
      
      // Add subjects if available
      if (this.form.subjects.value && this.form.subjects.value.length > 0) {
        requestData.subjectsName = this.form.subjects.value.map(item => item.name);
      }
      
      // Add current summary if available (for refinement)
      if (this.form.summary.value && this.form.summary.value.trim()) {
        requestData.summary = this.form.summary.value.trim();
      }

       // Add language code from selected country
       requestData.languageCode = this.selectedLanguageCode;
       
       const response = await newsService.aiSummarySuggestions(requestData, new URLSearchParams());
       const suggestions = response?.suggestions || [];
       
       // Return the first valid suggestion, or empty string if none
       if (suggestions.length > 0) {
         return suggestions[0];
       }
       return '';
     },

    async aiBodyCreateRequest({ prompt } = {}) {
      // Create body content from context (and the user's instructions, when given)
      const requestData = {};

      if (prompt && prompt.trim()) {
        requestData.instructions = prompt.trim();
      }
      
      // Add title if available
      if (this.form.title.value && this.form.title.value.trim()) {
        requestData.title = this.form.title.value.trim();
      }
      
      // Add summary if available
      if (this.form.summary.value && this.form.summary.value.trim()) {
        requestData.summary = this.form.summary.value.trim();
      }
      
      // Add hat (chapeu) if available
      if (this.form.hat.value && this.form.hat.value.length > 0) {
        requestData.hat = this.form.hat.value.map(item => item.name);
      }
      
      // Add tags if available
      if (this.form.tags.value && this.form.tags.value.length > 0) {
        requestData.tags = this.form.tags.value.map(item => item.name);
      }
      
      // Add subjects if available
      if (this.form.subjects.value && this.form.subjects.value.length > 0) {
        requestData.subjectsName = this.form.subjects.value.map(item => item.name);
      }
      
      // Add content type if available
      // TODO: Determine content type from form - for now we'll omit
      
      // Add language code from selected country
      requestData.languageCode = this.selectedLanguageCode;

      const response = await newsService.aiBodyCreate(requestData, new URLSearchParams());
      return response?.html || '';
    },

    async aiBodyImproveRequest({ html }) {
      // Improve existing body content with context
      const requestData = { html };
      
      // Add title if available
      if (this.form.title.value && this.form.title.value.trim()) {
        requestData.title = this.form.title.value.trim();
      }
      
      // Add summary if available
      if (this.form.summary.value && this.form.summary.value.trim()) {
        requestData.summary = this.form.summary.value.trim();
      }
      
      // Add hat (chapeu) if available
      if (this.form.hat.value && this.form.hat.value.length > 0) {
        requestData.hat = this.form.hat.value.map(item => item.name);
      }
      
      // Add tags if available
      if (this.form.tags.value && this.form.tags.value.length > 0) {
        requestData.tags = this.form.tags.value.map(item => item.name);
      }
      
      // Add subjects if available
       if (this.form.subjects.value && this.form.subjects.value.length > 0) {
         requestData.subjectsName = this.form.subjects.value.map(item => item.name);
       }
       
       // Add content type if available
       // TODO: Determine content type from form - for now we'll omit

       // Add language code from selected country
       requestData.languageCode = this.selectedLanguageCode;
       
       const response = await newsService.aiBodyImprove(requestData, new URLSearchParams());
       return response?.html || '';
     },

      async aiTagsSuggestionsRequest() {
        const requestData = {};
        
        // Add title if available (current title for refinement)
        if (this.form.title.value && this.form.title.value.trim()) {
          requestData.title = this.form.title.value.trim();
        }
        
        // Add summary if available
        if (this.form.summary.value && this.form.summary.value.trim()) {
          requestData.summary = this.form.summary.value.trim();
        }
        
        // Add body if available
        const bodyHtml = this.getCurrentBodyHtml();
        if (bodyHtml && this.getBodyNewsText()) { // so cabecalho/assinatura nao e conteudo
          requestData.body = bodyHtml;
        }
        
        // Add hat (chapeu) if available
        if (this.form.hat.value && this.form.hat.value.length > 0) {
          requestData.hat = this.form.hat.value.map(item => item.name);
        }
              
        // Add subjects if available
        if (this.form.subjects.value && this.form.subjects.value.length > 0) {
          requestData.subjectsName = this.form.subjects.value.map(item => item.name);
        }
        
        // Add language code from selected country
        requestData.languageCode = this.selectedLanguageCode;

        const response = await newsService.aiTagsSuggestions(requestData, new URLSearchParams());
        return response?.suggestions || [];
      },

      async aiHatSuggestionsRequest() {
        // Generate title suggestions based on full context
        const requestData = {};
        
        // Add title if available (current title for refinement)
        if (this.form.title.value && this.form.title.value.trim()) {
          requestData.title = this.form.title.value.trim();
        }
        
        // Add summary if available
        if (this.form.summary.value && this.form.summary.value.trim()) {
          requestData.summary = this.form.summary.value.trim();
        }
        
        // Add body if available
        const bodyHtml = this.getCurrentBodyHtml();
        if (bodyHtml && this.getBodyNewsText()) { // so cabecalho/assinatura nao e conteudo
          requestData.body = bodyHtml;
        }
        
        // Add hat (chapeu) if available
        if (this.form.hat.value && this.form.hat.value.length > 0) {
          requestData.hat = this.form.hat.value.map(item => item.name);
        }
        
        // Add tags if available
        if (this.form.tags.value && this.form.tags.value.length > 0) {
          requestData.tags = this.form.tags.value.map(item => item.name);
        }
        
        // Add subjects if available
        if (this.form.subjects.value && this.form.subjects.value.length > 0) {
          requestData.subjectsName = this.form.subjects.value.map(item => item.name);
        }
        
        // Add language code from selected country
        requestData.languageCode = this.selectedLanguageCode;

        const response = await newsService.aiHatSuggestions(requestData, new URLSearchParams());
        return response?.suggestions || [];
      },

      applyAiAssist(html) {
      if (!html) return;

      if (this.aiAssistTarget === 'body') {
        this.form.body.value = html;

        if (this.$refs[`${this.instance}-send-news-editor-form`]) {
          this.$refs[`${this.instance}-send-news-editor-form`].body = html;
        }
        if (this.$refs[`${this.instance}-send-news-editor-modal`]) {
          this.$refs[`${this.instance}-send-news-editor-modal`].body = html;
        }

        messagesNotifyHelper.successNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.BodyUpdated'));
        return;
      }

      const text = this.htmlToPlainText(html);
      if (this.aiAssistTarget === 'title') {
        this.form.title.value = text;
        messagesNotifyHelper.successNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.TitleUpdated'));
        return;
      }

      if (this.aiAssistTarget === 'summary') {
        this.form.summary.value = text;
        messagesNotifyHelper.successNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.SummaryUpdated'));
      }
      if (this.aiAssistTarget === 'hat') {
        this.form.hat.value = [{ id: null, name: text }];
        messagesNotifyHelper.successNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.HatUpdated'));
      }
    },
    applyAiAssistTags(val) {
      if (this.aiAssistTarget === 'tags') {
        // console.log('[applyAiAssistTags]', val);
        if (val && val.length > 0) {
          this.form.tags.value = this.form.tags.value.concat(val.map(item => {return {id: null, name: item, aiGenerated: true}}));
          messagesNotifyHelper.successNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.TagsUpdated'));
        }
      }
    },

    onAiAssistError(message, error) {
      // Erros do backend ja foram notificados (traduzidos) pelo interceptor do axios
      if (messagesNotifyHelper.isAlreadyNotified(error)) return;
      messagesNotifyHelper.errorNotify(this.$t('AI_MESSAGES.Title'), message || this.$t('AI_ASSIST.CouldNotGenerateVersion'));
    },
    onChangeSubjectValue(val) {
      console.log("form.subjects.value: ", val);
      if (val.findIndex((item) => item.name.indexOf("Manchete") >= 0) >= 0) {
        this.form.importance.value = true;
        this.typeMessageModel = this.typeMessages.filter(
            (item) => item.id == 1
        );
      }
      if (val.length > 0) {
        // this.topic = val.map(item => item.topic).flat(1);
        // this.form.topic.value = Object.assign({}, this.topic);
        const generalIndex = val.findIndex(item => item.general);
        if (generalIndex >= 0) { // general auto select other subjects
          const general_autoselect = val[generalIndex].general_autoselect;
          if (general_autoselect && general_autoselect.length > 0) {
            // console.log(this.subjects.filter(item => general.findIndex(g => g.id == item.id) >= 0));
            this.form.subjects.value = this.userCore.subjects.filter(item => general_autoselect.findIndex(g => g.id == item.id) >= 0);
            this.subjectModelCheckbox = JSON.parse(JSON.stringify(this.form.subjects.value));
            return;
            // for (let index = 0; index < general.length; index++) {
            //   if (this.form.subjects.value.findIndex(item => item.id == general[index].id) < 0) this.form.subjects.value.push()
            // }
          }
        }
        // this.loadContentBySubject();
        const keepSourceChannel = this.keepLoadedSourceChannel;
        this.keepLoadedSourceChannel = false;
        this.loadDataSubject(val, keepSourceChannel);
      } else {
        this.keepLoadedSourceChannel = false;
        this.topic = [];
        this.form.topic.value = [];
        this.newsContent = [];
        this.form.newsContent.value = [];
        this.form.source.value = [];
        this.form.channel.value = [];
        // this.origins = [];
        // this.channels = [];
      }
    },
    onChangeEventScheduleDurationDateTo(val) {
      console.log('[onChangeEventScheduleDurationDateTo]', val);
    },
    getYesterdayDateFrom(val) {
      const dt = new Date(val);
      // dt.setDate(dt.getDate() - 1);
      return dt;
    },
    hasUserCoreCategorie(field) {
      if (!this.userCore || !this.userCore.categories) return false;
      return this.userCore.categories.findIndex(item => item == field) >= 0;
    },
    updateTime() {
      this.totalSeconds++;
      const minutes = Math.floor(this.totalSeconds / 60);
      const seconds = this.totalSeconds % 60;
      const newTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      this.$set(this, 'formattedTime', newTime);
    },
    loadAssetReference() {
      this.assetReference = [];
      const params = new URLSearchParams();
      // params.append("origins", this.getOriginWithChannelOrigin().join(","));
      dropdownService.getAssetReference(params).then((res) => {
        this.assetReference = res;
      });
    },
    initComponent() {
      if (this.currentTab) {
        if (this.currentTab.form) {
          this.form = Object.create(this.currentTab.form);
          this.templateSelected = this.listTemplate.find(
              (item) => item.id == this.form.layout
          );
        } else {
          switch (this.startTemplate) {
            case AppConstants.NEWS_LAYOUT.NEWS:
              this.form = Object.assign({}, formTemplates.newsFields());
              this.templateSelected = this.listTemplate.find(
                  (item) => item.id == AppConstants.NEWS_LAYOUT.NEWS
              );
              break;
            case AppConstants.NEWS_LAYOUT.FLASHES:
              this.form = Object.assign({}, formTemplates.flashesFields());
              this.templateSelected = this.listTemplate.find(
                  (item) => item.id == AppConstants.NEWS_LAYOUT.FLASHES
              );
              break;
            case AppConstants.NEWS_LAYOUT.TVCAST:
              this.form = Object.assign({}, formTemplates.tvFields());
              this.templateSelected = this.listTemplate.find(
                  (item) => item.id == AppConstants.NEWS_LAYOUT.TVCAST
              );
              break;
            case AppConstants.NEWS_LAYOUT.PODCAST:
              this.form = Object.assign({}, formTemplates.podcastFields());
              this.templateSelected = this.listTemplate.find(
                  (item) => item.id == AppConstants.NEWS_LAYOUT.PODCAST
              );
              break;
            case AppConstants.NEWS_LAYOUT.REPORT:
              this.form = Object.assign({}, formTemplates.reportFields());
              this.templateSelected = this.listTemplate.find(
                  (item) => item.id == AppConstants.NEWS_LAYOUT.REPORT
              );
              break;
            case AppConstants.NEWS_LAYOUT.EVENT:
              this.form = Object.assign({}, formTemplates.eventFields());
              this.templateSelected = this.listTemplate.find(
                  (item) => item.id == AppConstants.NEWS_LAYOUT.EVENT
              );
              break;
            default:
              this.form = Object.assign({}, formTemplates.newsFields());
              this.templateSelected = this.listTemplate.find(
                  (item) => item.id == AppConstants.NEWS_LAYOUT.NEWS
              );
              break;
          }
        }
      }

      this.updateTabName(this.templateSelected.name);
      // if (this.form.related_news.value.length == 0) {
      //   this.createNewRelatedNews();
      // }
      if (this.subjectViewType == AppConstants.SUBJECT_VIEWTYPE_CHECKBOX) {
        this.displaySubjectViewTypeCheckbox = true;
      }
      this.displayForm = true;
      // this.displayOverlay = true;
      this.loadData();
      self = this;
    },
    checkTemplateUpdated(data, callback) {
      // if (this.currentUserTemplates.findIndex(item => item.isUpdated) >= 0) {
      if (data.isUpdated) {
        messageDialogHelper.displayConfirmMessage(
            this.$t('SEND_NEWS.Template_Change_Title'),
            this.$t('SEND_NEWS.Template_Change_Confirm'),
            () => {
              callback(true);
            }
        );
      } else {
        callback(false);
      }
    },
    onEditSelectedUserTemplateName() {
      messageDialogHelper.displayWithInputTextSubmit(this.$t('SEND_NEWS.Template_Enter_New_Name'),(val) => {
        if (val) {
          this.userTemplate.name = val;
          this.form.template_name.value = val;
          this.userTemplate.isUpdated = true;
        } else {
          messagesNotifyHelper.warningNotify(this.$t('SEND_NEWS.Template_Rename_Title'), this.$t('SEND_NEWS.Template_Name_Required'));
        }
      });
    },
    clearUserTemplate(clearForm = false) {
      this.userTemplate = { name: '', data: {}};

      if (clearForm) {
        // reset form to news layout
        this.form = Object.assign({}, formTemplates.newsFields());
        this.templateSelected = this.listTemplate.find(
            (item) => item.id == AppConstants.NEWS_LAYOUT.NEWS
        );

        this.loadData();
      }
    },
    newUserTemplate() {
      this.clearUserTemplate();
      this.form.template_name.value = '';
    },
    saveUserTemplate() {
      if (this.userTemplate.name) {
        this.onSubmit(AppConstants.EVENT_STATUS.TEMPLATE);
      } else {
        messageDialogHelper.displayWithInputTextSubmit(this.$t('SEND_NEWS.Template_Enter_Name'),(val) => {
          if (val) {
            this.userTemplate.name = val;
            this.form.template_name.value = val;
            this.onSubmit(AppConstants.EVENT_STATUS.TEMPLATE);
          } else {
            messagesNotifyHelper.warningNotify(this.$t('SEND_NEWS.Template_Save'), this.$t('SEND_NEWS.Template_Name_Required'));
          }
        });
      }
    },
    onDeleteUserTemplate() {
      messageDialogHelper.displayConfirmMessage(
          this.$t('SEND_NEWS.Template_Delete'),
          this.$t('SEND_NEWS.Template_Delete_Confirm', { name: this.userTemplate.name }),
          () => {
            const form = {
              name: this.userTemplate.name,
              data: { _id: this.userTemplate.data._id }
            }
            newsService.deleteUserTemplate(form, new URLSearchParams())
                .then(() => {
                  messagesNotifyHelper.successNotify(this.$t('SEND_NEWS.Template_Delete'), this.$t('SEND_NEWS.Template_Deleted_Success', { name: form.name }));
                  const index = this.currentUserTemplates.findIndex(item => item.name == this.userTemplate.name);
                  if (index >= 0) {
                    this.currentUserTemplates.splice(index, 1);
                  }
                  this.clearUserTemplate(true);
                })
                .catch(err => console.log(err));
          }
      );
    },
    openImage() {
      this.$refs['imageMaximized'].show()
    },
    getThumbPathStyle(image) {
      if (image) {
        return `background-image:url('${image}')`;
      }
      return '';
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      event.currentTarget.classList.add("bg-dragover");
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.remove("bg-dragover");
    },
    dropItem(event) {
      event.preventDefault();
      // console.log(event)
      this.onPasteData(event);
      this.dragleave(event);
    },
    onPasteData(event) {
      // console.log('[paste]', event);
      // console.log('[paste]', event.clipboardData);
      // console.log('[paste]', event.clipboardData.files[0].type);
      let file = null;
      // event from paste
      if (event.clipboardData && event.clipboardData.files.length > 0) {
        file = event.clipboardData.files[event.clipboardData.files.length - 1];
      } else if (event.target.files) {
        // event from drag drop
        file = event.target.files[event.target.files.length - 1];
      } else if (event.dataTransfer && event.dataTransfer.files) {
        file = event.dataTransfer.files[event.dataTransfer.files.length - 1];
      }

      if (!file) {
        console.log("Document empty");
        return;
      }

      if (
          AppConstants.MEDIA_DOCUMENT_TYPE.findIndex(
              (item) => item.values.findIndex((val) => file.type.includes(val)) >= 0
          ) >= 0
      ) {
        const totalSize = file.size / 1024 / 1024;
        if (totalSize > AppConstants.MEDIA_MAX_SIZE) {
          messagesNotifyHelper.warningNotify(
              this.$t("DIALOG_MESSAGES.Title"),
              this.$t("MEDIA_LIBRARY.Alert_Limit_Media_Size")
          );
          return;
        }
        if (
            AppConstants.MEDIA_AUDIO_EXTENSIONS.findIndex((item) =>
                file.type.includes(item)
            ) >= 0
        ) {
          this.openAudioLibraryDocument(file);
          return;
        }
        if (
            AppConstants.MEDIA_DOCUMENT_EXTENSIONS.findIndex((item) =>
                file.type.includes(item)
            ) >= 0
        ) {
          this.openImageLibraryDocument(file);
          return;
        }
        if (
            AppConstants.MEDIA_IMAGE_EXTENSIONS.findIndex((item) =>
                file.type.includes(item)
            ) >= 0
        ) {
          if (!this.thumbPodcastLibraryData.file) {
            this.openImageLibraryThumbPodcast(file);
            return;
          }
          if (!this.thumbVideoLibraryData.file) {
            this.openImageLibraryThumbVideo(file);
            return;
          }
          if (!this.thumbLibraryData.file) {
            this.openImageLibraryThumb(file);
            return;
          }
          if (!this.imageLibraryData.file) {
            this.openImageLibraryImage(file);
          }
          return;
        }
      }
    },
    getTranslateFieldHat(item) {
      let currLocale = getCodeLang(this.currentUser.locale);
      return item[`hat${currLocale}`] || item.name;
      // if (this.form.country.value[0]) {
      //   return item[`hat${this.form.country.value[0].locale}`];
      // }
      // return item.name;
    },
    getTranslateFieldName(item) {
      let currLocale = getCodeLang(this.currentUser.locale);
      return item[`name${currLocale}`] || item.name;
      // if (this.form.country.value[0]) {
      //   return item[`name${this.form.country.value[0].locale}`];
      // }
      // return item.name;
    },
    onSelectSubjectCheckbox(sub) {
      const index = this.subjectModelCheckbox.findIndex(
          (item) => item.id == sub.id
      );
      if (index < 0) {
        this.subjectModelCheckbox.push(sub);
      } else {
        this.subjectModelCheckbox.splice(index, 1);
      }
      this.form.subjects.value = JSON.parse(JSON.stringify(this.subjectModelCheckbox));
    },
    subjectSelected(sub) {
      return (
          this.subjectModelCheckbox.findIndex((item) => item.id == sub.id) >= 0
      );
    },
    clearSubjects() {
      this.form.subjects.value = [];
      this.subjectModelCheckbox = [];
    },
    getSpotifyIdFromUrl(url) {
      return formatFieldHelper.getSpotifyId(url);
    },
    displayCreateRelatedNewsButton(item) {
      if (!item) return true;
      if (this.form.related_news.value.length == 0) return true;
      if (!this.form.related_news.value) return true;
      return (
          this.form.related_news.value[this.form.related_news.value.length - 1]
              .id == item.id
      );
    },
    selectRecord(r) {
      if (!r) {
        this.audioBlob = null;
        return;
      }
      // console.log('record selected...');
      // console.log(r.blob);
      this.audioBlob = r.blob;
    },
    // openRelatedNewsCard() {
    //   if (this.form.related_news.value.length == 0) {
    //     this.createNewRelatedNews();
    //   }
    //   this.displayRelatedNewsCard = !this.displayRelatedNewsCard;
    //   // console.log(this.$refs[`${this.instance}-scrollbar`]);
    //   setTimeout(() => {
    //     this.$refs[`${this.instance}-scrollbar`].$el.scrollTop =
    //       this.$refs[`${this.instance}-scrollbar`].$el.scrollHeight;
    //   }, 100);
    // },
    hotKeySendPublish() {
      messageDialogHelper.displayConfirmMessage(
          this.$t('SEND_NEWS.Confirm_Publish_Title'),
          this.$t('SEND_NEWS.Confirm_Publish_Text'),
          () => {
            this.sendPublish();
          }
      );
    },
    hotKeySavePublish() {
      messageDialogHelper.displayConfirmMessage(
          this.$t('SEND_NEWS.Confirm_Save_Title'),
          this.$t('SEND_NEWS.Confirm_Save_Text'),
          () => {
            this.sendStore();
          }
      );
    },
    hotKeyDiscartPublish() {
      messageDialogHelper.displayConfirmMessage(
          this.$t('SEND_NEWS.Confirm_Discard_Title'),
          this.$t('SEND_NEWS.Confirm_Draft_Text'),
          () => {
            this.onSubmit(AppConstants.EVENT_STATUS.DRAFT);
          }
      );
    },
    hasFieldError(field) {
      return this.messageErrors.findIndex((item) => item.field == field) >= 0;
    },
    getMessageFieldError(field) {
      const data = this.messageErrors.find((item) => item.field == field);
      if (data) {
        return data.message;
      }
      return "";
    },
    onSelectDuration(data) {
      this.form[data.field].value = data.date;
      this.$refs[`${this.instance}-modal-highlight-date`].hide();
    },
    openSelectDurationModal(field, highlight = false, inLive = false) {
      setTimeout(() => {
        this.$refs[`${this.instance}-modal-highlight-date`].show();
        this.$nextTick(() => {
          this.$refs[`${this.instance}-send-news-select-duration`].field =
              field;
          this.$refs[
              `${this.instance}-send-news-select-duration`
              ].highlight_period = highlight;
          this.$refs[
              `${this.instance}-send-news-select-duration`
              ].inLive_period = inLive;
        });
      }, 200);
    },
    onPreviewUrl(url) {
      this.previewURL = url;
      this.$refs[`${this.instance}-preview-url-modal`].show();
    },
    onMaximizeEditor() {
      this.form.body.value =
          this.$refs[`${this.instance}-send-news-editor-form`].body;
      this.displayContentEditor = false;
      this.displayContentEditorMaximized = true;
      setTimeout(() => {
        this.$refs[`${this.instance}-modal-content-editor`].show();
        this.$nextTick(() => {
          this.$refs[`${this.instance}-modal-content-editor`].body =
              this.form.body.value;
        });
      }, 200);
    },
    onMinimizeEditor() {
      this.form.body.value =
          this.$refs[`${this.instance}-send-news-editor-modal`].body;
      this.$refs[`${this.instance}-send-news-editor-form`].body =
          this.form.body.value;
      // this.form.body.value = value;
      this.displayContentEditor = true;
      this.displayContentEditorMaximized = false;
      this.$refs[`${this.instance}-modal-content-editor`].hide();
    },
    updateTabName(text) {
      if (this.currentTab) {
        this.$store.dispatch("report/updateTabName", {
          index: this.currentTab.index,
          title: text,
        });
        setTimeout(() => {
          this.$emit("update-tab");
        }, 500);
      }
    },
    // createNewRelatedNews() {
    //   this.form.related_news.value.push({
    //     id: this.getLastIdFromRelatedNewsForm(),
    //     type: this.related_news_type[0],
    //     news: {},
    //     title: "",
    //   });
    // },
    openHistNewsFlashesModal() {
      console.log("openHistNewsFlashes");
      this.$refs[`${this.instance}-modal-hist-flashes`].show();
    },
    closeHistNewsFlashes() {
      this.$refs[`${this.instance}-modal-hist-flashes`].hide();
    },
    openLinkInviteModal() {
      console.log("openHistNewsFlashes");
      this.$refs[`${this.instance}-modal-link-invite`].show();
    },
    closeLinkInviteModal() {
      this.$refs[`${this.instance}-modal-link-invite`].hide();
    },
    searchRelatedNews() {
      this.$refs[`${this.instance}-modal-related-news`].show();
    },
    // openRelatedNews(id) {
    //   console.log("openRelatedNews: ", id);
    //   this.$refs[`${this.instance}-modal-related-news`].show();
    //   this.$nextTick(() => {
    //     this.$refs[`${this.instance}-list-related-news`].currentRelatedNewsId =
    //       id;
    //   });
    // },
    onSelectRelatedNews(item) {
      if (!this.form.related_news.news) {
        this.form.related_news.news = [];
      }

      const related_news_ids = this.form.related_news.news.map(item => item.id);

      if (item && !related_news_ids.includes(item.news.id)) {
        this.form.related_news.news.push({
          id: item.news.id,
          title: item.news.content.title.data
        })
      } else {
        messagesNotifyHelper.warningNotify(
            this.$t("DIALOG_MESSAGES.Title"),
            this.$t("SEND_NEWS.Related_News_Already_Registered")
        );
      }

      this.$refs[`${this.instance}-modal-related-news`].hide();
      this.$forceUpdate();
    },
    // onSelectRelatedNews(item) {
    //   const index = this.form.related_news.value.findIndex(
    //     (n) => n.id == item.id
    //   );
    //   if (index >= 0) {
    //     this.form.related_news.value[index].news = item.news;
    //     this.form.related_news.value[index].title =
    //       item.news.content.title.data;
    //     // this.form.related_news.value.push({news: item.news, type: this.related_news_type[1], id: this.getLastIdFromRelatedNewsForm()})
    //   }
    //   this.$refs[`${this.instance}-modal-related-news`].hide();
    // },
    getLastIdFromRelatedNewsForm() {
      if (this.form.related_news.value.length == 0) {
        return 1;
      }
      return (
          this.form.related_news.value[this.form.related_news.value.length - 1]
              .id + 1
      );
    },
    unlinkRelatedNews(item) {
      const index = this.form.related_news.value.findIndex(
          (n) => n.id == item.id
      );
      this.form.related_news.value[index].news = {};
    },

    // removeNewRelatedNews() {
    //   this.relatedNews = {}
    // },
    deleteRelatedNews(item) {
      const index = this.form.related_news.news.indexOf(item);

      if (index !== -1) {
        this.form.related_news.news.splice(index, 1);
      }

      this.$forceUpdate();
    },
    // removeRelatedNews(item) {
    //   this.form.related_news[item].news = {}
    //   const index = this.form.related_news.value.findIndex(
    //     (n) => n.id == item.id
    //   );
    //   if (index >= 0) {
    //     this.form.related_news.value.splice(index, 1);
    //   }
    //   if (this.form.related_news.value.length == 0) {
    //     this.createNewRelatedNews();
    //   }
    // },
    onSelectFlashes(item) {
      console.log("[onSelectFlashes]", item);
      this.form.title.value = item.content.title.data;
      if (this.form.title.value.indexOf("*") >= 0) {
        this.form.title.value = this.form.title.value.replace("*", "");
      }
      // console.log('[Source]', source);
      this.form.source.value = [item.source];
      this.typeMessageModel = this.typeMessages.filter(
          (t) => t.id === item.importance
      );
      this.typeMessageSaved = this.typeMessageModel;
      this.form.importance.value = item.importance == 1;

      this.form.subjects.value = item.subjects;
      this.subjectModelCheckbox = item.subjects.map((item) => item.id);
      this.form.tags.value = item.tags;
      this.closeHistNewsFlashes();
    },
    onSelectLinkInvite(item) {
      // console.log('[onSelectLinkInvite]', item);
      this.form.eventScheduleRelatedNews.value = {
        id: item["_id"],
        _id: item["_id"],
        name: item.content.title.data,
      };
      if (item.eventScheduleDuration_dateTo) {
        this.form.eventScheduleDuration_dateTo.value =
            item.eventScheduleDuration_dateTo;
      }
      if (item.eventScheduleDuration_hourTo) {
        this.form.eventScheduleDuration_hourTo.value =
            item.eventScheduleDuration_hourTo;
      }
      if (item.eventScheduleDuration_dateFrom) {
        this.form.eventScheduleDuration_dateFrom.value =
            item.eventScheduleDuration_dateFrom;
      }
      if (item.eventScheduleDuration_hourFrom) {
        this.form.eventScheduleDuration_hourFrom.value =
            item.eventScheduleDuration_hourFrom;
      }
      // if (item.eventScheduleAllDay) {
      //   this.form.eventScheduleAllDay.value = item.eventScheduleAllDay;
      // }
      // if (item.eventScheduleLocation) {
      //   this.form.eventScheduleLocation.value = item.eventScheduleLocation;
      // }
      if (item.eventScheduleLink) {
        this.form.eventScheduleLink.value = item.eventScheduleLink;
      }
      // if (item.eventSchedulePrice) {
      //   this.form.eventSchedulePrice.value = item.eventSchedulePrice;
      // }
      this.closeLinkInviteModal();
    },
    isDraft(eventStatus) {
      return eventStatus == AppConstants.EVENT_STATUS.DRAFT;
    },
    customButtonClick() {
      alert("Button clicked!");
    },
    // Texto padrao do corpo do Pisca no idioma do (primeiro) pais selecionado
    getFlashesBody() {
      const country = this.form.country.value && this.form.country.value[0];
      const locale = country && ENUM_LOCALE_LIST.find((item) => item.name === country.locale);
      return this.$t("SEND_NEWS.Flashes_Body", locale ? locale.locale : "pt");
    },
    isFlashesBody(text) {
      return Object.keys(this.$i18n.messages).some((locale) => this.$t("SEND_NEWS.Flashes_Body", locale) === text);
    },
    togglePisca() {
      if (this.isFlashes) {
        this.form.body.value = this.getFlashesBody();
        // this.$refs[`${this.instance}-send-news-editor-form`].body = this.form.body.value;
      }
    },
    onRemoveThumbPodcastSelected() {
      this.thumbPodcastLibraryData = {};
    },
    onRemoveThumbSelected() {
      this.thumbLibraryData = {};
    },
    onRemoveThumbVideoSelected() {
      this.thumbVideoLibraryData = {};
    },
    onRemoveImageSelected() {
      this.imageLibraryData = {};
    },
    onRemoveDocumentSelected() {
      this.documentLibraryData = {};
      this.form.download_document.display = false;
      this.form.generate_thumb.display = false;
    },
    onRemoveAudioSelected() {
      this.audioLibraryData = {};
    },
    onRemoveVideoSelected() {
      this.videoLibraryData = {};
      this.form.youtube.display = false;
      this.form.youtube_title.value = '';
      this.form.youtube_description.value = '';
      this.isSendingYoutube = false;
      this.isYoutubeSentSuccess = false;
      this.youtubeVideoId = '';
    },
    onSubmitImageLibrary(data) {
      this.closeModalLibraryImage();
      if (data.newImage) {
        this.imageLibraryData = data.newImage;
      }
      if (data._id) {
        this.imageLibraryData = data;
      }
    },
    onSubmitThumbPodcastLibrary(data) {
      this.closeModalLibraryThumbPodcast();
      if (data.newImage) {
        this.thumbPodcastLibraryData = data.newImage;
      }
      if (data._id) {
        this.thumbPodcastLibraryData = data;
      }
    },
    onSubmitThumbVideoLibrary(data) {
      this.closeModalLibraryThumbVideo();
      if (data.newImage) {
        this.thumbVideoLibraryData = data.newImage;
      }
      if (data._id) {
        this.thumbVideoLibraryData = data;
      }
    },
    onSubmitThumbLibrary(data) {
      this.closeModalLibraryThumb();
      if (data.newImage) {
        this.thumbLibraryData = data.newImage;
      }
      if (data._id) {
        this.thumbLibraryData = data;
      }
    },
    onSubmitDocumentsLibrary(data) {
      this.closeModalLibraryDocument();
      if (data.newDocument) {
        this.documentLibraryData = data.newDocument;
      }
      if (data._id) {
        this.documentLibraryData = data;
      }
      this.form.download_document.display = true;
      if (this.documentLibraryData.extension == 'pdf') {
        this.form.generate_thumb.display = true;
      }
    },
    onSubmitAudioLibrary(data) {
      this.closeModalAudioDocument();
      if (data.newAudio) {
        this.audioLibraryData = data.newAudio;
      }
      if (data._id) {
        this.audioLibraryData = data;
      }
    },
    onSubmitVideoLibrary(data) {
      this.closeModalVideoDocument();
      if (data.newVideo) {
        this.videoLibraryData = data.newVideo;
        this.form.youtube.display = true;
      }
      if (data._id) {
        this.videoLibraryData = data;
        this.form.youtube.display = true;
      }
    },
    openImageLibraryThumbPodcast(pasteData) {
      this.$refs[`${this.instance}-modal-image-library-thumb-podcast`].show();
      if (pasteData) {
        this.$nextTick(() => {
          this.$refs[`${this.instance}-image-library-list-thumb-podcast`].onPaste(
              pasteData
          );
        });
      }
    },
    openImageLibraryThumbVideo(pasteData) {
      this.$refs[`${this.instance}-modal-image-library-thumb-video`].show();
      if (pasteData) {
        this.$nextTick(() => {
          this.$refs[`${this.instance}-image-library-list-thumb-video`].onPaste(
              pasteData
          );
        });
      }
    },
    closeModalLibraryThumbPodcast() {
      if (this.$refs[`${this.instance}-modal-image-library-thumb-podcast`]) {
        this.$refs[`${this.instance}-modal-image-library-thumb-podcast`].hide();
      }
    },
    closeModalLibraryThumbVideo() {
      if (this.$refs[`${this.instance}-modal-image-library-thumb-video`]) {
        this.$refs[`${this.instance}-modal-image-library-thumb-video`].hide();
      }
    },
    openImageLibraryThumb(pasteData) {
      this.$refs[`${this.instance}-modal-image-library-thumb`].show();
      if (pasteData) {
        this.$nextTick(() => {
          this.$refs[`${this.instance}-image-library-list-thumb`].onPaste(
              pasteData
          );
        });
      }
    },
    closeModalLibraryThumb() {
      if (this.$refs[`${this.instance}-modal-image-library-thumb`]) {
        this.$refs[`${this.instance}-modal-image-library-thumb`].hide();
      }
    },
    openImageLibraryImage(pasteData) {
      this.$refs[`${this.instance}-modal-image-library-image`].show();
      if (pasteData) {
        this.$nextTick(() => {
          this.$refs[`${this.instance}-image-library-list-image`].onPaste(
              pasteData
          );
        });
      }
    },
    closeModalLibraryImage() {
      if (this.$refs[`${this.instance}-modal-image-library-image`]) {
        this.$refs[`${this.instance}-modal-image-library-image`].hide();
      }
    },
    openImageLibraryDocument(pasteData) {
      this.$refs[`${this.instance}-modal-image-library-document`].show();
      if (pasteData) {
        this.$nextTick(() => {
          this.$refs[`${this.instance}-image-library-list-document`].onPaste(
              pasteData
          );
        });
      }
    },
    closeModalLibraryDocument() {
      if (this.$refs[`${this.instance}-modal-image-library-document`]) {
        this.$refs[`${this.instance}-modal-image-library-document`].hide();
      }
    },
    openAudioLibraryDocument(pasteData) {
      this.$refs[`${this.instance}-modal-image-library-audio`].show();
      if (pasteData) {
        this.$nextTick(() => {
          this.$refs[`${this.instance}-image-library-list-audio`].onPaste(
              pasteData
          );
        });
      }
    },
    closeModalAudioDocument() {
      if (this.$refs[`${this.instance}-modal-image-library-audio`]) {
        this.$refs[`${this.instance}-modal-image-library-audio`].hide();
      }
    },
    openVideoLibraryDocument(pasteData) {
      this.$refs[`${this.instance}-modal-image-library-video`].show();
      if (pasteData) {
        this.$nextTick(() => {
          this.$refs[`${this.instance}-image-library-list-video`].onPaste(
              pasteData
          );
        });
      }
    },
    closeModalVideoDocument() {
      if (this.$refs[`${this.instance}-modal-image-library-video`]) {
        this.$refs[`${this.instance}-modal-image-library-video`].hide();
      }
    },
    validateVideoFormData() {
      if (!this.videoLibraryData.tags || this.videoLibraryData.tags.length === 0) {
        messagesNotifyHelper.warningNotify(
            "Youtube",
            this.$t("SEND_NEWS.Youtube_Tag_Required")
        );
        this.displayOverlay = false;
        return false;
      }

      if (!this.thumbVideoLibraryData.file) {
        messagesNotifyHelper.warningNotify(
            "Youtube",
            this.$t("SEND_NEWS.Youtube_Thumb_Required")
        );
        this.displayOverlay = false;
        return false;
      }

      if (!this.videoLibraryData.file) {
        messagesNotifyHelper.warningNotify(
            "Youtube",
            this.$t("SEND_NEWS.Youtube_Video_Required")
        );
        this.displayOverlay = false;
        return false;
      }

      if (!this.form.youtube_title.value) {
        messagesNotifyHelper.warningNotify(
            "Youtube",
            this.$t("SEND_NEWS.Youtube_Title_Required")
        );
        this.displayOverlay = false;
        return false;
      }

      if (!this.form.youtube_description.value) {
        messagesNotifyHelper.warningNotify(
            "Youtube",
            this.$t("SEND_NEWS.Youtube_Description_Required")
        );
        this.displayOverlay = false;
        return false;
      }

      return true;
    },
    sendVideoToYoutube() {
      if (this.isYoutubeSentSuccess) {
        const urlYoutubeStudio = `https://studio.youtube.com/video/${this.youtubeVideoId}/edit`;
        window.open(urlYoutubeStudio, '_blank');
        return;
      }

      if (this.isSendingYoutube) {
        return;
      }

      if (!this.validateVideoFormData()) {
        return;
      }

      this.totalSeconds = 0;
      this.intervalId = setInterval(this.updateTime, 1000);

      this.isSendingYoutube = true;
      console.log('Sending video to youtube...');

      const formData = new FormData();

      const videoTitle = this.form.youtube_title.value;
      const videoDescription = this.form.youtube_description.value;

      formData.append("newThumbVideo", this.thumbVideoLibraryData.file);
      formData.append("newVideo", this.videoLibraryData.file);
      formData.append("newVideo_tags", this.videoLibraryData.tags);
      formData.append("newVideo_copyright", this.videoLibraryData.copyright);
      formData.append("newVideo_title", videoTitle);
      formData.append("newVideo_description", videoDescription);

      newsService
          .sendYoutube(formData, new URLSearchParams())
          .then((newsData) => {
            console.log(newsData);
            this.youtubeVideoId = newsData?.youtubeVideoId;
            this.isSendingYoutube = false;
            clearInterval(this.intervalId);
            this.videoLibraryData = newsData.video;
            this.isYoutubeSentSuccess = true;

            messagesNotifyHelper.successNotify(
                "Youtube",
                this.$t("SEND_NEWS.Youtube_Upload_Success")
            );
          })
          .catch((err) => {
            this.isSendingYoutube = false;
            clearInterval(this.intervalId);
            this.displayOverlay = false;
          });
    },
    dateDisabled(ymd) {
      const rightNow = new Date();
      const res = rightNow.toISOString().slice(0, 10).replace(/-/g, "");
      return Number(res) > Number(ymd.replaceAll("-", ""));
    },
    onContextSchedule(ctx) {
      // console.log("contextSchedule: ", ctx);
      this.contextSchedule = ctx;
    },
    publish(typePublish, typeMessage, subjects, tags, newTags) {
      this.form.typeMessage.value = typeMessage;
      this.form.subjects.value = subjects;
      this.subjectModelCheckbox = subjects.map((item) => item.id);
      this.form.tags.value = tags;
      this.form.newTags.value = newTags;

      if (typePublish === AppConstants.EVENT_STATUS.SCHEDULED) {
        this.openScheduleModal();
      } else {
        this.onSubmit(typePublish);
      }
    },
    focusTitle() {
      this.$refs[`${this.instance}-title`].focus();
    },
    focusSummary() {
      this.$refs[`${this.instance}-summary`].focus();
    },
    onSelectAcronyms(item) {
      this.$refs[`${this.instance}-send-news-editor-form`].insertAcronyms(
          item.text
      );
      this.$refs[`${this.instance}-modal-acronyms`].hide();
    },
    onKeyDownTitle(e) {
      if (e.keyCode === 13 && e.shiftKey && this.isFlashes) {
        this.sendPublish();
      }
    },
    onKeyDownContent(e) {
      if (e.keyCode === 9 && !e.shiftKey) {
        // Tab
        e.preventDefault();
        const textarea = this.$refs[`${this.instance}-contentTextarea`];
        const cursortAt = textarea.selectionStart;

        this.form.body.value = `${textarea.value.substring(
            0,
            cursortAt
        )}\t${textarea.value.substring(
            textarea.selectionEnd,
            textarea.value.length
        )}`;
        setTimeout(() => {
          this.$refs[`${this.instance}-contentTextarea`].selectionEnd =
              cursortAt + 1;
        }, 100);
      }

      if (e.keyCode === 51) {
        // #
        if (this.form.body.value.includes("#")) {
          // console.log(this.$refs.contentTextarea.value);
          const cursortAt =
              this.$refs[`${this.instance}-contentTextarea`].selectionStart;
          const contentAt = this.form.body.value.substring(0, cursortAt);

          const split = contentAt.split("#");
          if (split.length === 2 && split[1]) {
            this.loadAcronymsByName(split[1]);
          }
        }
      }

      // Open acronyms modal
      if (e.keyCode === 13 && e.altKey) {
        this.$refs[`${this.instance}-modal-acronyms`].id = "modal-acronyms";
        this.$refs[`${this.instance}-modal-acronyms`].show();
      }
    },
    displayAcronymsModal() {
      const params = new URLSearchParams();
      params.append("origins", this.getOriginWithChannelOrigin().join(","));
      // params.append("origins", this.getOriginsByChannel().join(","));
      dropdownService.getAcronyms(params).then((resp) => {
        this.acronyms = resp;
        this.$refs[`${this.instance}-modal-acronyms`].id = "modal-acronyms";
        this.$refs[`${this.instance}-modal-acronyms`].show();
      });
    },
    loadAcronymsByName(acronym) {
      const params = new URLSearchParams();
      params.append("name", acronym);
      params.append(
          "origins",
          this.form.source.value.map((item) => item.id).join(",")
      );
      acronymsService
          .getAcronymsByOriginAndName(params)
          .then((resp) => {
            this.$refs[`${this.instance}-send-news-editor-form`].replaceAcronym(
                acronym,
                resp.text
            );
            // this.form.body.value = this.form.body.value.replace(
            //   `#${acronym}`,
            //   resp.text
            // );
          })
          .catch((err) => console.log(err));
    },
    // Formats for pisca: '* ' + title
    formatTitle(title) {
      if (!this.isFlashes) {
        return title;
      }

      if (title.length < 2 || title[0] !== "*") {
        return `*${title}`;
      }

      if (title[1] === " ") {
        return title;
      }

      return `* ${title.substr(1)}`;
    },
    closeForm(data) {
      this.$emit("close", { data: data, currentTab: this.currentTab });
    },
    confirmCancelEditing() {
      messageDialogHelper.displayConfirmMessage(
          this.$t('SEND_NEWS.Confirm_Cancel_Editing_Title'),
          this.$t('SEND_NEWS.Confirm_Cancel_Editing_Text'),
          () => {
            this.cancelEditing();
          }
      );
    },
    // Volta a noticia ao status de antes da edicao e descarta o que foi alterado no formulario
    cancelEditing() {
      this.displayOverlay = true;
      const params = new URLSearchParams();
      params.append("_id", this.newsID);
      newsService
          .cancelEditing(params)
          .then((newsData) => {
            messagesNotifyHelper.successNotify(
                this.$t('SEND_NEWS.Confirm_Cancel_Editing_Title'),
                this.$t('SEND_NEWS.Cancel_Editing_Success')
            );
            // Status ja restaurado: ao fechar a aba o onBeforeUnmount nao pode mandar para armazenado
            this.submitData = true;
            this.closeForm(newsData);
          })
          .catch((err) => console.log(err))
          .finally(() => {
            this.displayOverlay = false;
          });
    },
    openScheduleModal() {
      // Noticia ja agendada abre com a data/hora gravada; senao o modal sugere daqui a 1 hora
      this.$refs[`${this.instance}-modal-scheduled`].show(this.currentScheduledDate);
    },
    getStatusBeforeEditing(news) {
      if (news.event_status != AppConstants.EVENT_STATUS.EDITING) {
        return news.event_status;
      }
      const hist = news.event_status_hist || [];
      for (let index = hist.length - 1; index >= 0; index--) {
        if (hist[index].code != AppConstants.EVENT_STATUS.EDITING) {
          return hist[index].code;
        }
      }
      return this.editData.event_status;
    },
    openGoogleMapsModal() {
      this.$refs[`${this.instance}-google-maps-modal`].show();
    },
    closeGoogleMapsModal() {
      this.$refs[`${this.instance}-google-maps-modal`].hide();
    },
    // O modal ja validou (data/hora valida e futura) e fechou, entao os erros do formulario ficam visiveis
    sendEventShedule({ date, hour }) {
      this.form.dt_scheduled.value = date;
      this.form.hour_schedule.value = hour;
      this.onSubmit(AppConstants.EVENT_STATUS.SCHEDULED);
    },
    sendPublish() {
      this.onSubmit(AppConstants.EVENT_STATUS.PUBLISHED);
    },
    sendStore() {
      // if (this.form.event_status.value == AppConstants.EVENT_STATUS.TEMPLATE) {
      //   this.onSubmit(AppConstants.EVENT_STATUS.TEMPLATE);
      //   return;
      // }
      this.onSubmit(AppConstants.EVENT_STATUS.SAVED);
    },
    onSubmit(eventStatusId) {
      this.displayOverlay = true;
      this.messageErrors = [];
      if (this.form.body.display) {
        this.form.body.text =
            this.$refs[`${this.instance}-send-news-editor-form`].text;
        this.form.body.value =
            this.$refs[`${this.instance}-send-news-editor-form`].body;
      }

      const formData = new FormData();
      if (eventStatusId != AppConstants.EVENT_STATUS.TEMPLATE) {
        formData.append("_id", this.form._id.value);
      }

      // Title
      // formData.append("content[title][data]", this.formatTitle(this.form.title.value));
      formData.append("content[title][data]", this.form.title.value);
      formData.append("content[title][mimetype]", "text/plain");

      // Abstract
      formData.append("content[abstract][data]", this.form.summary.value);
      formData.append("content[abstract][mimetype]", "text/plain");

      // Body
      formData.append("content[body][data]", this.form.body.value);
      formData.append("content[body][mimetype]", "text/html");
      formData.append("content[body][target]", "content");
      formData.append("content[text][target]", "content");

      // Body in plain text
      formData.append("content[text][data]", this.form.body.text);
      formData.append("content[text][mimetype]", "text/plain");

      formData.append("push", this.form.push.value);
      formData.append("ignored_by_ai", this.form.ignored_by_ai.value);
      formData.append("image_copyright", this.form.image_copyright.value);
      formData.append("external_url", this.form.external_url.value);
      formData.append("external_label_btn", this.form.external_label_btn.value);
      formData.append("external_source_origin", 'Publisher frontend');

      formData.append("event_status", eventStatusId);

      // formData.append("flashes", this.isFlashes);

      formData.append("dt_report", this.form.dt_report.value);
      if (this.form.dt_publish.value) {
        formData.append("dt_publish", this.form.dt_publish.value);
      }
      formData.append("highlight", this.form.highlight.value);
      if (this.form.highlight_date.value && this.form.highlight.value) {
        formData.append(
            "highlight_date",
            this.form.highlight_date.value.trim()
        );
      }
      formData.append("download_document", this.form.download_document.value);
      
      formData.append("layout", this.form.layout);

      formData.append("weblink", this.form.weblink.value);
      formData.append(
          "type_message_channel",
          this.form.type_message_channel.value.value
      );

      if (eventStatusId == AppConstants.EVENT_STATUS.SCHEDULED) {
        // formData.append(
        //   "dt_scheduled",
        //   new Date(this.form.dt_scheduled.value).getTime() / 1000
        // );

        // formData.append("dt_scheduled", this.form.dt_scheduled.value);
        formData.append(
            "dt_scheduled",
            `${this.form.dt_scheduled.value} ${this.form.hour_schedule.value}`
        );
      }

      formData.append(
          "importance",
          this.form.importance.value
              ? AppConstants.IMPORTANT.IMPORTANT.id
              : AppConstants.IMPORTANT.INFO.id
      );
      // if (this.typeMessageModel.length == 1) {
      //   formData.append("typeMessage", this.typeMessageModel[0].id);
      // }
      // for (
      //     let index = 0;
      //     index < this.form.sharedSources.value.length;
      //     index++
      // ) {
      //   formData.append(
      //       `sharedSources[${index}][_id]`,
      //       this.form.sharedSources.value[index].id
      //   );
      // }
      for (let index = 0; index < this.form.source.value.length; index++) {
        formData.append(`source[${index}][_id]`, this.form.source.value[index].id);
      }
      if (!this.displaySubjectViewTypeCheckbox) {
        for (let index = 0; index < this.form.subjects.value.length; index++) {
          if (this.form.subjects.value[index].id) {
            formData.append(
                `subjects[${index}][_id]`,
                this.form.subjects.value[index].id
            );
          }
        }
      }
      if (this.displaySubjectViewTypeCheckbox) {
        for (let index = 0; index < this.subjectModelCheckbox.length; index++) {
          if (this.subjectModelCheckbox[index]) {
            formData.append(
                `subjects[${index}][_id]`,
                this.subjectModelCheckbox[index].id
            );
          }
        }
      }
      const selectedTags = this.form.tags.value.filter((item) => item.id);
      const newTags = this.form.tags.value.filter((item) => !item.id);

      if (this.form.tags.value.length > 0) {
        for (let index = 0; index < selectedTags.length; index++) {
          if (selectedTags[index].id) {
            formData.append(`tags[${index}][_id]`, selectedTags[index].id);
          }
        }
        // formData.append("tags", selectedTags.map((item) => item.id).join(","));
      }

      if (newTags && newTags.length > 0) {
        for (let index = 0; index < newTags.length; index++) {
          if (newTags[index].name) {
            formData.append(`newTags[${index}]`, newTags[index].name);
          } else {
            formData.append(`newTags[${index}]`, newTags[index]);
          }
        }
      }

      const selectedHats = this.form.hat.value.filter((item) => item.id);
      const newHats = this.form.hat.value.filter((item) => !item.id);
      if (selectedHats && selectedHats.length > 0) {
        for (let index = 0; index < selectedHats.length; index++) {
          if (selectedHats[index].id) {
            formData.append(`hat[${index}][_id]`, selectedHats[index].id);
          }
        }
      }
      if (newHats && newHats.length > 0) {
        for (let index = 0; index < newHats.length; index++) {
          if (newHats[index].name) {
            formData.append(`newHat[${index}]`, newHats[index].name);
          } else {
            formData.append(`newHat[${index}]`, newHats[index]);
          }
        }
      }

      if (this.documentLibraryData._id) {
        // document from library
        formData.append("document[_id]", this.documentLibraryData._id);
      } else if (this.documentLibraryData.file) {
        formData.append("newDocument", this.documentLibraryData.file);
        formData.append("newDocument_tags", this.documentLibraryData.tags);
        formData.append("newDocument_compressPdf", this.documentLibraryData.compressPdf);
        formData.append(
            "newDocument_copyright",
            this.documentLibraryData.copyright
        );
      }

      // Mp3 audio
      if (this.audioBlob) {
        formData.append(
            "audioBlob",
            this.audioBlob,
            this.form.audiofilename.value
        );
      } else if (this.audioLibraryData._id) {
        // audio from library
        formData.append("audio[_id]", this.audioLibraryData._id);
      } else if (this.audioLibraryData.file) {
        formData.append("newAudio", this.audioLibraryData.file);
        formData.append("newAudio_tags", this.audioLibraryData.tags);
        formData.append("newAudio_copyright", this.audioLibraryData.copyright);
      } else if (this.videoLibraryData.file) {
        formData.append("newVideo", this.videoLibraryData.file);
        formData.append("newVideo_tags", this.videoLibraryData.tags);
        formData.append("newVideo_copyright", this.videoLibraryData.copyright);
      }

      if (this.imageLibraryData._id) {
        // image from library
        formData.append("image[_id]", this.imageLibraryData._id);
      } else if (this.imageLibraryData.file) {
        formData.append("newImage", this.imageLibraryData.file);
        formData.append("newImage_tags", this.imageLibraryData.tags);
        formData.append("newImage_copyright", this.imageLibraryData.copyright);
      }
      if (this.form.image_description.value) {
        formData.append("image_description", this.form.image_description.value);
      }

      if (this.thumbPodcastLibraryData._id) {
        // thumb from library
        formData.append("thumbPodcast[_id]", this.thumbPodcastLibraryData._id);
      } else if (this.thumbPodcastLibraryData.file) {
        formData.append("newThumbPodcast", this.thumbPodcastLibraryData.file);
        formData.append("newThumbPodcast_tags", this.thumbPodcastLibraryData.tags);
        formData.append("newThumbPodcast_copyright", this.thumbPodcastLibraryData.copyright);
      }
      if (this.thumbLibraryData._id) {
        // thumb from library
        formData.append("thumb[_id]", this.thumbLibraryData._id);
      } else if (this.thumbLibraryData.file) {
        formData.append("newThumb", this.thumbLibraryData.file);
        formData.append("newThumb_tags", this.thumbLibraryData.tags);
        formData.append("newThumb_copyright", this.thumbLibraryData.copyright);
      }

      // if (this.form.related_news.value.length > 0) {
      //   for (
      //     let index = 0;
      //     index < this.form.related_news.value.length;
      //     index++
      //   ) {
      //     if (this.form.related_news.value[index].title) {
      //       formData.append(
      //         `related_news[${index}][title]`,
      //         this.form.related_news.value[index].title
      //       );
      //       formData.append(
      //         `related_news[${index}][type]`,
      //         this.form.related_news.value[index].type.value
      //       );
      //       if (this.form.related_news.value[index].news._id) {
      //         formData.append(
      //           `related_news[${index}][news][_id]`,
      //           this.form.related_news.value[index].news._id
      //         );
      //       }
      //     }
      //   }
      // }

      // if (this.form.related_news) {

      //   formData.append("related_news[free_text]", this.form.related_news)
      //   console.log("related_news", JSON.stringify(this.form.related_news))
      // }

      if (this.form.related_news) {
        if (this.form.related_news.free_title) {
          formData.append("related_news[free_title]", this.form.related_news.free_title);
        }
        if (this.form.related_news.free_text) {
          formData.append("related_news[free_text]", this.form.related_news.free_text);
        }
        if (this.form.related_news.news && this.form.related_news.news.length > 0) {
          for (let i = 0; i < this.form.related_news.news.length; i++) {
            formData.append(`related_news[news][${i}][_id]`, this.form.related_news.news[i].id);
            // formData.append(`related_news[news][${i}][title]`, this.form.related_news.news[i].title);
            // console.log("passou aqui", i);
          }
        }
      }

      if (this.form.youtube.value) {
        if (
            !formatFieldHelper.validateLinkYoutubeVideo(this.form.youtube.value)
        ) {
          messagesNotifyHelper.warningNotify(
              "Youtube",
              this.$t("SEND_NEWS.Youtube_Invalid_Url")
          );
          this.displayOverlay = false;
          return;
        }
        formData.append(
            "youtubeId",
            formatFieldHelper.getYoutubeId(this.form.youtube.value)
        );
      }
      if (this.form.soundcloud.value) {
        formData.append(
            "soundcloud",
            formatFieldHelper.getSoundcloudId(this.form.soundcloud.value)
        );
      }
      if (this.form.spotify.value) {
        formData.append(
            "spotify",
            this.getSpotifyIdFromUrl(this.form.spotify.value)
        );
      }

      if (this.form.country.value.length > 0) {
        for (let index = 0; index < this.form.country.value.length; index++) {
          if (this.form.country.value[index].id) {
            formData.append(
                `country[${index}][_id]`,
                this.form.country.value[index].id
            );
          }
        }
      }
      if (this.form.newsContent.value.length > 0) {
        for (
            let index = 0;
            index < this.form.newsContent.value.length;
            index++
        ) {
          if (this.form.newsContent.value[index].id) {
            formData.append(
                `newsContent[${index}][_id]`,
                this.form.newsContent.value[index].id
            );
            formData.append(
                `newsContent[${index}][code]`,
                this.form.newsContent.value[index].code
            );
          }
        }
      }
      if (this.form.reportType.value.length > 0) {
        if (this.form.reportType.value[0]) {
          if (this.form.reportType.value[0].id) {
            formData.append(
                "reportType[_id]",
                this.form.reportType.value[0].id
            );
          }
        }
      }
      if (this.form.package.value) {
        if (this.form.package.value.id) {
          formData.append("package[_id]", this.form.package.value.id);
        }
      }
      if (this.form.characteristic.value) {
        if (this.form.characteristic.value.id) {
          formData.append(
              "characteristic[_id]",
              this.form.characteristic.value.id
          );
        }
      }
      if (this.form.periodicity.value) {
        if (this.form.periodicity.value.id) {
          formData.append("periodicity[_id]", this.form.periodicity.value.id);
        }
      }

      if (this.form.channel.value.length > 0) {
        for (let index = 0; index < this.form.channel.value.length; index++) {
          if (this.form.channel.value[index].id) {
            formData.append(
                `channel[${index}][_id]`,
                this.form.channel.value[index].id
            );
            if (this.form.channel.value[index].code) {
              formData.append(
                  `channel[${index}][code]`,
                  this.form.channel.value[index].code
              );
            }
          }
        }
        // formData.append("channel", this.form.channel.value.map((item) => item.id).join(","));
      }

      // if (this.form.category.value && this.hasWordpressChannel) {
      //   formData.append(`category[_id]`, this.form.category.value.id);
      // }
      // if (this.form.category.value.length > 0 && this.hasWordpressChannel) {
      //   for (let index = 0; index < this.form.category.value.length; index++) {
      //     if (this.form.category.value[index].id) {
      //       formData.append(`category[${index}][_id]`, this.form.category.value[index].id);
      //     }
      //   }
      // }

      if (this.isErrata) {
        formData.append("isErrata", true);
      }

      if (this.form.clientGroup.value.length > 0) {
        for (
            let index = 0;
            index < this.form.clientGroup.value.length;
            index++
        ) {
          if (this.form.clientGroup.value[index]) {
            formData.append(`exclusive`, true);
            formData.append(
                `clientGroup[${index}]`,
                this.form.clientGroup.value[index]
            );
          }
        }
      } else {
        formData.append(`exclusive`, false);
      }

      if (this.form.disclosureType.value) {
        formData.append(`disclosureType`, this.form.disclosureType.value);
      }
      formData.append(`eventScheduleType`, this.form.eventScheduleType.value);
      formData.append(
          `eventScheduleDuration_dateTo`,
          this.form.eventScheduleDuration_dateTo.value
      );
      formData.append(
          `eventScheduleDuration_hourTo`,
          this.form.eventScheduleDuration_hourTo.value
      );
      formData.append(
          `eventScheduleDuration_dateFrom`,
          this.form.eventScheduleDuration_dateFrom.value
      );
      formData.append(
          `eventScheduleDuration_hourFrom`,
          this.form.eventScheduleDuration_hourFrom.value
      );
      // formData.append(
      //     `eventScheduleAllDay`,
      //     this.form.eventScheduleAllDay.value
      // );
      // formData.append(
      //     `eventScheduleLocation`,
      //     this.form.eventScheduleLocation.value
      // );
      // formData.append(`eventSchedulePrice`, this.form.eventSchedulePrice.value);
      formData.append(`eventScheduleLink`, this.form.eventScheduleLink.value);
      if (this.form.eventScheduleRelatedNews.value) {
        formData.append(
            `eventScheduleRelatedNews[_id]`,
            this.form.eventScheduleRelatedNews.value.id
        );
      }

      formData.append(`inLive`, this.form.inLive.value);
      if (this.form.inLive.value) {
        formData.append(`inLive_validate`, this.form.inLive_validate.value);
      }

      formData.append("generate_thumb", this.form.generate_thumb.value);
      for (let index = 0; index < this.form.topic.value.length; index++) {
        formData.append(`topic[${index}][_id]`, this.form.topic.value[index].id);
      }

      for (let index = 0; index < this.form.asset_reference.value.length; index++) {
        formData.append(`asset_reference[${index}][_id]`, this.form.asset_reference.value[index].id);
      }

      if (eventStatusId == AppConstants.EVENT_STATUS.TEMPLATE && this.userTemplate.data._id) {
        formData.append("_id", this.userTemplate.data._id);
        this.form.template_name.value = this.userTemplate.name;
      }
      if (this.form.template_name.value) {
        formData.append("template_name", this.form.template_name.value);
        // formData.append("template_name", this.userTemplate.name);
      }
      formData.append("public_area", this.form.public_area.value);
      formData.append("enable_chart", this.form.enable_chart.value);

      formData.append("announcement_date", this.form.announcement_date.value);

      newsService
          .sendNews(formData, new URLSearchParams())
          .then((newsData) => {
            // console.log(res);
            setTimeout(() => {
              let messageNotifyTitle = this.$t("SEND_NEWS.Message_Title_News");
              let messageNotifyMessage = "";

              switch (eventStatusId) {
                case AppConstants.EVENT_STATUS.DRAFT:
                  messageNotifyTitle = this.$t("SEND_NEWS.Message_Title_Draft");
                  if (this.isUpdate) {
                    messageNotifyMessage = this.$t(
                        "SEND_NEWS.Message_Draft_Updated"
                    );
                  } else {
                    messageNotifyMessage = this.$t(
                        "SEND_NEWS.Message_Draft_Created"
                    );
                  }
                  break;
                case AppConstants.EVENT_STATUS.PUBLISHED:
                  if (this.isUpdate) {
                    messageNotifyMessage = this.$t(
                        "SEND_NEWS.Message_News_Updated"
                    );
                  } else {
                    messageNotifyMessage = this.$t(
                        "SEND_NEWS.Message_News_Created"
                    );
                  }
                  break;
                case AppConstants.EVENT_STATUS.SAVED:
                  messageNotifyMessage = this.$t("SEND_NEWS.Message_News_Stored");
                  break;
                case AppConstants.EVENT_STATUS.SCHEDULED:
                  messageNotifyMessage = this.$t(
                      "SEND_NEWS.Message_News_Scheduled"
                  );
                  break;
                case AppConstants.EVENT_STATUS.TEMPLATE:
                  messageNotifyMessage = this.$t('SEND_NEWS.Template_Saved_Success');
                  break;
              }

              messagesNotifyHelper.successNotify(
                  messageNotifyTitle,
                  messageNotifyMessage
              );
              this.displayOverlay = false;
              if (eventStatusId === AppConstants.EVENT_STATUS.TEMPLATE) {
                this.userTemplate.name = this.form.template_name.value;
                this.userTemplate.data = { _id: newsData._id };
                this.userTemplate.isUpdated = false;
                if (this.currentUserTemplates.findIndex(({data}) => data._id == newsData._id) < 0) {
                  this.currentUserTemplates.push(Object.assign({}, this.userTemplate));
                }
              } else {
                if (!this.isFlashes) {
                  this.submitData = true;
                  this.sendNewsWithAction = true;
                  this.closeForm(newsData);
                } else {
                  this.$emit("load-news-data");
                  if (this.$refs[`${this.instance}-list-flashes`]) {
                    this.$refs[`${this.instance}-list-flashes`].refreshList();
                  }
                  if (this.form.title.value.indexOf(":") >= 0) {
                    this.form.title.value = this.form.title.value.substring(
                        0,
                        this.form.title.value.indexOf(":") + 1
                    );
                  }
                  this.focusTitle();
                }
              }

            }, 1000);
          })
          .catch((err) => {
            this.displayOverlay = false;
            console.log(err);
            if (err.statusCode != 500) {
              this.messageErrors = err;
            }
          });
    },
    onRemoveImage() {
      this.imagePreviewSrc = "";
      this.displayImagePreview = false;
    },
    onRemoveThumb() {
      this.thumbPreviewSrc = "";
      this.displayThumbPreview = false;
    },
    onChangeThumbImage(input) {
      // console.log("onChangeUserImage: ", input);
      const file = input.target.files[0];
      this.form.thumb.value = file;
      if (file) {
        this.thumbPreviewSrc = URL.createObjectURL(file);
        this.displayThumbPreview = true;
      } else {
        this.thumbPreviewSrc = "";
        this.displayThumbPreview = false;
      }
    },
    onChangeImage(input) {
      const file = input.target.files[0];
      this.form.image.value = file;
      if (file) {
        this.imagePreviewSrc = URL.createObjectURL(file);
        this.displayImagePreview = true;
      } else {
        this.imagePreviewSrc = "";
        this.displayImagePreview = false;
      }
    },
    onChangeDoc(input) {
      const file = input.target.files[0];
      this.form.doc.value = file;
    },
    updateStatusEditing() {
      if (this.isUpdate && !this.isDraft(this.editData.event_status)) {
        const params = new URLSearchParams();
        params.append("_id", this.newsID);
        newsService
            .updateStatusEditing(params)
            .then(() => {
              this.$emit("load-news-data");
            })
            .catch((err) => console.log(err));
      }
    },
    loadNewsData(isChangingTemplate = false) {
      // after load data need update status to editing
      // this.form = Object.assign({}, formTemplates.newsFields());
      let id = this.newsID;
      if (this.userTemplate.data._id) {
        id = this.userTemplate.data._id;
      } else {
        this.updateStatusEditing();
      }

      // Check if translating
      if (this.editData && this.editData._translationTargetLanguage) {
        this.translationTargetLanguage = this.editData._translationTargetLanguage;
        this.translationTargetLanguageLabel = this.editData._translationTargetLanguage;
        // TODO: In future, can load translation config to get the label
      }

      const params = new URLSearchParams();
      newsService
          .getNewsDetail(id, params)
          .then((resp) => {
            this.dataUpdate = resp;
            if (!isChangingTemplate) {
              this.bodyBeforeFlashes = null;
              switch (resp.layout) {
                case AppConstants.NEWS_LAYOUT.NEWS:
                  this.form = JSON.parse(
                      JSON.stringify(formTemplates.newsFields())
                  );
                  this.templateSelected = this.listTemplate.find(
                      (item) => item.id == AppConstants.NEWS_LAYOUT.NEWS
                  );
                  break;
                case AppConstants.NEWS_LAYOUT.FLASHES:
                  this.form = JSON.parse(
                      JSON.stringify(formTemplates.flashesFields())
                  );
                  this.templateSelected = this.listTemplate.find(
                      (item) => item.id == AppConstants.NEWS_LAYOUT.FLASHES
                  );
                  break;
                case AppConstants.NEWS_LAYOUT.TVCAST:
                  this.form = JSON.parse(
                      JSON.stringify(formTemplates.tvFields())
                  );
                  this.templateSelected = this.listTemplate.find(
                      (item) => item.id == AppConstants.NEWS_LAYOUT.TVCAST
                  );
                  break;
                case AppConstants.NEWS_LAYOUT.PODCAST:
                  this.form = JSON.parse(
                      JSON.stringify(formTemplates.podcastFields())
                  );
                  this.templateSelected = this.listTemplate.find(
                      (item) => item.id == AppConstants.NEWS_LAYOUT.PODCAST
                  );
                  break;
                case AppConstants.NEWS_LAYOUT.REPORT:
                  this.form = JSON.parse(
                      JSON.stringify(formTemplates.reportFields())
                  );
                  this.templateSelected = this.listTemplate.find(
                      (item) => item.id == AppConstants.NEWS_LAYOUT.REPORT
                  );
                  break;
                case AppConstants.NEWS_LAYOUT.EVENT:
                  this.form = JSON.parse(
                      JSON.stringify(formTemplates.eventFields())
                  );
                  this.templateSelected = this.listTemplate.find(
                      (item) => item.id == AppConstants.NEWS_LAYOUT.EVENT
                  );
                  break;
                default:
                  this.form = JSON.parse(
                      JSON.stringify(formTemplates.newsFields())
                  );
                  this.templateSelected = this.listTemplate.find(
                      (item) => item.id == AppConstants.NEWS_LAYOUT.NEWS
                  );
                  break;
              }
            }

            if (this.isUpdate) {
              this.form._id.value = resp._id;
            }
            this.form.hat.value = resp.hat;
            this.form.title.value = resp.content.title.data;
            this.form.title.value = this.form.title.value.replace("*", "");
            this.form.summary.value = resp.content.abstract.data;
            this.form.body.value = resp.content.body.data || "";
            // if (resp.related_news) {
            //   this.form.related_news.free_title = resp.related_news.free_title || "";
            //   this.form.related_news.free_text = resp.related_news.free_text || "";
            //   this.form.related_news.news = resp.related_news.news.map(item => {
            //     return {
            //       id: item._id,
            //       title: item.content.title.data
            //     };
            //   });
            // }

            this.form.push.value = resp.push;
            // Noticias antigas nao tem o campo; sem o !! o FormData enviaria o texto "undefined"
            this.form.ignored_by_ai.value = !!resp.ignored_by_ai;
            this.form.image_copyright.value = resp.image_copyright || "";
            this.form.soundcloud.value = resp.soundcloud || "";
            this.form.external_url.value = resp.external_url || "";
            this.form.external_label_btn.value = resp.external_label_btn || "";
            if (resp.youtubeId) {
              this.form.youtube.value =
                  `${AppConstants.URL_YOUTUBE_WATCH}?v=${resp.youtubeId}` || "";
            }

            if (this.$refs[`${this.instance}-send-news-editor-form`]) {
              this.$refs[`${this.instance}-send-news-editor-form`].body =
                  this.form.body.value;

              if (this.form.body.value && this.userTemplate.data._id) {
                // console.log('userheaders', this.userHeaders)
                this.$refs[`${this.instance}-send-news-editor-form`].updateUserHeader(this.userHeaders[0]);
              }
            }

            this.form.event_status.value = resp.event_status;
            this.statusBeforeEditing = this.isUpdate ? this.getStatusBeforeEditing(resp) : null;
            // So vale o dt_scheduled de noticia agendada (armazenada pode guardar um agendamento antigo)
            this.currentScheduledDate =
                this.statusBeforeEditing == AppConstants.EVENT_STATUS.SCHEDULED && resp.dt_scheduled
                    ? new Date(resp.dt_scheduled)
                    : null;

            // if (!resp.source.id) {
            //   resp.source.id = resp.source._id;
            // }
            // this.sourceModel = resp.source;
            // this.form.source.value = this.origins.filter(
            //     (item) => resp.source.findIndex((s) => s.id == item.id) >= 0
            // );
            this.form.source.value = this.userCore.origins.filter(
                (item) => resp.source.findIndex((s) => s.id == item.id) >= 0
            );
            this.form.channel.value = this.userCore.channels.filter(
                (item) => resp.channel.findIndex((s) => s.id == item.id) >= 0
            );
            const subjectsFilteredByUsercore = this.userCore.subjects.filter(
                (item) => resp.subjects.findIndex((s) => s.id == item.id) >= 0
            );
            // filter channel by usercore
            // this.form.channel.value = resp.channel;
            // this.form.subjects.value = resp.subjects;
            // this.subjectModelCheckbox = resp.subjects;
            this.keepLoadedSourceChannel = (this.isEdit || this.isCopy) && !isChangingTemplate;
            this.form.subjects.value = subjectsFilteredByUsercore;
            this.subjectModelCheckbox = subjectsFilteredByUsercore;
            // if (this.form.source.value.length > 0) {
            //   // console.log('[teste] ', this.channels);
            // }

            if (resp.newsContent) {
              this.form.newsContent.value = this.userCore.contents.filter(
                (item) => resp.newsContent.findIndex((s) => s.id == item.id) >= 0
              );
              // this.form.newsContent.value = resp.newsContent;
            }

            this.typeMessageModel = this.typeMessages.filter(
                (item) => item.id === resp.importance
            );
            this.form.importance.value = resp.importance == 1;

            this.form.tags.value = resp.tags;
            this.typeMessageSaved = resp.importance;

            // if (this.isErrata) {
            //   if (this.form.title.value.indexOf(":") >= 0) {
            //     this.form.title.value = `(CORREÇÃO) ${this.form.title.value.substring(
            //       0,
            //       this.form.title.value.indexOf(":") + 1
            //     )}`;
            //   } else {
            //     this.form.title.value = `(CORREÇÃO) ${this.form.title.value}`;
            //   }
            // }
            this.displayOverlay = false;

            if (resp.thumb) {
              this.onSubmitThumbLibrary(resp.thumb);
            }
            if (resp.image) {
              this.onSubmitImageLibrary(resp.image);
            }
            if (resp.document) {
              this.onSubmitDocumentsLibrary(resp.document);
            }
            if (resp.audio) {
              this.onSubmitAudioLibrary(resp.audio);
              this.form.audiofilename.value = resp.audio.original_filename;
            }

            this.form.image_description.value = resp.image_description;

            if (resp.dt_report) {
              if (!this.userTemplate.data._id) {
                this.form.dt_report.value = new Date(convertDatetimeHelper.getDateWithoutTimezone(resp.dt_report));
              }
            }
            // if (resp.dt_publish && !this.isCopy) {
            //   if (this.isEdit) {
            //     this.form.dt_publish.value = new Date(resp.dt_publish);
            //   } else {
            //     this.form.dt_publish.value = new Date(convertDatetimeHelper.getDateWithoutTimezone(resp.dt_publish));
            //   }
            // }
            if (resp.highlight) {
              this.form.highlight.value = resp.highlight;
            }
            if (resp.highlight_date) {
              this.form.highlight_date.value = formatDate(resp.highlight_date, {
                dateStyle: "short",
                timeStyle: "short",
              });
            }
            if (resp.announcement_date) {
              this.form.announcement_date.value = formatDate(resp.announcement_date, {
                dateStyle: "short",
                timeStyle: "short",
              });
            }
            if (resp.country) {
              this.form.country.value = resp.country;
            }
            // if (resp.commodity) {
            //   this.commodityModel = [resp.commodity];
            // }
            // if (resp.newsContent) {
            //   this.form.newsContent.value = resp.newsContent;
            // }
            if (resp.reportType) {
              this.form.reportType.value = [resp.reportType];
            }
            if (resp.category) {
              this.form.category.value = [resp.category];
            }
            this.form.package.value = resp.package || {};
            this.form.characteristic.value = resp.characteristic || {};
            this.form.periodicity.value = resp.periodicity || {};
            this.form.download_document.value = resp.download_document;

            if (resp.weblink) {
              this.form.weblink.value = resp.weblink;
            }

            this.form.related_news.value = resp.related_news || [];
            // if (this.form.related_news.value.length == 0) {
            //   this.createNewRelatedNews();
            // } else {
            //   this.displayRelatedNewsCard = true;
            //   this.form.related_news.value = this.form.related_news.value.map(
            //     (item) => {
            //       if (!item.news) {
            //         item.news = {};
            //       }
            //       if (item.type == AppConstants.RELATED_NEWS_TYPE_TEXT.value) {
            //         item.type = AppConstants.RELATED_NEWS_TYPE_TEXT;
            //       } else {
            //         item.type = AppConstants.RELATED_NEWS_TYPE_LINK;
            //       }
            //       return item;
            //     }
            //   );
            // }
            if (resp.clientGroup) {
              this.form.clientGroup.value = resp.clientGroup;
            }
            this.$refs[`${this.instance}-scrollbar`].$el.scrollTop = 0;

            this.form.disclosureType.value = resp.disclosureType;
            this.form.eventScheduleType.value = resp.eventScheduleType;
            if (resp.eventScheduleDuration_dateTo) {
              this.form.eventScheduleDuration_dateTo.value = convertDatetimeHelper.getDateRangeParamsFormat(resp.eventScheduleDuration_dateTo);
            }
            if (resp.eventScheduleDuration_dateFrom) {
              this.form.eventScheduleDuration_dateFrom.value = convertDatetimeHelper.getDateRangeParamsFormat(resp.eventScheduleDuration_dateFrom);
            }
            this.form.eventScheduleDuration_hourTo.value = resp.eventScheduleDuration_hourTo;
            this.form.eventScheduleDuration_hourFrom.value = resp.eventScheduleDuration_hourFrom;
            // this.form.eventScheduleAllDay.value = resp.eventScheduleAllDay;
            // this.form.eventSchedulePrice.value = resp.eventSchedulePrice;
            // this.form.eventScheduleLocation.value = resp.eventScheduleLocation;
            this.form.eventScheduleLink.value = resp.eventScheduleLink;
            this.form.public_area.value = resp.public_area;
            if (resp.asset_reference) {
              this.form.asset_reference.value = resp.asset_reference;
            }

            this.form.inLive.value = resp.inLive;
            if (resp.inLive_validate) {
              this.form.inLive_validate.value = formatDate(resp.inLive_validate, {
                dateStyle: "short",
                timeStyle: "short",
              });
            }

            if (resp.topic) {
              this.form.topic.value = resp.topic;
            }

          })
          .catch((err) => {
            console.log(err);
            this.displayOverlay = false;
            this.translationLanguagesLoading = false;
          });
    },
    loadClientGroupData(value) {
      this.clientGroup = [];
      const params = new URLSearchParams();
      params.append("limit", 100);
      if (value) {
        params.append("name", value);
      }
      return dropdownService.getClientGroup(params);
    },
    loadTagData(value) {
      this.tags = [];
      const params = new URLSearchParams();
      params.append("limit", 100);
      params.append("sort", "name");
      if (value) {
        params.append("name", value);
      } else {
        params.delete("sort");
      }
      return dropdownService.getAllTags(params);
    },
    loadHatData(value) {
      this.hats = [];
      const params = new URLSearchParams();
      params.append("limit", 100);
      params.append("sort", "name");
      if (value) {
        params.append("name", value);
      } else {
        params.delete("sort");
      }
      return dropdownService.getHat(params);
    },
    loadData(isChangingTemplate = false) {
      this.displayOverlay = true;
      this.translationLanguagesLoading = true;
      const countryParams = new URLSearchParams();
      countryParams.append("displayInSendNews", true);
      const eventStatusParams = new URLSearchParams();
      eventStatusParams.append("sendNews", true);
      if (this.isUpdate) {
        eventStatusParams.append("isUpdate", true);
      }
      const userParams = new URLSearchParams();
      userParams.append(AppConstants.PARAMS_USER_FILTER, true);
      userParams.append("noApp", true);
      userParams.append("displayInSendNews", true);

      const sharedOriginParams = new URLSearchParams();
      userParams.append("noApp", true);
      sharedOriginParams.append("displayInSendNews", true);

      const hatParams = new URLSearchParams();
      hatParams.append("limit", 100);
      Promise.all([
        // dropdownService.getAllOrigin(userParams),
        dropdownService.getTypeMessages(new URLSearchParams()),
        dropdownService.getEventStatus(eventStatusParams),
        dropdownService.getHat(hatParams),
        dropdownService.getCountry(countryParams),
        userService.getUserFormDetail(new URLSearchParams()),
        // dropdownService.getAllOrigin(sharedOriginParams),
        newsService.getDetailUserCore(new URLSearchParams()),
        dropdownService.getAllTags(hatParams),
        translationConfigService.getAllTranslationConfigs(new URLSearchParams()),
      ])
          .then((resp) => {
            // this.origins = resp[0];
            this.typeMessages = resp[0];
            this.eventStatus = this.addIcons(resp[1]);
            this.hats = resp[2];
            this.countries = resp[3];
            this.countries.unshift(AppConstants.DROPDOWN_ALL_OPTION);

            this.userHeaders = resp[4].user_header;
            this.signatures = resp[4].signatures;
            this.contentFooter = resp[4].contentFooter;
            this.canCreateTag = resp[4].canCreateTag;
            this.canCreateHat = resp[4].canCreateHat;
            this.canSendSoundcloudLink = resp[4].canSendSoundcloudLink;
            this.canSendChartOnSendNews = resp[4].canSendChartOnSendNews;
            if (resp[4].templates) {
              this.currentUserTemplates = resp[4].templates;
            }

            this.tags = resp[6];

      const translationConfigsResponse = resp[7];
      const translationConfigs = Array.isArray(translationConfigsResponse)
        ? translationConfigsResponse
        : (translationConfigsResponse && translationConfigsResponse.data) || [];
      this.translationLanguages = translationConfigs;
      this.translationLanguagesLoading = false;

            // this.form.signatures.value = resp[5].signatures.map(item => `${item.name} (${item.origin.name})`).join(',');
            // this.form.contentFooter.value = resp[5].contentFooter;

            // this.sharedSources = resp[6];
            // this.sharedSources.unshift(AppConstants.DROPDOWN_ALL_OPTION);
            this.$store.dispatch("auth/setUserCore", resp[5]);
            if (this.userCore.contents) {
              if (this.isNews || this.isFlashes) {
                this.newsContent = this.userCore.contents.filter(item => item.code == AppConstants.CONTENT_ENUM.NEWS);
              } else if (this.isDisclosure) {
                this.newsContent = this.userCore.contents.filter(item => 
                  item.code == AppConstants.CONTENT_ENUM.NEWS ||
                  item.code == AppConstants.CONTENT_ENUM.CONSULTING ||
                  item.code == AppConstants.CONTENT_ENUM.CONSULTING_COURSES ||
                  item.code == AppConstants.CONTENT_ENUM.CONSULTING_SPEECHES
                );
              } else {
                this.newsContent = this.userCore.contents;
              }
            }

            if (!isChangingTemplate) {
              this.typeMessageModel = [this.typeMessages[0]];
              this.typeMessageSaved = this.typeMessages[0].id;
            }

            // Ao trocar de modelo o form ja traz os valores do modelo anterior (onSelectTemplate):
            // recarregar a noticia ou aplicar os padroes de conteudo novo apagaria o que foi preenchido
            if (isChangingTemplate) {
              // nada a carregar
            } else if (this.isEdit || this.isCopy || this.userTemplate.data._id) {
              this.loadNewsData();
            } else {
              if (resp[4].country) {
                this.form.country.value = [resp[4].country];
              }

              // if (this.form.source.value.length == 0) {
              //   this.form.source.value = JSON.parse(JSON.stringify(this.userCore.origins));
              //   // this.form.source.value = resp[0];
              //   // removido regra, agora deve inserir todas as origens que vir do backend
              //   // if (this.origins.length == 1) {}
              // }
              // if (this.form.channel.value.length == 0) {
              //   this.form.channel.value = JSON.parse(JSON.stringify(this.userCore.channels));
              // }
              if (
                  !this.isFlashes &&
                  this.form.body.display &&
                  !this.isDisclosure
              ) {
                if (this.contentFooter) {
                  this.$refs[
                      `${this.instance}-send-news-editor-form`
                      ].body = `<br>${this.contentFooter}`;
                }
                if (this.signatures.length == 1) {
                  this.$refs[
                      `${this.instance}-send-news-editor-form`
                      ].onSelectSignatureItem(this.signatures[0]);
                }
                if (this.userHeaders.length == 1) {
                  this.$refs[
                      `${this.instance}-send-news-editor-form`
                      ].onSelectUserHeaderItem(this.userHeaders[0]);
                }
              }
              // console.log('[log here]')
              // if (this.changeTemplateForm) {
              //   this.form.hat.value = this.changeTemplateForm.hat.value;
              //   this.form.title.value = this.changeTemplateForm.title.value;
              //   this.form.summary.value = this.changeTemplateForm.summary.value;
              //   this.form.body.value = this.changeTemplateForm.body.value;
              //   this.form.source.value = this.changeTemplateForm.source.value;
              //   this.form.channel.value = this.changeTemplateForm.channel.value;
              //   this.form.subjects.value = this.changeTemplateForm.subjects.value;
              // }
            }
            this.displayActionButtons = true;
            this.displayContentEditor = true;
            this.displayOverlay = false;

            this.togglePisca();
            setTimeout(() => {
              this.$refs[`${this.instance}-scrollbar`].$el.scrollTop = 0;
            }, 100);
          })
          .catch((err) => {
            console.log(err);
            this.displayOverlay = false;
          });
    },
    // TODO - add to backend the icons
    addIcons(events) {
      return events.map((item) => {
        switch (item.id) {
          case AppConstants.EVENT_STATUS.PUBLISHED:
            item.icon = "SendIcon";
            break;
          case AppConstants.EVENT_STATUS.SCHEDULED:
            item.icon = "ClockIcon";
            break;
          case AppConstants.EVENT_STATUS.SAVED:
            item.icon = "SaveIcon";
            break;
          case AppConstants.EVENT_STATUS.REVIEW:
            item.icon = "EyeIcon";
            break;
          case AppConstants.EVENT_STATUS.CANCELED:
            item.icon = "XIcon";
            break;
          default:
            item.icon = "";
            break;
        }
        return item;
      });
    },
    getOriginsByChannel() {
      if (this.form.channel.value) {
        const channelFiltered = this.form.channel.value.filter(
            (item) => item.origin
        );
        if (channelFiltered.length > 0) {
          return channelFiltered.map((item) => item.origin);
        }
      }
      return [];
    },
    getOriginWithChannelOrigin() {
      let originList = this.form.source.value.map((item) => item.id);
      if (this.form.channel.value) {
        const channelFiltered = this.form.channel.value.filter(
            (item) => item.origin
        );
        if (channelFiltered.length > 0) {
          return originList.concat(channelFiltered.map((item) => item.origin));
        }
      }
      return originList;
    },
    getWordpressChannel() {
      return this.form.channel.value
          .filter((item) => item.code == AppConstants.CHANNELS.WORDPRESS.id)
          .map((item) => item.id);
    },
    loadCategoriesByCountry() {
      this.categories = [];
      const categoryParams = new URLSearchParams();
      if (this.form.country.value.length > 0) {
        categoryParams.append(
            "country",
            this.form.country.value.map((item) => item.id).join(",")
        );
      }
      if (this.hasWordpressChannel) {
        categoryParams.append("channel", this.getWordpressChannel().join(","));
      }
      dropdownService.getCategoryByChannel(categoryParams).then((res) => {
        this.categories = res;
      });
    },
    loadDataByChannels() {
      // this.subjects = [];
      // this.tags = [];
      // this.topic = [];
      // this.userHeaders = [];
      // this.newsContent = [];
      this.clientGroup = [];
      // this.form.newsContent.value = [];
      // console.log('[loadDataByChannels] ', this.sourceModel);

      const params = new URLSearchParams();
      params.append("origins", this.getOriginWithChannelOrigin().join(","));
      // params.append("origins", this.getOriginsByChannel().join(","));
      params.append("isQuotes", false);
      params.append("layout", this.form.layout);
      params.append("limit", 100);

      // const categoryParams = new URLSearchParams();
      // if (this.hasWordpressChannel) {
      //   categoryParams.append("channel", this.getWordpressChannel().join(','));
      // }
      Promise.all([
        // dropdownService.getAllSubjects(params),
        // dropdownService.getAllTags(new URLSearchParams()),
        dropdownService.getClientGroup(params),
        // dropdownService.getContent(params),
      ]).then((res) => {
        // this.subjects = res[0];
        // this.tags = res[0];
        this.clientGroup = res[0];
        // this.newsContent = res[3];
        // this.checkSubjectsSelected();
        // this.checkTagsSelected();

        // if (this.isFlashes) {
        //   const sub = this.subjects.filter(
        //       (item) => item.name.indexOf("MCT") >= 0
        //   );
        //   this.form.subjects.value = sub;
        //   this.subjectModelCheckbox = sub;
        // }

        // if (this.hasWordpressChannel) {
        //   if (this.categories.length == 0) {
        //     this.loadCategoriesByCountry();
        //   }
        // }
        // if (this.newsContent.length == 1) {
        //   this.form.newsContent.value = [this.newsContent[0]];
        // }
      });
    },
    loadDataByOrigin() {
      this.channels = [];
      const params = new URLSearchParams();
      params.append(
          "origins",
          this.form.source.value.map((item) => item.id).join(",")
      );
      params.append(AppConstants.PARAMS_USER_FILTER, true);
      params.append("layout", this.form.layout);

      dropdownService.getChannelByOrigin(params).then((res) => {
        this.channels = res;
        if (!this.isEdit && !this.isCopy && !this.userTemplate.data._id) {
          this.form.channel.value = res.filter(item => item.populateOnSendNews);
          if (this.form.channel.value.length == 0) {
            messagesNotifyHelper.warningNotify(this.$t("SEND_NEWS.Channel_Title"), this.$t("SEND_NEWS.Channel_Not_Found"));
          }
        } else {
          if (this.form.channel.value.length > 0) {
            this.form.channel.value = this.form.channel.value.filter(item => this.channels.findIndex(c => c.id == item.id) >= 0);
          }
          // this.loadDataByChannels();
        }
      });
    },
    loadDataSubject(val, keepSourceChannel = false) {
      this.displayOverlay = true;
      console.log('[loadDataSubject]')
      // this.origins = [];
      // this.channels = [];
      this.newsContent = [];
      if (this.userCore && this.userCore.subjects) {
        const userCoreSubjects = this.userCore.subjects.filter(item => val.findIndex(s => s.id == item['_id']) >= 0);
        const subOrigin = [];
        const subChannel = [];
        const subContent = [];
        for (let index = 0; index < userCoreSubjects.length; index++) {
          userCoreSubjects[index].origins.forEach(item => {
            if (subOrigin.findIndex(o => o.id == item.id) < 0) subOrigin.push(item);
          });
          userCoreSubjects[index].channels.forEach(item => {
            if (subChannel.findIndex(o => o.id == item.id) < 0) subChannel.push(item);
          });
          userCoreSubjects[index].content.forEach(item => {
            if (subContent.findIndex(o => o.id == item.id) < 0) subContent.push(item);
          });
        }
        // check if user has rights from userCore
        const originRights = subOrigin.filter(item => this.userCore.origins.findIndex(o => o.id == item.id) >= 0);
        const channelRights = subChannel.filter(item => this.userCore.channels.findIndex(o => o.id == item.id) >= 0);
        let contentRights = [];
        if (this.isNews || this.isFlashes) {
          contentRights = subContent.filter(item => item.code == AppConstants.CONTENT_ENUM.NEWS);
        } else if (this.isDisclosure) {
          contentRights = this.userCore.contents.filter(item => 
            item.code == AppConstants.CONTENT_ENUM.NEWS ||
            item.code == AppConstants.CONTENT_ENUM.CONSULTING ||
            item.code == AppConstants.CONTENT_ENUM.CONSULTING_COURSES ||
            item.code == AppConstants.CONTENT_ENUM.CONSULTING_SPEECHES
          );
        } else {
          contentRights = subContent.filter(item => this.userCore.contents.findIndex(o => o.id == item.id) >= 0);
        }

        // this.origins = originRights;
        // this.channels = channelRights;
        this.newsContent = contentRights;
        if (keepSourceChannel) {
          // mantem somente as origens e os canais da noticia carregada
        } else if (this.form.source.value && this.form.source.value.length == 0) {
          this.form.source.value = originRights;
        } else {
          originRights.forEach(item => {
            if (this.form.source.value.findIndex(c => c.id == item.id) < 0) {
              this.form.source.value.push(item);
            }
          });
        }
        if (keepSourceChannel) {
          // idem origens
        } else if (this.form.channel.value && this.form.channel.value.length == 0) {
          this.form.channel.value = channelRights;
        } else {
          channelRights.forEach(item => {
            if (this.form.channel.value.findIndex(c => c.id == item.id) < 0) {
              this.form.channel.value.push(item);
            }
          });
        }

        if (this.form.newsContent.value && this.form.newsContent.value.length == 0) {
          if (contentRights.length == 1) {
            this.form.newsContent.value = contentRights;
          }
        }
        // this.loadDataByChannels();
      }
      setTimeout(() => {
        this.displayOverlay = false;
      }, 200);
    },
    loadContentBySubject() {
      // this.channels = [];
      // const params = new URLSearchParams();
      // params.append("origins", this.getOriginWithChannelOrigin().join(","));
      // // params.append("origins", this.getOriginsByChannel().join(","));
      // if (this.displaySubjectViewTypeCheckbox) {
      //   params.append(
      //       "subject",
      //       this.subjectModelCheckbox.map((item) => item.id).join(",")
      //   );
      // } else {
      //   params.append(
      //       "subject",
      //       this.form.subjects.value.map((item) => item.id).join(",")
      //   );
      // }
      // params.append("layout", this.form.layout);
      // params.append("isQuotes", false);
      // // params.append('isInvite', this.form.eventScheduleIsInvite.value);

      // if (this.hasPlatformChannel) {
      //   const channels = this.form.channel.value.filter(item => item.code == AppConstants.CHANNELS.PLATFORM.id);
      //   params.append("channel", channels.map(({id}) => id).join(","));
      //   // params.append(
      //   //   "channel",
      //   //   this.form.channel.value.find(
      //   //     (item) => item.code == AppConstants.CHANNELS.PLATFORM.id
      //   //   ).id
      //   // );
      // }

      // // COMMENT
      // dropdownService.getContentBySubjectUserRule(params).then((res) => {
      //   this.newsContent = res;
      //   if (this.newsContent.length == 1) {
      //     this.form.newsContent.value = [this.newsContent[0]];
      //   }
      // });
      // switch (this.form.layout.value) {
      //   case AppConstants.NEWS_LAYOUT.NEWS:
      //     this.newsContent = this.userCore.contents.filter(item => item.code == );
      //   break;
      // }
    },
    checkAppOrigin(currentOrigin) {
      if (currentOrigin.code === AppConstants.ORIGINS.AGENCIA_CMA_APP) {
        this.displayAppFields = true;
      } else {
        this.displayAppFields = false;
      }
    },
    checkSubjectsSelected() {
      const sub = this.form.subjects.value
          .filter((s) => {
            if (this.subjects.findIndex((item) => item.id == s.id) >= 0) {
              return true;
            }
            return false;
          })
          .slice();

      this.form.subjects.value = sub;
      this.subjectModelCheckbox = sub;
    },
    checkTagsSelected() {
      this.form.tags.value = this.form.tags.value
          .filter((s) => {
            if (this.tags.findIndex((item) => item.id == s.id) >= 0) {
              return true;
            }
            return false;
          })
          .slice();
    },
    onSelectTemplate(event) {
      // console.log('onSelectTemplate',val);
      // this.form = JSON.parse(JSON.stringify(formTemplates[event.value]()));
      // let subjectM = [];
      // if (this.form.subjects.value) {
      //   subjectM = JSON.parse(JSON.stringify(this.form.subjects.value));
      // }
      // let sourceM = [];
      // if (this.form.source.value) {
      //   sourceM = JSON.parse(JSON.stringify(this.form.source.value));
      // }
      // let channel = [];
      // if (this.form.channel.value) {
      //   channel = JSON.parse(JSON.stringify(this.form.channel.value));
      // }
      
      // if (channel) {
      //   this.form.channel.value = channel;
      // }
      // if (sourceM) {
      //   this.form.source.value = sourceM;
      // }
      // if (subjectM) {
      //   this.form.subjects.value = subjectM;
      // }
      const previousForm = this.form;
      const wasFlashes = this.isFlashes;
      // O editor guarda o texto no proprio componente: sincroniza antes de trocar, pois o novo modelo pode nao exibi-lo
      const editor = this.$refs[`${this.instance}-send-news-editor-form`];
      if (previousForm.body.display && editor) {
        previousForm.body.text = editor.text;
        previousForm.body.value = editor.body;
      }

      // Todos os modelos tem os mesmos campos (so muda display/required): mantem os valores preenchidos
      const form = JSON.parse(JSON.stringify(formTemplates[event]()));
      Object.keys(form).forEach((key) => {
        const previousField = previousForm[key];
        if (form[key] && typeof form[key] === "object" && previousField && typeof previousField === "object") {
          form[key].value = previousField.value;
        }
      });
      form.body.text = previousForm.body.text;
      this.form = form;
      // if (this.isNews) {
      //   if (this.form.related_news.value.length == 0) {
      //     this.createNewRelatedNews();
      //   }
      // }

      if (this.isFlashes) {
        this.form.importance.value = true;
        // Pisca envia o texto padrao no corpo; guarda o corpo para devolver ao sair do Pisca
        if (!wasFlashes) {
          this.bodyBeforeFlashes = this.form.body.value;
        }
      } else if (wasFlashes) {
        if (this.bodyBeforeFlashes !== null) {
          this.form.body.value = this.bodyBeforeFlashes;
        } else if (this.isFlashesBody(this.form.body.value)) {
          // Conteudo que ja era Pisca: o texto padrao nao e corpo de noticia
          this.form.body.value = "";
        }
        this.bodyBeforeFlashes = null;
      }
      if (this.isDisclosure && !this.isEdit) {
        this.form.public_area.value = true;
      }
      // if (this.form.source.value.length > 0 &&
      //     this.form.subjects.value.length > 0 &&
      //     this.form.channel.value.length > 0 &&
      //     this.form.title.value) {
      //   this.changeTemplateForm = Object.assign({}, this.form);
      // }
      // this.changeTemplateForm = Object.assign({}, this.form);
      this.loadData(true);
      this.togglePisca();
      this.$forceUpdate();
    },
    selectCountry(country) {
      if (country) {
        this.languageModel = country.language;
        this.form.language.value = country.language;
        // this.loadCommodity(this.sourceModel, country);
      } else {
        this.languageModel = null;
        this.form.language.value = null;
      }
    },
    loadReportType() {
      this.reportType = [];
      if (!this.isEdit) {
        this.selectReportType(null);
      }
      const params = new URLSearchParams();
      params.append("origins", this.getOriginWithChannelOrigin().join(","));
      // params.append("origins", this.getOriginsByChannel().join(","));
      if (this.displaySubjectViewTypeCheckbox) {
        params.append(
            "subject",
            this.subjectModelCheckbox.map((item) => item.id).join(",")
        );
      } else {
        params.append(
            "subject",
            this.form.subjects.value.map((item) => item.id).join(",")
        );
      }
      params.append(
          "content",
          this.form.newsContent.value.map((item) => item.id).join(",")
      );
      dropdownService
          .getReportType(params)
          .then((resp) => {
            this.reportType = resp;
            if (this.dataUpdate) {
              this.form.reportType.value = this.reportType.filter(
                  (item) => item.id == this.dataUpdate.reportType.id
              );
            } else if (
                this.reportType.length > 0 &&
                !this.form.reportType.value
            ) {
              this.form.reportType.value = [this.reportType[0]];
            }
          })
          .catch((err) => console.log(err));
    },
    // A busca considera o nome do relatorio em todos os idiomas (ex.: "Agri Day Soybeans" com o usuario em portugues)
    filterReportTypeOption(option, label, search) {
      const normalize = (text) =>
          String(text || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
      const term = normalize(search);
      return [
        label,
        option.name,
        option.namePtBr,
        option.nameEnEu,
        option.nameEsEs,
        option.nameEsAr,
        option.namePtPt,
        option.nameZhCn,
      ].some((name) => normalize(name).indexOf(term) > -1);
    },
    // Chapeu/manchete do relatorio no idioma do primeiro pais selecionado (ex.: Estados Unidos -> hatEnEu),
    // independente do idioma do publisher; sem pais usa o idioma do publisher
    getReportTypeHatByCountry(item) {
      const country = this.form.country.value && this.form.country.value[0];
      if (country && country.locale && item[`hat${country.locale}`]) {
        return item[`hat${country.locale}`];
      }
      return this.getTranslateFieldHat(item);
    },
    selectReportType(val) {
      if (val) {
        this.form.package.value = val.package;
        this.form.characteristic.value = val.characteristic;
        this.form.periodicity.value = val.periodicity;

        const hatName = this.getReportTypeHatByCountry(val);
        this.form.title.value = hatName;
        const hat = this.hats.find(
            (item) => item.name == hatName
        );
        if (!hat) {
          this.form.hat.value.push({ name: hatName });
        } else {
          this.form.hat.value.push(hat);
        }
      } else {
        this.form.package.value = "";
        this.form.characteristic.value = "";
        this.form.periodicity.value = "";
      }
    },
    // Manchete e resumo precisam de conteudo da noticia (integra, manchete ou resumo).
    // Assunto, tags e chapeu sao so categorias: com eles a IA responde que nao ha contexto.
    hasAiSuggestionContext() {
      const hasText = (field) => !!(field.value && String(field.value).trim());
      return !!this.getBodyNewsText() || hasText(this.form.summary) || hasText(this.form.title);
    },
    // Descarta respostas da IA que não são tag/chapéu (frases de recusa, textos longos, marcador de "sem sugestão")
    isValidShortAiSuggestion(text) {
      const value = String(text || '').trim();
      if (!value || value.length > 40) return false;
      if (value.split(/\s+/).length > 3) return false;
      if (/[.!?:]$/.test(value)) return false;
      if (/SEM_SUGESTAO/i.test(value)) return false;
      return !/(informa[cç][aã]o|informa[cç][oõ]es|contexto|conte[uú]do)\s+(\w+\s+)?(suficiente|insuficiente)/i.test(value);
    },
    async generateTagsSuggestion() {
      if (this.tagsAiLoading) return;
      this.hideActiveTooltip();
      this.tagsAiLoading = true;
      try {
        if (!this.form.subjects.value || this.form.subjects.value.length === 0) {
          throw new Error(this.$t('AI_MESSAGES.SubjectRequiredForTags'));
        }
        const tags = await this.aiTagsSuggestionsRequest();
        if (tags && tags.length > 0) {
          console.log('[generateTagsSuggestion]', tags);
          const newTags = tags.filter(tag => this.isValidShortAiSuggestion(tag)).map(tag => ({ id: null, name: tag.trim(), aiGenerated: true }));
          const existingTagNames = new Set(this.form.tags.value.map(tag => tag.hasOwnProperty('name') ? tag.name.toLowerCase() : tag.toLowerCase()));
          const filteredNewTags = newTags.filter(newTag => !existingTagNames.has(newTag.name.toLowerCase()));
          if (filteredNewTags.length > 0) {
            this.form.tags.value = this.form.tags.value.concat(filteredNewTags);
            this.highlightField('tags');
            messagesNotifyHelper.successNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.TagsSuggested'));
          } else {
            messagesNotifyHelper.messageNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.TagsAlreadyExist'));
          }
        } else {
          throw new Error(this.$t('AI_MESSAGES.NoTagsReturned'));
        }
      } catch (error) {
        messagesNotifyHelper.errorNotifyUnlessHandled(this.$t('AI_MESSAGES.Title'), error, this.$t('AI_MESSAGES.CouldNotSuggestTags'));
      } finally {
        this.tagsAiLoading = false;
      }
    },
    async generateHatSuggestion() {
      if (this.hatAiLoading) return;
      this.hideActiveTooltip();
      this.hatAiLoading = true;
      try {
        if (!this.form.subjects.value || this.form.subjects.value.length === 0) {
          throw new Error(this.$t('AI_MESSAGES.SubjectRequiredForHats'));
        }
        const hats = await this.aiHatSuggestionsRequest();
        if (hats && hats.length > 0) {
          const newHats = hats.filter(hat => this.isValidShortAiSuggestion(hat)).map(hat => ({ id: null, name: hat.trim(), aiGenerated: true }));
          const existingHatNames = new Set(this.form.hat.value.map(hat => hat.name.toLowerCase()));
          const filteredNewHats = newHats.filter(newHat => !existingHatNames.has(newHat.name.toLowerCase()));
          if (filteredNewHats.length > 0) {
            this.form.hat.value = this.form.hat.value.concat(filteredNewHats);
            this.highlightField('hat');
            messagesNotifyHelper.successNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.HatsSuggested'));
          } else {
            messagesNotifyHelper.messageNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.HatsAlreadyExist'));
          }
        } else {
          throw new Error(this.$t('AI_MESSAGES.NoHatsReturned'));
        }
      } catch (error) {
        messagesNotifyHelper.errorNotifyUnlessHandled(this.$t('AI_MESSAGES.Title'), error, this.$t('AI_MESSAGES.CouldNotSuggestHats'));
      } finally {
        this.hatAiLoading = false;
      }
    },
    async generateTitleSuggestion() {
      if (this.titleAiLoading) return;
      this.hideActiveTooltip();
      this.titleAiLoading = true;
      try {
        // Falta de contexto e orientacao ao usuario, nao erro: aviso em vez de toast de erro
        if (!this.hasAiSuggestionContext()) {
          messagesNotifyHelper.warningNotify(this.$t('AI_MESSAGES.ContextRequiredTitle'), this.$t('AI_MESSAGES.ContextRequiredForTitle'));
          return;
        }
        const suggestion = await this.aiTitleSuggestionsRequest();
        if (suggestion && suggestion.trim()) {
          this.form.title.value = suggestion.trim();
          this.highlightField('title');
          messagesNotifyHelper.successNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.TitleSuggested'));
        } else {
          messagesNotifyHelper.warningNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.NoTitleReturned'));
        }
      } catch (error) {
        messagesNotifyHelper.errorNotifyUnlessHandled(this.$t('AI_MESSAGES.Title'), error, this.$t('AI_MESSAGES.CouldNotSuggestTitle'));
      } finally {
        this.titleAiLoading = false;
      }
    },
    async generateSummarySuggestion() {
      if (this.summaryAiLoading) return;
      this.hideActiveTooltip();
      this.summaryAiLoading = true;
      try {
        if (!this.hasAiSuggestionContext()) {
          messagesNotifyHelper.warningNotify(this.$t('AI_MESSAGES.ContextRequiredTitle'), this.$t('AI_MESSAGES.ContextRequiredForSummary'));
          return;
        }
        const suggestion = await this.aiSummarySuggestionsRequest();
        if (suggestion && suggestion.trim()) {
          this.form.summary.value = suggestion.trim();
          this.highlightField('summary');
          messagesNotifyHelper.successNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.SummarySuggested'));
        } else {
          messagesNotifyHelper.warningNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.NoSummaryReturned'));
        }
      } catch (error) {
        messagesNotifyHelper.errorNotifyUnlessHandled(this.$t('AI_MESSAGES.Title'), error, this.$t('AI_MESSAGES.CouldNotSuggestSummary'));
      } finally {
        this.summaryAiLoading = false;
      }
    },
    async suggestAllFields() {
      if (this.suggestingAll) return;
      this.hideActiveTooltip();
      this.suggestingAll = true;
      const title = this.$t('AI_MESSAGES.Title');
      // Campos que a IA nao conseguiu sugerir (sem resposta valida ou erro na requisicao)
      const skippedFields = [];
      let backendFailed = false;
      const fieldLabel = (key) => this.$t(`AI_MESSAGES.${key}`);
      // Executa uma etapa; erros do backend ja foram notificados pelo interceptor e interrompem as etapas seguintes
      const runStep = async (label, step) => {
        if (backendFailed) {
          skippedFields.push(fieldLabel(label));
          return;
        }
        try {
          const applied = await step();
          if (!applied) skippedFields.push(fieldLabel(label));
        } catch (error) {
          console.warn(`Erro ao sugerir ${label}:`, error?.message);
          skippedFields.push(fieldLabel(label));
          if (messagesNotifyHelper.isAlreadyNotified(error)) backendFailed = true;
        }
      };
      try {
        // O editor guarda o texto digitado no proprio componente; form.body.value so e sincronizado ao maximizar/salvar.
        // Cabecalho, assinatura e rodape nao contam como conteudo da noticia.
        if (!this.getBodyNewsText()) {
          messagesNotifyHelper.warningNotify(this.$t('AI_MESSAGES.ContextRequiredTitle'), this.$t('AI_MESSAGES.BodyRequiredForSuggestions'));
          return;
        }

        await runStep('Field_Summary', async () => {
          const summarySuggestion = await this.aiSummarySuggestionsRequest();
          if (!summarySuggestion || !summarySuggestion.trim()) return false;
          this.form.summary.value = summarySuggestion.trim();
          this.highlightField('summary');
          return true;
        });

        await runStep('Field_Title', async () => {
          const titleSuggestion = await this.aiTitleSuggestionsRequest();
          if (!titleSuggestion || !titleSuggestion.trim()) return false;
          this.form.title.value = titleSuggestion.trim();
          this.highlightField('title');
          return true;
        });

        await runStep('Field_Hat', async () => {
          const hatSuggestion = await this.aiHatSuggestionsRequest();
          if (!Array.isArray(hatSuggestion)) return false;
          const newHats = hatSuggestion.filter(item => this.isValidShortAiSuggestion(item)).map(item => ({id: null, name: item.trim(), aiGenerated: true}));
          const existingHatNames = new Set(this.form.hat.value.map(hat => hat.name.toLowerCase()));
          const filteredNewHats = newHats.filter(newHat => !existingHatNames.has(newHat.name.toLowerCase()));
          if (filteredNewHats.length === 0) return false;
          this.form.hat.value = this.form.hat.value.concat(filteredNewHats);
          this.highlightField('hat');
          return true;
        });

        await runStep('Field_Tags', async () => {
          const tagsSuggestion = await this.aiTagsSuggestionsRequest();
          if (!Array.isArray(tagsSuggestion)) return false;
          const newTags = tagsSuggestion.filter(item => this.isValidShortAiSuggestion(item)).map(item => ({id: null, name: item.trim(), aiGenerated: true}));
          const existingTagNames = new Set(this.form.tags.value.map(tag => tag.hasOwnProperty('name') ? tag.name.toLowerCase() : tag.toLowerCase()));
          const filteredNewTags = newTags.filter(newTag => !existingTagNames.has(newTag.name.toLowerCase()));
          if (filteredNewTags.length === 0) return false;
          this.form.tags.value = this.form.tags.value.concat(filteredNewTags);
          this.highlightField('tags');
          return true;
        });

        if (skippedFields.length === 0) {
          messagesNotifyHelper.successNotify(title, this.$t('AI_MESSAGES.AllSuggested'));
        } else if (skippedFields.length === 4) {
          // Se o backend falhou, o interceptor ja exibiu o erro (ex.: IA desabilitada); evita um segundo aviso
          if (!backendFailed) {
            messagesNotifyHelper.warningNotify(title, this.$t('AI_MESSAGES.NoSuggestions'));
          }
        } else {
          messagesNotifyHelper.warningNotify(title, this.$t('AI_MESSAGES.SuggestionsPartial', { fields: skippedFields.join(', ') }));
        }
      } catch (error) {
        messagesNotifyHelper.errorNotifyUnlessHandled(title, error, this.$t('AI_MESSAGES.CouldNotSuggestAll'));
      } finally {
        this.suggestingAll = false;
      }
    },
    async improveContent() {
      if (this.contentAiLoading) return;
      this.hideActiveTooltip();
      this.contentAiLoading = true;
      try {
        const html = this.getCurrentBodyHtml();
        if (!html) {
          throw new Error(this.$t('AI_MESSAGES.BodyRequiredForImprove'));
        }
        const improvementPrompt = 'Melhore e aprimore este texto, corrigindo erros de gramática e melhorando a clareza mantendo o significado original.';
        const improvedHtml = await this.aiEditBodyRequest({ html: html, prompt: improvementPrompt });
        if (improvedHtml && improvedHtml.trim()) {
          this.form.body.value = improvedHtml;
          if (this.$refs[`${this.instance}-send-news-editor-form`]) {
            this.$refs[`${this.instance}-send-news-editor-form`].body = improvedHtml;
          }
          if (this.$refs[`${this.instance}-send-news-editor-modal`]) {
            this.$refs[`${this.instance}-send-news-editor-modal`].body = improvedHtml;
          }
          messagesNotifyHelper.successNotify(this.$t('AI_MESSAGES.Title'), this.$t('AI_MESSAGES.BodyImproved'));
        } else {
          throw new Error(this.$t('AI_MESSAGES.ImproveBodyEmpty'));
        }
      } catch (error) {
        messagesNotifyHelper.errorNotifyUnlessHandled(this.$t('AI_MESSAGES.Title'), error, this.$t('AI_MESSAGES.CouldNotImproveBody'));
      } finally {
        this.contentAiLoading = false;
      }
    },
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
    "b-modal": VBModal,
  },
  components: {
    SendNewsSelectDuration,
    SendNewsEditor,
    AiAssistDrawer,
    AiIcon,
    Cleave,
    // BCalendar,
    ImageLibraryList,
    BOverlay,
    BImg,
    /* eslint-disable */
    BPopover,
    NewsActionButton,
    NwScheduleModal,
    ListFlashes,
    // AppCollapse,
    // AppCollapseItem,
    BListGroup,
    BListGroupItem,
    BForm,
    BFormInput,
    BCard,
    // BCardText,
    BCardBody,
    BCol,
    BRow,
    BFormTextarea,
    BBadge,
    vSelect,
    /* eslint-disable */
    BFormGroup,
    /* eslint-disable */
    BFormCheckbox,
    /* eslint-disable */
    BFormFile,
    BButtonGroup,
    BButton,
    BModal,
    BFormCheckboxGroup,
    BSpinner,
    // SidebarPlacementNews,
    // SidebarContentNews,
    // SendImageLibrary,
    VuePerfectScrollbar,
    flatPickr,
    AppCollapse,
    AppCollapseItem,
  },
  setup() {
    onBeforeUnmount(() => {
      if (
          self.form._id.value &&
          !self.submitData &&
          !self.isDraft(self.form.event_status.value)
      ) {
        const params = new URLSearchParams();
        params.append("_id", self.form._id.value);
        params.append("leavingPageWhileEditing", true);
        newsService.updateStatusEditing(params).then(() => {
          self.$emit("updated-status-editing", self.newsID);
        });
      }
    });
  },
};
</script>

<style scoped>
.ai-icon-btn {
  color: inherit !important;
}

.ai-highlight {
  background-color: #fffacd !important;
  animation: highlight-fade 3s ease-out forwards;
}

@keyframes highlight-fade {
  0% {
    background-color: #fffacd;
  }
  100% {
    background-color: transparent;
  }
}

.ai-highlight-textarea {
  background-color: #fffacd !important;
  animation: highlight-fade 3s ease-out forwards;
}

.dark-layout .ai-highlight,
.dark-layout .ai-highlight-textarea {
  background-color: rgba(255, 250, 205, 0.3) !important;
}
</style>
